// 包含常量的文件
export const CATEGORY = [
  {
    categoryId: 1,
    categoryName: '文化艺术'
  },
  {
    categoryId: 2,
    categoryName: '动物植物'
  },
  {
    categoryId: 3,
    categoryName: '生活教育'
  },
  {
    categoryId: 4,
    categoryName: '工业医疗'
  },
  {
    categoryId: 5,
    categoryName: '游戏电子'
  },
  {
    categoryId: 6,
    categoryName: '其他'
  }
]
export const MODEL_PAGE_SIZE = 10
export const FEEDBACK_PAGE_SIZE = 10
export const SUCC_CODE = 0 // 成功
export const MODEL_ALLEGEDCOPY = 1000040 // 模型涉嫌侵权
export const ERR_TOKEN_CODE = 4 // 身份过期
export const NOT_HAVE_AUTH = 520 // 没有权限
export const API_NOT_DATA = 517 // 后端异常处理
export const OLD_PASSWORD_ERR = 11 // 旧密码错误
export const ERR_USER = 5 // 身份错误
export const APP_NOT_EXIST = 3 // app id not exist
export const OVER_TIME = 19
export const OVER_NUM = 539 // 超过限制个数
export const BANNER_ERROR_POSITION = 1000102 // 广告位已经配置资源位
// 接口 鉴权
export const AUTH_NAME = {
  // 管理后台-用户列表、用户详情等，涉及联系方式新增权限管理
  userSensitive: {
    api: 'user_sensitive_info'
  },
  // F038 模型库
  f038Models: {
    stemModelList: '/api/cxy/manager/v3/stem/stemModelList',
    stemModelDetail: '/api/cxy/manager/v3/stem/stemModelDetail',
    stemModelSave: '/api/cxy/manager/v3/stem/stemModelSave',
    stemModelEdit: '/api/cxy/manager/v3/stem/stemModelEdit',
    stemModelUpdateCategory: '/api/cxy/manager/v3/stem/stemModelChangeCategory',
    stemModelDelete: '/api/cxy/manager/v3/stem/stemModelDelete',
    stemModelRefresh: '/api/cxy/manager/v3/stem/stemModelRefresh',
    albumList: '/api/cxy/manager/v3/stem/thematic/list',
    albumSaveOrUpdate: '/api/cxy/manager/v3/stem/thematic/saveOrUpdate',
    albumDelete: '/api/cxy/manager/v3/stem/thematic/delete',
    albumUpdateStatus: '/api/cxy/manager/v3/stem/thematic/offOrOn',
    albumChangeRank: '/api/cxy/manager/v3/stem/thematic/changeRank',
    albumAddModel: '/api/cxy/manager/v3/stem/thematic/batchImportModel',
    albumRemoveModel: '/api/cxy/manager/v3/stem/thematic/removeModel',
    albumModelList: '/api/cxy/manager/v3/stem/thematic/modelList',
    tagList: '/api/cxy/manager/v3/stem/tag/list',
    tagAdd: '/api/cxy/manager/v3/stem/tag/saveOrUpdate',
    tagChangeRank: '/api/cxy/manager/v3/stem/tag/changeRank',
    tagDelete: '/api/cxy/manager/v3/stem/tag/delete',
    tagUpdateStatus: '/api/cxy/manager/v3/stem/tag/offOrOn',
    tagAddModel: '/api/cxy/manager/v3/stem/tag/batchAddModel',
    tagModelList: '/api/cxy/manager/v3/stem/tag/modelList',
    tagRemoveModel: '/api/cxy/manager/v3/stem/tag/removeModel',
    helpCenterList: '/api/cxy/manager/v3/stem/help/list',
    helpCenterDetail: '/api/cxy/manager/v3/stem/help/detail',
    helpCenterUpdate: '/api/cxy/manager/v3/stem/help/put',
    helpCenterRank: '/api/cxy/manager/v3/stem/help/updateRank',
    helpCenterStatus: '/api/cxy/manager/v3/stem/help/updateStatus',
    videoTutorialList: '/api/cxy/manager/v3/stem/video/list',
    videoTutorialUpdate: '/api/cxy/manager/v3/stem/video/put',
    videoTutorialDetail: '/api/cxy/manager/v3/stem/video/detail',
    videoTutorialRank: '/api/cxy/manager/v3/stem/video/updateRank',
    videoTutorialStatus: '/api/cxy/manager/v3/stem/video/updateStatus',
    creativityTemplateList: '/api/cxy/manager/v3/stem/creativity/templateList',
    creativityTemplateSaveOrUpdate:
      '/api/cxy/manager/v3/stem/creativity/templateSaveOrUpdate',
    creativityTemplateDelete:
      '/api/cxy/manager/v3/stem/creativity/templateDelete',
    creativityTemplateUploadPictures:
      '/api/cxy/manager/v3/stem/creativity/templateUploadPictures',
    creativityTemplateDetail:
      '/api/cxy/manager/v3/stem/creativity/templateDetail',
    creativityTemplatePictureChangeRank:
      '/api/cxy/manager/v3/stem/creativity/templatePictureChangeRank',
    creativityTemplatePictureDelete:
      '/api/cxy/manager/v3/stem/creativity/templatePictureDelete',
    creativityEntryList: '/api/cxy/manager/v3/stem/creativity/entryList',
    creativityEntrySaveOrUpdate:
      '/api/cxy/manager/v3/stem/creativity/entrySaveOrUpdate',
    creativityEntryDelete: '/api/cxy/manager/v3/stem/creativity/entryDelete',
    creativityEntryOffOrOn: '/api/cxy/manager/v3/stem/creativity/entryOffOrOn',
    courseFolderList: '/api/cxy/manager/v3/stem/courseFolder/list',
    courseFolderSaveOrUpdate:
      '/api/cxy/manager/v3/stem/courseFolder/saveOrUpdate',
    courseFolderDelete: '/api/cxy/manager/v3/stem/courseFolder/delete',
    courseFolderOffOrOn: '/api/cxy/manager/v3/stem/courseFolder/offOrOn',
    courseFolderChangeRank: '/api/cxy/manager/v3/stem/courseFolder/changeRank',
    courseFolderResourceSave:
      '/api/cxy/manager/v3/stem/courseFolder/resource/batchSave',
    courseFolderResourceList:
      '/api/cxy/manager/v3/stem/courseFolder/resource/list',
    courseFolderResourceDelete:
      '/api/cxy/manager/v3/stem/courseFolder/resource/delete',
    courseFolderResourceChangeRank:
      '/api/cxy/manager/v3/stem/courseFolder/resource/changeRank'
  },
  // 现金激励
  cashIncentives: {
    // 模型获得的积分
    modelPoints: '/api/cxy/manager/v3/model/modelPoints',
    // 模型是否有扣除积分
    modelPointsRecord: '/api/cxy/manager/v3/model/modelPointsRecord',
    // ------ 模型池 ------
    // 模型列表
    modelsList: '/api/rest/lottery/cashPlan/models/list',
    // 预备池-黑名单-新增用户
    addBlackUsers: '/api/rest/lottery/cashPlan/models/addBlackUsers',
    // 预备池-黑名单-查询列表
    getBlackUsers: '/api/rest/lottery/cashPlan/models/getBlackUsers',
    // 预备池-黑名单-移除用户
    delBlackUsers: '/api/rest/lottery/cashPlan/models/delBlackUsers',
    // 准入条件配置
    alternativeConfig: '/api/rest/lottery/cashPlan/models/alternativeConfig',
    // 获取准入条件
    getAlternativeConfig:
      '/api/rest/lottery/cashPlan/models/getAlternativeConfig',
    // 批量剔除预备
    removeAlternative: '/api/rest/lottery/cashPlan/models/removeAlternative',
    // 批量确认精选
    addSelected: '/api/rest/lottery/cashPlan/models/addSelected',
    // 移出精选
    removedSelected: '/api/rest/lottery/cashPlan/models/removedSelected',
    // 添加精选模型
    importModelsSelected:
      '/api/rest/lottery/cashPlan/models/importModelsSelected',
    // 精选模式池-白名单列表
    getWhiteUsers: '/api/rest/lottery/cashPlan/models/getWhiteUsers',
    // 精选模式池-添加白名单
    addWhiteUsers: '/api/rest/lottery/cashPlan/models/addWhiteUsers',
    // 精选模式池-移除白名单
    delWhiteUsers: '/api/rest/lottery/cashPlan/models/delWhiteUsers',
    // 获取自动进入星标池时间配置
    getAutoSelectedDuration:
      '/api/rest/lottery/cashPlan/configs/getAutoSelectedDuration',
    // 更新自动进入星标池时间配置
    saveAutoSelectedDuration:
      '/api/rest/lottery/cashPlan/configs/saveAutoSelectedDuration',
    // ------ 创作者池 ------
    // 作者列表
    creatorsList: '/api/rest/lottery/cashPlan/creators/list',
    // 添加可转换名单
    addApprovedUsers: '/api/rest/lottery/cashPlan/creators/addApprovedUsers',
    // 移出可转换名单
    removeCreators: '/api/rest/lottery/cashPlan/creators/removeCreators',
    // 审核通过
    creatorsApproved: '/api/rest/lottery/cashPlan/creators/approved',
    // 审核不通过
    creatorsRejected: '/api/rest/lottery/cashPlan/creators/rejected',
    // 总获星标积分
    creatorsCashPointsStat:
      '/api/rest/lottery/cashPlan/creators/cashPointsStat',
    // 创作者池- 用户违规处理记录
    handlePunishLog: '/api/rest/lottery/cashPlan/creators/handlePunishLog',
    // 创作者池- 用户违规处罚
    handlePunish: '/api/rest/lottery/cashPlan/creators/handlePunish',
    // 查看推荐用户
    listRecommend: '/api/rest/lottery/cashPlan/creators/listRecommend',
    // 风险处理
    handleRecommendRisk:
      '/api/rest/lottery/cashPlan/creators/handleRecommendRisk',
    // ------ 转换订单 ------
    // 获取订单列表
    getPointsTransferRecords:
      '/api/rest/lottery/cashPlan/transfer/getPointsTransferRecords',
    // 订单拦截驳回
    rejectPointsTransferRecord:
      '/api/rest/lottery/cashPlan/transfer/rejectPointsTransferRecord'
  },
  // DTC
  dtc: {
    // 券码发放用户列表
    stockoutDelayedUsers: '/api/cxy/manager/v3/dtc/stockoutDelayedUsers'
  },
  shopManage: {
    // 更新商品排序
    productSort: '/api/cxy/crealitydtc/admin/product/mall/sort',
    // 后台DTC商品分页查询
    productPage: '/api/cxy/crealitydtc/admin/product/page',
    // 查询商品类型枚举
    productTypeList: '/api/cxy/crealitydtc/admin/product/productType/list',
    // 将 DTC 商品导入商城商品池
    productImport: '/api/cxy/crealitydtc/admin/product/import',
    // 后台商品详情
    productDetail: '/api/cxy/crealitydtc/admin/product/detail',
    // 批量导入商城商品
    productBatchImport: '/api/cxy/crealitydtc/admin/product/batchImport',
    // DTC 商品池统计
    dtcSummary: '/api/cxy/crealitydtc/admin/product/dtc/summary',
    // 商城商品池统计
    mallSummary: '/api/cxy/crealitydtc/admin/product/mall/summary',
    // 商城商品池分页查询
    mallPage: '/api/cxy/crealitydtc/admin/product/mall/page',
    // 商城商品详情
    mallDetail: '/api/cxy/crealitydtc/admin/product/mall/detail',
    // 保存商城商品草稿
    mallSaveDraft: '/api/cxy/crealitydtc/admin/product/mall/saveDraft',
    // 发布商城商品到 App
    mallPublish: '/api/cxy/crealitydtc/admin/product/mall/publish',
    // 取消发布商城商品
    mallUnpublish: '/api/cxy/crealitydtc/admin/product/mall/unpublish',
    // 查看 DTC 源商品更新差异
    mallUpdateDiff: '/api/cxy/crealitydtc/admin/product/mall/updateDiff',
    // 暂不更新
    mallIgnoreUpdate: '/api/cxy/crealitydtc/admin/product/mall/ignoreUpdate',
    // 应用选中更新
    mallApplySelectedUpdate:
      '/api/cxy/crealitydtc/admin/product/mall/applySelectedUpdate',
    // 订单分页查询
    orderPage: '/api/cxy/crealitydtc/admin/dtc/order/page',
    // 订单详情
    orderDetail: '/api/cxy/crealitydtc/admin/dtc/order/detail',
    // 分类排序
    categorySort: '/api/cxy/crealitydtc/admin/dtc/navigation/sort',
    // 新增分类
    categoryAdd: '/api/cxy/crealitydtc/admin/dtc/navigation/create',
    categoryUpload: '/api/cxy/crealitydtc/admin/dtc/navigation/update',
    // 删除分类
    categoryDel: '/api/cxy/crealitydtc/admin/dtc/navigation/delete',
    // 导航菜单树
    navigationTree: '/api/cxy/crealitydtc/admin/dtc/navigation/tree',
    // 商品政策
    productPolicy: '/api/cxy/crealitydtc/admin/product/policy'
  },
  // 优惠券包管理（国内站）
  couponPackageManage: {
    // 优惠券包列表
    list: '/api/cxy/manager/v3/dtc/dtcBundleList',
    // 优惠券包编辑
    put: '/api/cxy/manager/v3/dtc/dtcBundlePut',
    // 优惠券包更新状态
    up: '/api/cxy/manager/v3/dtc/dtcBundleUp',
    // 券码导入
    promoCodeImport: '/api/cxy/manager/v3/dtc/promoCodeImport',
    // 优惠券包详情
    detail: '/api/cxy/manager/v3/dtc/dtcBundleDetail',
    // 券码使用详情
    promoCodeList: '/api/cxy/manager/v3/dtc/promoCodeList',
    // DTC模板列表
    dtcTemplateList: '/api/cxy/manager/v3/dtc/dtcTemplateList'
  },
  // 模型招募
  modelRecruit: {
    // 定价池列表
    pricingPool: '/api/cxy/operational_support/model_recruitment/pricing_pool',
    // 定价标签列表
    pricingTagList:
      '/api/cxy/operational_support/model_recruitment/pricing_tag_list',
    // 设置定价标签列表
    pricingTagModify:
      '/api/cxy/operational_support/model_recruitment/pricing_tag',
    // 公式设置列表
    pricingSettingList:
      '/api/cxy/operational_support/model_recruitment/pricing_setting_list',
    // 设置公式列表
    pricingSettingModify:
      '/api/cxy/operational_support/model_recruitment/pricing_setting',
    // 模型定价
    pricing: '/api/cxy/operational_support/model_recruitment/pricing',
    // 建联池列表
    contactPool: '/api/cxy/operational_support/model_recruitment/contact_pool',
    // 批量移除建模师
    removeContactPool:
      '/api/cxy/operational_support/model_recruitment/remove_contact_pool',
    // 更新建模师信息
    updateContactPool:
      '/api/cxy/operational_support/model_recruitment/update_contact_pool',
    // 下架模型
    modelOffline: '/api/cxy/operational_support/model_recruitment/offline',
    // 批量新增建模师
    insertContactPool:
      '/api/cxy/operational_support/model_recruitment/insert_contact_pool',
    // 咨询单状态修改
    updateContactForm:
      '/api/cxy/operational_support/model_recruitment/update_contact_form',
    // 风险处理
    handleRecommendRisk:
      '/api/cxy/operational_support/model_recruitment/handle_recommend_risk',
    // 创想币明细
    modelRecruitEarnings:
      '/api/cxy/operational_support/model_recruitment/earnings',
    // 被删除的模型列表
    deletedModelList:
      '/api/cxy/operational_support/model_recruitment/deleted_model_list',
    // 活动上传模型数据统计
    modelDataStatistics:
      '/api/cxy/operational_support/model_recruitment/model_data_statistics'
  },
  // AI工具管理
  aiToolManage: {
    // 创建活动
    createActivity: '/api/rest/lottery/makenow/activity/createActivity',
    // 编辑活动
    modifyActivity: '/api/rest/lottery/makenow/activity/modifyActivity',
    // 活动列表
    activeList: '/api/rest/lottery/makenow/activity/queryActivity',
    // 活动操作
    changeStatus: '/api/rest/lottery/makenow/activity/changeStatus',
    // 新增/编辑页面配置
    modifyPageConfig:
      '/api/rest/lottery/makenow/activity/upsertTriggerWaitlistPage',
    // 查询页面配置列表
    pageConfigList:
      '/api/rest/lottery/makenow/activity/queryTriggerWaitlistPage',
    // 删除页面配置
    delPageConfig:
      '/api/rest/lottery/makenow/activity/deleteTriggerWaitlistPage',
    // 查看指定用户列表
    queryEligibilityPool:
      '/api/rest/lottery/makenow/activity/queryEligibilityPool',
    // 我的风格列表(灵感管理)
    myStyles: '/api/v1/ai/tasks/styles',
    // 官方创作权限-列表
    officialCreatorPermissionList: '/api/v1/official/creator-permission/list',
    // 官方创作权限-添加
    officialCreatorPermissionAdd: '/api/v1/official/creator-permission/add',
    // 官方创作权限-删除
    officialCreatorPermissionDelete:
      '/api/v1/official/creator-permission/delete',
    // 官方创作权限-更新
    officialCreatorPermissionUpdate:
      '/api/v1/official/creator-permission/update',
    // 官方灵感管理-列表
    officialStyleMaterialList: '/api/v1/official/style-material/list',
    officialStyleList: '/api/v1/official/style/list',
    // 官方灵感管理-发布
    officialStylePublish: '/api/v1/official/style/publish',
    // 官方灵感管理-下线
    officialStyleOffline: '/api/v1/official/style/delete',
    // 官方灵感管理-编辑
    officialStyleEdit: '/api/v1/official/style/edit',
    // 灵感审核状态更新
    updateInspirationStatus: '/api/v1/ai/tasks/updateInspirationStatus',
    // 大模型厂商列表
    vendorListByType: '/api/v1/vendor/listByType',
    // 更新灵感大模型
    updateStyleModel: '/api/v1/official/style/updateModel'
  },
  // 过滤userid
  common: {
    validUsers: '/api/cxy/manager/v2/user/validUsers',
    // 获取jwttoken
    getJwtToken: '/api/cxy/manager/v2/common/getJwtToken',
    // 获取用户最近一次行为时间
    userLastActive: '/api/rest/lottery/userData/person/userLastActive'
  },
  // 首页相关接口
  indexPage: {
    // 首页部分 golang 提供的仪表盘数据
    // indexDashboardData: '/api/cxy/manager/v2/common/dashboard/count',
    indexDashboardData: '/api/rest/lottery/dashboard/count',
    noticeDataForPrintOrder:
      '/api/rest/lottery/mangerPrintOrder/noticeDataForPrintOrder',
    noticeDataForProvider:
      '/api/rest/lottery/tServiceProvider/noticeDataForProvider',
    // 操作记录聚合统计
    operateAggregateCount: '/api/cxy/manager/v2/common/operateAggregateCount',
    // 3d照片分销订单数据
    distributionData: '/api/rest/lottery/photo3dOrder/getDistributionData'
  },
  modelManage: {
    // 模型设置版本展示
    opDisplayVersions: '/api/cxy/manager/v3/model/opDisplayVersions',
    // createModelGroup: '/api/cxy/manager/model/modelGroupCreate', // 模型组创建
    createModelGroup: '/api/cxy/manager/v3/model/modelGroupCreate',
    // modelGroupDetail: '/api/cxy/manager/model/modelGroupInfo', // 模型组详情
    modelGroupDetail: '/api/cxy/manager/v3/model/modelGroupInfo',
    // modelGroupList: '/api/cxy/manager/v2/model/modelGroupList', // 模型组列表
    modelGroupList: '/api/cxy/manager/v3/model/modelGroupList', // 模型组列表
    modelGroupWaitList: '/api/cxy/manager/v3/model/modelGroupPendList', // 模型组列表
    // modelGroupEdit: '/api/cxy/manager/model/modelGroupEdit', // 模型组信息更改
    modelGroupEdit: '/api/cxy/manager/v3/model/modelGroupEdit', // 模型组信息更改

    // 模型组状态更改
    modelGroupUpdate: '/api/cxy/manager/v3/model/modelGroupStatus',
    // 模型组推荐
    modelRecommend: '/api/cxy/manager/v3/model/modelGroupRecommend',
    // modelList: '/api/cxy/manager/model/modelList', // 模型组里模型列表
    modelList: '/api/cxy/manager/v3/model/fileList', // 模型组里模型列表
    // modelEdit: '/api/cxy/manager/model/modelEdit', // 模型编辑 修改模型名称
    modelEdit: '/api/cxy/manager/v3/model/fileEdit', // 模型编辑 修改模型名称
    modelDel: '/api/cxy/manager/v3/model/fileDel', // 模型编辑 修改模型名称
    modelAdd: '/api/cxy/manager/v3/model/fileAdd', // 模型新增
    // editCate: '/api/cxy/manager/model/modelGroupUpdateCategory', // 模型组分类更改
    editCate: '/api/cxy/manager/v3/model/modelGroupCategory', // 模型组分类更改
    // changeRank: '/api/cxy/manager/model/modelGroupRecommendRank', // 编辑排序
    changeRank: '/api/cxy/manager/v3/model/modelGroupRecommend', // 编辑排序
    // changeGrade: '/api/cxy/manager/model/modelGroupUpdateGrade', // 修改等级
    // changeGrade: '/api/cxy/manager/v2/model/setGrade', // 修改等级
    changeGrade: '/api/cxy/manager/v3/model/modelGroupGrade', // 修改等级
    // changeTags: '/api/cxy/manager/v2/model/addTag' // 模型组打标签
    changeTags: '/api/cxy/manager/v3/model/modelGroupTag', // 模型组打标签
    download: '/api/cxy/manager/v3/model/fileDownload', // 模型下载
    modelOrderId: '/api/cxy/manager/v3/model/modelOrderList', // 模型订单
    modelOrderDetail: '/api/cxy/manager/v3/model/modelOrderDetail', // 模型订单详情
    editPrice: '/api/cxy/manager/v3/model/updatePrice', // 模型价格修改
    // 拍照建模列表
    photoModelList: '/api/rest/lottery/photomodel/photoModelMangerList',
    //  模型订单统计
    modelOrderStatistic: '/api/cxy/manager/v3/model/modelOrderStatistic',
    // 模型订单退款
    modelOrderRefund: '/api/cxy/manager/v3/model/modelOrderRefund',
    // 模型组推荐 --- 上面相同接口沟通是没用了 等有空 要优化处理
    reqModelRecommend: '/api/cxy/manager/v3/model/recommend',
    // 查看重复模型列表
    modelRepeatedList: '/api/cxy/manager/v3/model/repeatedList',
    // 重复模型批量处理
    repeatHandle: '/api/cxy/manager/v3/model/repeatHandle',
    // 模型组推荐列表
    modelRecommendList: '/api/cxy/manager/v3/model/recommendList',
    // 模型组推荐排序
    modelRecommendRank: '/api/cxy/manager/v3/model/recommendRank',
    // 模型组推荐取消
    modelUnRecommend: '/api/cxy/manager/v3/model/unRecommend',
    // 模型申诉列表
    appealList: '/api/cxy/manager/v3/model/appealList',
    // 模型申诉处理
    appealHandle: '/api/cxy/manager/v3/model/appealHandle',
    // 模型申诉不处理
    appealHandleNo: '/api/cxy/manager/v3/model/appealHandleNo',
    // 添加/移除到vip模型专区
    addModelVip: '/api/cxy/manager/v3/model/modelVip',
    // 添加/移出最佳建模师专属模型
    opBmySpecial: '/api/cxy/manager/v3/model/opBmySpecial',
    // 模型组VIP专区修改排序
    rankModelVip: '/api/cxy/manager/v3/model/rankVip',
    // vip模型
    modelBatchVip: '/api/cxy/manager/v3/model/modelBatchVip',
    // VIP模型编辑是否商用
    editVipCommercial: '/api/cxy/manager/v3/model/editVipCommercial',
    // 模型活动列表
    promoModelList: '/api/cxy/manager/v2/promo/modelList',
    // 模型组加上/取消独家标识
    modelOpExclusive: '/api/cxy/manager/v3/model/opExclusive',
    // 独家模型排序
    rankModelExclusive: '/api/cxy/manager/v3/model/rankExclusive',
    // 打印文件列表
    printFiles: '/api/cxy/manager/v3/model/printFiles',
    // 修改模型18禁级别
    opMaturityRating: '/api/cxy/manager/v3/model/opMaturityRating',
    /** ** 多色模型模块 */
    // 多色模型排序
    rankMultiColor: '/api/cxy/manager/v3/model/rankMulti',
    // 模型组加上/取消多色标识
    opMultiColor: '/api/cxy/manager/v3/model/opMulti',
    /** ** 多色模型模块 */
    // 多语言模型列表
    deeplModelList: '/api/cxy/manager/v2/deepl/mainTaskList',
    // 查看翻译使用详情
    deeplDetail: '/api/cxy/manager/v2/deepl/detail',
    // 智能翻译导入任务
    deeplImportTask: '/api/cxy/manager/v2/deepl/importTask',
    // 修改每日限额
    modifyDailyLimit: '/api/cxy/manager/v2/deepl/modifyDailyLimit',
    // 失败任务重试
    failTaskRetry: '/api/cxy/manager/v2/deepl/failTaskRetry',
    // 查看当前月使用总金额
    viewUsedBanlance: '/api/cxy/manager/v2/deepl/viewUsedBanlance',
    // 修改任务权重
    deeplEditTaskRank: '/api/cxy/manager/v2/deepl/editTaskRank',
    // 删除任务
    deeplDelTask: '/api/cxy/manager/v2/deepl/delTask',
    // 翻译结果编辑
    deeplEditTranslateModel: '/api/cxy/manager/v2/deepl/editTranslateModel',
    // 翻译的子任务列表
    deeplSubTaskList: '/api/cxy/manager/v2/deepl/subTaskList',
    // 翻译关键词列表
    deeplListKeyword: '/api/cxy/manager/v2/deepl/listKeyword',
    // 新增翻译关键词
    deeplAddKeyword: '/api/cxy/manager/v2/deepl/addKeyword',
    // 删除翻译关键词
    deeplDelKeyword: '/api/cxy/manager/v2/deepl/delKeyword',
    // 模型文件3mf列表
    model3mfList: '/api/cxy/manager/v3/model/3mfList',
    // 模型3mf文件删除
    model3mfDelete: '/api/cxy/manager/v3/model/3mfDelete',
    // 模型3mf文件上下架
    model3mfUpdate: '/api/cxy/manager/v3/model/3mfUpdate',
    // 模型3mf文件详情
    model3mfDetail: '/api/cxy/manager/v3/model/3mfDetail',
    // 批量上下架
    model3mfUpdateBatch: '/api/cxy/manager/v3/model/3mfUpdateBatch',
    // 翻译账号列表
    deeplAccountList: '/api/cxy/manager/v2/deepl/accountList',
    // 翻译账号删除
    deeplAccountDel: '/api/cxy/manager/v2/deepl/accountDel',
    // 翻译账号使用
    deeplAccountUse: '/api/cxy/manager/v2/deepl/accountUse',
    // 翻译账号新增
    deeplAccountAdd: '/api/cxy/manager/v2/deepl/accountAdd',
    // 支持打印列表
    model3mfSupportPrintList: '/api/cxy/manager/v2/printer3mf/list',
    // 支持打印列表排序
    printer3mfChangeRank: '/api/cxy/manager/v2/printer3mf/changeRank',
    // 新增打印列表
    model3mfSupportPrintAdd: '/api/cxy/manager/v2/printer3mf/put',
    // 删除
    model3mfSupportPrintDelete: '/api/cxy/manager/v2/printer3mf/delete',
    // 模型转3mf列表
    to3mf: '/api/cxy/manager/v2/to3mf/list',
    // 模型转3mf打印机列表
    printerList: '/api/cxy/manager/v2/to3mf/printerList',
    // 创建模型转3mf任务
    createTo3mf: '/api/cxy/manager/v2/to3mf/create',
    // 模型转3mf任务列表
    listTo3mf: '/api/cxy/manager/v2/to3mf/list',
    // 转3mf任务重试
    retryTo3mf: '/api/cxy/manager/v2/to3mf/retry',
    // 转3mf任务删除
    delTo3mf: '/api/cxy/manager/v2/to3mf/delete',
    // 编辑转3mf任务权重
    rankTo3mf: '/api/cxy/manager/v2/to3mf/rank',
    // 3mf任务统计
    statiscTo3mf: '/api/cxy/manager/v2/to3mf/statisc',
    // 模型AI审核信息
    // modelAIReview: '/api/cxy/manager/v2/ai/modelReview',
    modelAIReview: '/api/cxy/manager/v3/model/machineReviewModeration',
    // 模型组机审列表
    machineAIReviewList: '/api/cxy/manager/v3/model/machineReviewList',
    // 模型组复审 状态修改
    machineReviewStatus: '/api/cxy/manager/v3/model/machineReviewStatus',
    // 机审设置
    machineReviewSet: '/api/cxy/manager/v3/model/machineReviewSet',
    // 机审设置详情
    machineReviewSetDetail: '/api/cxy/manager/v3/model/machineReviewSetDetail',
    // 获取机审模型详情
    machineReviewDetail: '/api/cxy/manager/v3/model/machineReviewDetail',
    // 模型文件加密减面重试
    fileEncryptRetry: '/api/cxy/manager/v3/model/fileEncryptRetry',
    // 3mf工厂打印信息(生成打印验证编号)
    factoryPrintInfo: '/api/cxy/manager/v3/model/3mfFactoryPrintInfo',
    // 后台打印配置打印验证
    printVerified: '/api/cxy/manager/v3/model/3mfPrintVerified',
    // 后台打印配置清理打印验证
    clearPrintVerified: '/api/cxy/manager/v3/model/3mfClearPrintVerified',
    // 模型标注标签&AI提取标签 列表
    modelAITagsList: '/api/rest/lottery/modelRec/mgt/modelTagsList',
    // 模型标注标签&AI提取标签 修改
    updateModelAITags: '/api/rest/lottery/modelRec/mgt/updateTags',
    // 模型新增批量审核通过和批量审核不通过接口
    batchModelAudit: '/api/cxy/manager/v3/model/batchModelGroupStatus',
    // 机审新增批量审核通过和批量审核不通过接口
    machineBatchModelAudit: '/api/cxy/manager/v3/model/batchMachineModelStatus',
    // 模型复杂度设置 查询
    modelComplexitySet: '/api/rest/lottery/cashPlan/models/getComplexityConf',
    // 模型复杂度设置 修改
    updateModelComplexity:
      '/api/rest/lottery/cashPlan/models/updateComplexityConf',
    // 恢复默认复杂度设置
    restoreDefaultComplexity:
      '/api/rest/lottery/cashPlan/models/defaultComplexityConf',
    // 复杂度详情
    complexityDetail: '/api/rest/lottery/cashPlan/model/complexityDetail'
  },
  // 共享模型
  shareModel: {
    // 模型共享列表
    shareModelList: '/api/cxy/manager/v2/partnerData/list',
    // 增加
    addModel: '/api/cxy/manager/v2/partnerData/create',
    // 更新
    changeModel: '/api/cxy/manager/v2/partnerData/update',
    deleteModel: '/api/cxy/manager/v2/partnerData/delete'
  },
  // 助力券相关
  boostManage: {
    // 助力管理列表
    boostManageList: '/api/cxy/manager/v2/boost/listAction',
    // 助力管理编辑
    boostManageEdit: '/api/cxy/manager/v2/boost/editAction',
    boostManageStatus: '/api/cxy/manager/v2/boost/statusAction',
    // 发放列表(券列表)
    boostPushList: '/api/cxy/manager/v2/boost/listBoost',
    // 设置助力券发放上限
    boostSetLimit: '/api/cxy/manager/v2/boost/setLimit',
    // 获取助力券上线详情
    boostGetLimit: '/api/cxy/manager/v2/boost/getLimit',
    // 助力券用户统计列表
    boostUserList: '/api/cxy/manager/v2/boost/listUserStatisc',
    // 助力券使用流水列表
    boostUsedList: '/api/cxy/manager/v2/boost/listUsedRecord',
    // 助力券拉黑用户
    bootsBlack: '/api/cxy/manager/v2/boost/black',
    // 手动发放
    adminPush: '/api/cxy/manager/v2/boost/manualGive',
    // 助力统计
    boostStatics: '/api/rest/lottery/biStatistics/boostStatistic'
  },
  // 模型标注管理
  modelGrade: {
    // 标注列表
    modelGradeList: '/api/cxy/manager/v2/modelMark/listTask',
    // 标注数据统计
    modelGradeData: '/api/cxy/manager/v2/modelMark/statisc',
    // 新增标注
    addModelGrade: '/api/cxy/manager/v2/modelMark/createTask',
    // 标注完成列表
    modelGradeSuccessList: '/api/cxy/manager/v2/modelMark/listDone',
    // 收回
    modelGradeNum: '/api/cxy/manager/v2/modelMark/recycle',
    // 剩余可分配数量
    lessModelNum: '/api/cxy/manager/v2/modelMark/remainCount',
    // 标注用户列表
    modelMarkList: '/api/cxy/manager/v2/modelMark/userList',
    // 标注用户移出
    delMarkUser: '/api/cxy/manager/v2/modelMark/userDel',
    // 验证任务创建
    modelVerifyCreateTask: '/api/cxy/manager/v2/modelVerify/createTask',
    // 剩余可分配数量
    modelVerifyRemainCount: '/api/cxy/manager/v2/modelVerify/remainCount',
    // 验证任务统计
    modelVerifyStatic: '/api/cxy/manager/v2/modelVerify/statisc',
    // 验证任务列表
    modelVerifyListTask: '/api/cxy/manager/v2/modelVerify/listTask',
    // 验证任务详情（已完成/待完成）列表
    modelVerifyListDetail: '/api/cxy/manager/v2/modelVerify/listDetail',
    // 未完成验证任务回收
    modelVerifyRecycle: '/api/cxy/manager/v2/modelVerify/recycle',
    // 标注用户编辑
    modelUserEdit: '/api/cxy/manager/v2/modelMark/userEdit',
    // 用户验证模型池列表
    userVerifyModelList:
      '/api/cxy/manager/v2/modelVerify/userVerifyPool/modelList',
    // 获取用户验证设置
    userVerifySettingDetail:
      '/api/cxy/manager/v2/modelVerify/userVerifyPool/settingDetail',
    // 更新用户验证设置
    userVerifySettingPut:
      '/api/cxy/manager/v2/modelVerify/userVerifyPool/settingPut',
    // 批量写入用户验证模型池
    userVerifyBatchInsert:
      '/api/cxy/manager/v2/modelVerify/userVerifyPool/batchInsert',
    // 待打印模型验证池 移除模型
    removeVerifyModel:
      '/api/cxy/manager/v2/modelVerify/userVerifyPool/batchRemove',
    // 用户验证模型池统计
    userVerifyStatistics:
      '/api/cxy/manager/v2/modelVerify/userVerifyPool/statistics'
  },
  manageAdmin: {
    // 管理员管理权限
    // search: '/api/manager/list', // 管理员搜索
    search: '/api/cxy/account/v2/manager/list', // 管理员搜索
    authList: '/api/cxy/account/v2/authgroup/list', // 权限组列表
    // add: '/api/manager/add', // 新建管理员
    add: '/api/cxy/account/v2/manager/add', // 新建管理员
    // enable: '/api/manager/enable', // 停用，启用
    enable: '/api/cxy/account/v2/manager/enable', // 停用，启用
    // config: '/api/manager/attachAuthGroups', // 配置
    config: '/api/cxy/account/v2/manager/attachAuthGroups', // 配置
    // delete: '/api/manager/delete' // 删除
    delete: '/api/cxy/account/v2/manager/delete' // 删除
  },
  authgroupManage: {
    // 权限组管理权限
    // search: '/api/authgroup/list', // 搜索
    search: '/api/cxy/account/v2/authgroup/list', // 搜索
    // getInfo: '/api/authgroup/queryById', // 根据id 获取该权限组详情
    getInfo: '/api/cxy/account/v2/authgroup/queryById', // 根据id 获取该权限组详情
    // dispose: '/api/authgroup/dispose', // 配置
    dispose: '/api/cxy/account/v2/authgroup/dispose', // 配置
    // add: '/api/authgroup/add', // 新增权限组
    add: '/api/cxy/account/v2/authgroup/add', // 新增权限组
    // delete: '/api/authgroup/delete' // 删除
    delete: '/api/cxy/account/v2/authgroup/delete' // 删除
  },
  feedbackManage: {
    // 意见反馈
    feedbackList: '/api/cxy/manager/v2/feedback/list', // 意见反馈列表
    feedbackRemark: '/api/cxy/manager/v2/feedback/remark', // 旧 意见反馈处理
    feedbackReport: '/api/cxy/manager/v2/feedback/logReply', // 新  意见反馈 回复
    // feedbackReport: '/api/cxy/manager/v2/feedback/reply' // 旧 意见反馈 回复
    logFileList: '/api/cxy/manager/v2/feedback/logFileList', // 日志详情列表
    logReplyList: '/api/cxy/manager/v2/feedback/logReplyList', // 意见反馈问题回复详情列表
    dealwith: '/api/cxy/manager/v2/feedback/dealwith', // 新的意见反馈处理 日志状态更新
    replyTmpDelete: '/api/cxy/manager/v2/feedback/replyTmpDelete', // 意见反馈模板删除
    replyTmpEdit: '/api/cxy/manager/v2/feedback/replyTmpEdit', // 意见反馈模板新增、编辑
    replyTmpList: '/api/cxy/manager/v2/feedback/replyTmpList', // 意见反馈模板列表
    feedbackCancel: '/api/cxy/manager/v2/feedback/cancel', // 意见反馈撤回
    problemTypeList: '/api/cxy/manager/v2/feedback/problemTypeList', // 意见反馈类型列表
    classUpSort: '/api/cxy/manager/v2/workorder/classUpSort', // 工单分类更新排序
    problemTypePut: '/api/cxy/manager/v2/feedback/problemTypePut', // 意见反馈类型编辑
    problemTypeUpStatus: '/api/cxy/manager/v2/feedback/problemTypeUpStatus', // 意见反馈类型更新
    problemTypeIsShow: '/api/cxy/manager/v2/feedback/problemTypeIsShow', // 意见反馈类型前台是否显示
    problemClassAdd: '/api/cxy/manager/v2/workorder/classAdd', // 工单分类新增
    problemClassEdit: '/api/cxy/manager/v2/workorder/classEdit', // 工单分类编辑
    problemClassList: '/api/cxy/manager/v2/workorder/classList', // 工单分类列表
    problemClassUpStatus: '/api/cxy/manager/v2/workorder/classUpStatus', // 工单分类更新状态
    problemClassDel: '/api/cxy/manager/v2/workorder/classDel', // 工单分类删除
    workorderList: '/api/cxy/manager/v2/workorder/list', // 工单列表
    workorderDetail: '/api/cxy/manager/v2/workorder/detail', // 工单详情
    workorderReplyList: '/api/cxy/manager/v2/workorder/replyList', // 工单回复列表
    workorderisDeal: '/api/cxy/manager/v2/workorder/isDeal', // 工单标记解决
    workorderReply: '/api/cxy/manager/v2/workorder/reply', // 工单回复
    workorderFileList: '/api/cxy/manager/v2/workorder/logFileList', // 工单日志文件列表
    workorderDealwith: '/api/cxy/manager/v2/workorder/dealwith', // 工单处理
    workorderReplyCancel: '/api/cxy/manager/v2/workorder/replyCancel' // 工单回复撤销
  },
  userAdmin: {
    // search: '/api/cxy/manager/user/userList', // 搜索
    search: '/api/cxy/manager/v2/user/userList',
    // detail: '/api/cxy/manager/user/userInfo', // 用户详情
    detail: '/api/cxy/manager/v2/user/getOtherInfo',
    ban: '/api/cxy/manager/user/userOprating', // 禁言/ 封号, 推荐
    banV2: '/api/cxy/manager/v2/user/userOprating', // 禁言/ 封号, 推荐v2 暂时只迁移禁言跟封号相关
    addUser: '/api/cxy/manager/v2/user/robotCreate', // 新增
    editUser: '/api/cxy/manager/v2/user/robotEdit', // 编辑
    taskList: '/api/cxy/manager/v2/robot/taskList', // 任务列表
    taskPut: '/api/cxy/manager/v2/robot/taskPut', // 新建任务
    taskStatus: '/api/cxy/manager/v2/robot/taskStatus', // 任务停、启用
    // modifyBind: '/api/cxy/account/v2/manager/modifyBind', // 修改手机号
    modifyBind: '/api/cxy/manager/v2/user/modifyBind', // 修改手机号
    exceptionalUser: '/api/cxy/manager/v2/user/receiveUserList', // 打赏用户
    receiveCreate: '/api/cxy/manager/v2/user/receiveCreate', // 新增打赏用户
    receiveUpStatus: '/api/cxy/manager/v2/user/receiveUpStatus', // 更新打赏用户状态
    userMemberList: '/api/cxy/manager/v2/user/userMemberList', // 付费用户
    payUserMemberList: '/api/cxy/manager/v2/user/payUserMemberList', // 付费vip用户
    authUserBecome: '/api/cxy/manager/v2/user/authUserBecome', // 成为作者
    authUserUpdate: '/api/cxy/manager/v2/user/authUserUpdate', // 更新作者
    authUserList: '/api/cxy/manager/v2/user/authUserList', // 作者列表
    addWhitelistAuth: '/api/cxy/manager/v2/user/addWhitelistAuth', // 配置权限白名单
    authWhitelist: '/api/cxy/manager/v2/user/authWhitelist', // 权限白名单列表
    upWhitelistUser: '/api/cxy/manager/v2/user/upWhitelistUser', // 白名单权限用户更新状态
    deleteWhiteUser: '/api/cxy/manager/v2/user/deleteWhiteUser', // 白名单权限用户删除
    applicationUserList: '/api/cxy/manager/v2/coupon/applicationUserList', // 申请用户列表
    applicationRemove: '/api/cxy/manager/v2/coupon/applicationRemove', // 商家申请移除

    // 免手续费模块
    freeServiceAdd: '/api/cxy/manager/v2/withdrawal/freeServiceAdd', // 添加免手续费用户
    freeServiceDel: '/api/cxy/manager/v2/withdrawal/freeServiceDel', // 移除免手续费用户
    freeServiceList: '/api/cxy/manager/v2/withdrawal/freeServiceList', // 免手续费用户列表
    freeServiceAdds: '/api/cxy/manager/v2/withdrawal/freeServiceAdds', // 批量添加提现免手续费用户
    freeServiceUpdate: '/api/cxy/manager/v2/withdrawal/freeServiceUpdate', // 批量更新提现免手续费用户时间

    // 审核白名单
    auditWhiteListAdd: '/api/cxy/manager/v2/user/passUserAdd', // 添加免手续费用户
    auditWhiteListDel: '/api/cxy/manager/v2/user/passUserDel', // 移除免手续费用户
    auditWhiteList: '/api/cxy/manager/v2/user/passUserList', // 免手续费用户列表
    auditWhiteListUpDateStatus: '/api/cxy/manager/v2/user/passUserUpdateStatus',
    // 免手续费用户列表
    auditWhiteListEdit: '/api/cxy/manager/v2/user/passUserUpdate',
    // 盗用模型用户添加
    stealUserAdd: '/api/cxy/manager/v2/user/stealUserAdd',
    // 盗用模型用户移出
    stealUserDel: '/api/cxy/manager/v2/user/stealUserDel',
    // 盗用模型用户列表
    stealUserList: '/api/cxy/manager/v2/user/stealUserList',
    // 禁止用户上传模型
    forbidUploadModel: '/api/cxy/manager/v3/model/forbidUploadModel',
    // 取消禁止用户上传模型
    unForbidUploadModel: '/api/cxy/manager/v3/model/unForbidUploadModel',
    // 用户分层相关
    // 用户分层标签树
    userLayerTags: '/api/cxy/manager/v2/tagv2/userLayerTags',
    // 分层标签用户列表
    layerUserList: '/api/cxy/manager/v2/user/layerUserList',
    // 分层标签用户数量
    layerUserCount: '/api/cxy/manager/v2/user/layerUserCount',
    // 第三方导入模型用户列表
    thirdPartyImportUserList: '/api/cxy/manager/v3/privacy-preference/userList',
    // 第三方导入模型用户添加
    thirdPartyImportUserAdd:
      '/api/cxy/manager/v3/privacy-preference/importUser',
    // 第三方导入模型用户删除
    thirdPartyImportUserRemove:
      '/api/cxy/manager/v3/privacy-preference/userDel',

    // 内测用户管理模块（fland内测用户，弃用）
    flandUserList: '/api/cxy/manager/v2/user/flandUserList',
    // 内测用户列表
    betaUserList: '/api/cxy/manager/v2/device/internalTesting/userList',
    flandUserAdd: '/api/cxy/manager/v2/user/flandUserAdd',
    flandUserDel: '/api/cxy/manager/v2/user/flandUserDel',
    betaUserDel: '/api/cxy/manager/v2/device/internalTesting/userDel',
    flandUserUpPeriod: '/api/cxy/manager/v2/user/flandUserUpPeriod',
    flandUserEdit: '/api/cxy/manager/v2/user/flandUserEdit',
    validityPeriod: '/api/cxy/manager/v2/user/flandValidityPeriod',

    // 重置用户
    resetUserInfo: '/api/cxy/manager/v2/user/resetUserInfo',
    // 设置用户身份
    upUserIdentity: '/api/cxy/manager/v2/user/upUserIdentity',
    // 设置创作者等级
    setCreatorLevel: '/api/cxy/operational_support/creator/setCreatorLevel'
  },
  // 3D百科管理
  inforManage: {
    createInfor: '/api/cxy/manager/v2/news/create', // 创建资讯
    createDraft: '/api/cxy/manager/v2/news/createDraft', // 资讯存草稿
    editDraft: '/api/cxy/manager/v2/news/editDraft', // 资讯编辑草稿
    updateUrl: '/api/cxy/manager/v2/news/updateUrl', // 编辑URL别名
    inforList: '/api/cxy/manager/v2/news/list', // 资讯列表
    updateInfor: '/api/cxy/manager/v2/news/updateStatus', // 更新状态
    editRank: '/api/cxy/manager/v2/news/rank', // 编辑排序
    editInfor: '/api/cxy/manager/v2/news/edit', // 编辑资讯
    newDetail: '/api/cxy/manager/v2/news/detail' // 咨询详情
  },
  categoryManage: {
    // 分类
    // listAll: '/api/cxy/manager/category/listAll', // 获取所有分类
    // categoryPut: '/api/cxy/manager/category/categoryPut', // 创建或修改分类
    // categoryUpdateStatus: '/api/cxy/manager/category/categoryUpdateStatus', // 修改分类状态
    // 接口迁移
    listAll: '/api/cxy/manager/v2/common/categoryListAll', // 获取所有分类
    categoryPut: '/api/cxy/manager/v2/common/categoryPut', // 创建或修改分类
    categoryUpdateStatus: '/api/cxy/manager/v2/common/categoryUpdateStatus', // 修改分类状态
    categoryList: '/api/cxy/manager/category/categoryList' // 根据条件获取分类列表
  },
  channelManage: {
    channelAdd: '/api/cxy/manager/v2/channel/put', // 频道新增
    channelStatus: '/api/cxy/manager/v2/channel/updateStatus', // 频道状态
    channelList: '/api/cxy/manager/v2/channel/list' // 频道列表
  },
  tagsManage: {
    oldTagList: '/api/cxy/manager/v2/tag/tagList', // 获取标签列表（老）    产品和机型要用

    searchTag: '/api/cxy/manager/search/tagSearch', // 标签搜索

    tagPut: '/api/cxy/manager/v2/tagv2/put', // 创建或修改标签

    oldTagPut: '/api/cxy/manager/v2/tag/tagPut', // 创建或修改标签(老)

    tagList: '/api/cxy/manager/v2/tagv2/list', // 标签列表

    deleteTag: '/api/cxy/manager/v2/tagv2/delete', // 标签删除

    batchDeleteTag: '/api/cxy/manager/v2/tagv2/batchDelete', // 标签批量删除

    editTagType: '/api/cxy/manager/v2/tagv2/recObj', // 编辑标签类型

    tagRecommend: '/api/cxy/manager/v2/tagv2/recommend', // 标签推荐/取消推荐

    batchRecommend: '/api/cxy/manager/v2/tagv2/batchRecommend', // 标签批量推荐

    batchUnrecommend: '/api/cxy/manager/v2/tagv2/batchUnrecommend', // 标签批量取消推荐

    tagDwRecommendList: '/api/cxy/manager/v2/tagDwRecommend/list', // 系统推荐模型标签列表

    oldTagRecommend: '/api/cxy/manager/v2/tag/recommend', // 标签推荐/取消推荐 （老）

    tagRank: '/api/cxy/manager/v2/tagv2/rank', // 标签排序

    oldTagRank: '/api/cxy/manager/v2/tag/updateRank', // 标签排序（老）

    updateHeatValue: '/api/cxy/manager/v2/tagv2/heat', // 标签修改热度值

    updateOldHeatValue: '/api/cxy/manager/v2/tag/updateHeatValue', // 热度干预值（老）

    addBlackTag: '/api/cxy/manager/v2/tagv2/blackAdd', // 标签黑名单添加

    blackTagList: '/api/cxy/manager/v2/tagv2/blackList', // 标签黑名单列表

    deleteBlackTag: '/api/cxy/manager/v2/tagv2/blackDel', // 标签黑名单删除

    customList: '/api/cxy/manager/v2/tag/customList', // 自定义标签列表

    tagUpdateStatus: '/api/cxy/manager/v2/tag/tagUpdateStatus', // 修改标签状态
    tagsListRec: '/api/cxy/manager/v2/tagv2/listRec', // 标签推荐列表
    exportSyncTag: '/api/cxy/manager/v2/tag/syncTag', // 同环境标签导入
    requserTagList: '/api/cxy/manager/v2/tagv2/userTagList', // 用户标签列表
    deleteUserTag: '/api/cxy/manager/v2/tagv2/deleteUserTag', // 删除用户标签
    createUserTag: '/api/cxy/manager/v2/tagv2/createUserTag', // 新增用户标签
    // 标签分群
    tagGroupList: '/api/rest/lottery/userTags/tagGroupList', // 标签分群列表
    addTagGroup: '/api/rest/lottery/userTags/addTagGroup', // 新增标签分群
    updateTagGroup: '/api/rest/lottery/userTags/updateTagGroup', // 编辑标签分群
    delTagGroup: '/api/rest/lottery/userTags/delTagGroup', // 删除标签分群
    userLayerList: '/api/rest/lottery/userTags/userLayerList' // 标签用户列表
  },
  fileManage: {
    // 文件相关预上传
    reqPreUpload: '/api/cxy/manager/file/preupload'
  },
  // 红人计划
  sensation: {
    list: '/api/cxy/manager/v2/influencer/list',
    examine: '/api/cxy/manager/v2/influencer/examine'
  },
  // 商业模型招募
  businessModel: {
    list: '/api/cxy/manager/v2/commercial/user/list',
    examine: '/api/cxy/manager/v2/commercial/user/upStatus',
    queryModelList: '/api/cxy/manager/v2/commercial/user/modelList'
  },
  reportManage: {
    // 举报管理
    reportList: '/api/cxy/manager/v2/report/reportList', // 举报列表
    reportDeal: '/api/cxy/manager/v2/report/reportDeal', // 举报处理
    // reportType: '/api/cxy/report/reportReasonList', // 举报类型
    reportRespond: '/api/cxy/manager/v2/report/reportReply', // 举报回复
    reportTmpEdit: '/api/cxy/manager/v2/report/reportTmpEdit', // 举报模板编辑
    reportTmpDel: '/api/cxy/manager/v2/report/reportTmpDel',
    reportTmpList: '/api/cxy/manager/v2/report/reportTmpList' // 举报模板列表
  },
  circleManage: {
    circleDetail: '/api/cxy/manager/group/groupInfo', // 圈子详情
    postDetail: '/api/cxy/manager/post/postInfo', // 帖子详情
    createCircle: '/api/cxy/manager/group/putGroup', // 创建圈子
    circleList: '/api/cxy/manager/group/groupList', // 圈子列表
    circleOperating: '/api/cxy/manager/group/groupOperating', // 圈子操作
    circleDetect: '/api/cxy/manager/group/detectGroup', // 圈子探测
    // preUploadVideo: '/api/circle/preUploadVideo', // 创建视频凭证
    preUploadVideo: '/api/cxy/v2/common/preUploadVideo',
    createPost: '/api/cxy/manager/post/putPost', // 创建帖子
    postList: '/api/cxy/manager/post/postList', // 帖子列表
    topPostList: '/api/cxy/manager/post/postTopList', // 帖子置顶列表
    postOperating: '/api/cxy/manager/v2/ugc/postOperating', // 内容操作
    setTopPost: '/api/cxy/manager/v2/ugc/topOperating', // 帖子置顶/取消置顶
    topRank: '/api/cxy/manager/post/setRank', // 帖子置顶排序
    setGradeValue: '/api/cxy/manager/post/updateGradeValue', // 等级
    putColumns: '/api/cxy/manager/v2/group/putColumn', // 新增栏目
    getColumns: '/api/cxy/manager/v2/group/getGroupColumn', // 获取圈子栏目
    removeCircle: '/api/cxy/manager/v2/group/migrateGroup', // 栏目迁移
    columnsList: '/api/cxy/manager/v2/group/listColumn' // 栏目列表
  },
  contentManage: {
    contentAdd: '/api/cxy/manager/v2/ugc/create', // 内容新增
    draftAdd: '/api/cxy/manager/v2/ugc/createDraft', // 草稿新增
    contentList: '/api/cxy/manager/v2/ugc/list', // 内容列表
    // 发布草稿
    pushContent: '/api/cxy/manager/v2/ugc/pubDraft',
    topList: '/api/cxy/manager/v2/ugc/topList', // 置顶列表
    tagTop: '/api/cxy/manager/v2/ugc/tagTop', // 内容标签置顶管理
    delyList: '/api/cxy/manager/v2/ugc/delyList', // 定时发布任务
    operateTop: '/api/cxy/manager/post/topOperating', // 置顶|取消置顶
    contentDetail: '/api/cxy/manager/v2/ugc/detail', // 内容详情
    contentEdit: '/api/cxy/manager/v2/ugc/edit', // 内容编辑
    draftEdit: '/api/cxy/manager/v2/ugc/editDraft', // 草稿编辑
    setRecomRank: '/api/cxy/manager/v2/ugc/setRank', // 内容推荐排序
    setTopRank: '/api/cxy/manager/v2/ugc/setTopRank', // 内容置顶排序
    recommendList: '/api/cxy/manager/v2/ugc/recommList', // 推荐列表
    operateRecommend: '/api/cxy/manager/v2/ugc/recommOperating', // 推荐|取消推荐
    updateGrade: '/api/cxy/manager/v2/ugc/updateGradeValue', // 改变等级
    updatePublish: '/api/cxy/manager/v2/ugc/updatePublishTime', // 修改发布时间
    updateDelyTime: '/api/cxy/manager/v2/ugc/updateDelyTime', // 修改定时发布时间
    updateDelyStatus: '/api/cxy/manager/v2/ugc/updateDelyStatus', // 更新定时任务状态
    // 改变内容关联关系
    changeRelation: '/api/cxy/manager/v2/ugc/changeRelation',
    // 内容关联标签
    contentTagPut: '/api/cxy/manager/v2/ugc/blogTagPut',
    // 内容合集列表
    collectionList: '/api/cxy/manager/v2/anthology/list',
    // 创建合集
    createCollection: '/api/cxy/manager/v2/anthology/create',
    // 合集内容列表
    collectionContentList: '/api/cxy/manager/v2/anthology/ugcList',
    // 审核合辑
    auditCollection: '/api/cxy/manager/v2/anthology/operating',
    // 编辑合辑
    editCollection: '/api/cxy/manager/v2/anthology/update',
    // 合集添加内容
    collectionAddContent: '/api/cxy/manager/v2/anthology/addContents',
    // 合集删除内容
    collectionDelContent: '/api/cxy/manager/v2/anthology/delContents',
    // 合辑内容排序
    collectionRankContent: '/api/cxy/manager/v2/anthology/contentsRank',
    // 合辑删除
    collectionDelete: '/api/cxy/manager/v2/anthology/del',
    // 合辑推荐
    collectionRecommend: '/api/cxy/manager/v2/anthology/topOperating',
    // 合辑排序
    setCollectionRank: '/api/cxy/manager/v2/anthology/setRank',
    // 合辑修改关联产品
    updateProduct: '/api/cxy/manager/v2/anthology/updateProduct',
    // 加精
    refine: '/api/cxy/manager/v2/ugc/refine'
  },
  bannerManage: {
    bannerList: '/api/cxy/manager/v2/advance/advanceList', // 广告列表
    bannerModify: '/api/cxy/manager/v2/advance/advancePut', // 编辑/新增广告
    editRank: '/api/cxy/manager/v2/advance/advanceRank', // 编辑排序
    changeStatus: '/api/cxy/manager/v2/advance/advanceUpdateStatus', // 广告上下架
    // 广告详情
    bannerDetail: '/api/cxy/manager/v2/advance/advanceInfo'
  },
  // 推荐模型 人工推荐管理
  modelManualRecommend: {
    list: '/api/cxy/manager/v3/model/manualRecommendList', // 人工推荐列表
    create: '/api/cxy/manager/v3/model/manualRecommendCreate', // 创建人工推荐
    addModels: '/api/cxy/manager/v3/model/manualRecommendAddModelItems', // 批量添加人工推荐模型
    modelList: '/api/cxy/manager/v3/model/manualRecommendModelList', // 人工推荐-某推荐位下模型列表
    editModelList: '/api/cxy/manager/v3/model/manualRecommendUpdateOneModel', // 编辑人工推荐模型有效期/移除模型
    deleteManual: '/api/cxy/manager/v3/model/manualRecommendDeletePosition', // 删除
    editManual: '/api/cxy/manager/v3/model/manualRecommendUpdate' // 编辑
  },
  activeManage: {
    // activeList: '/api/cxy/manager/activity/list', // 列表
    activeList: '/api/cxy/manager/v2/activity/list', // 列表
    // activePut: '/api/cxy/manager/activity/put', // 新增活动
    activePut: '/api/cxy/manager/v2/activity/put', // 新增活动
    // activeRank: '/api/cxy/manager/activity/setSort', // 排序
    activeRank: '/api/cxy/manager/v2/activity/setSort', // 排序
    // activeStatus: '/api/cxy/manager/activity/setStatus', // 活动状态
    activeStatus: '/api/cxy/manager/v2/activity/setStatus', // 活动状态
    // 公司员工导入
    userImport: '/api/cxy/manager/v2/activity/userImport',
    // 活动用户列表
    userList: '/api/cxy/manager/v2/activity/userList',
    // 活动用户操作（兑奖，拉黑）
    userOperate: '/api/cxy/manager/v2/activity/operate',
    // 邀请明细
    inviteDetail: '/api/cxy/manager/v2/activity/inviteDetail',
    // 黑名单列表
    blackList: '/api/cxy/manager/v2/activity/blackedList',
    // 活动白名单列表
    whiteList: '/api/cxy/manager/v2/activity/emailWhitelist',
    // 白名单编辑
    whiteListEdit: '/api/cxy/manager/v2/activity/emailWhitePut',
    // 名单状态
    whiteListStatus: '/api/cxy/manager/v2/activity/emailSetStatus',
    // 常规活动列表
    regularActiveList: '/api/cxy/manager/v2/regularActivity/list',
    // 全部作品列表
    activeEntries: '/api/cxy/manager/v2/regularActivity/activeAllEntries',
    // 获奖作品列表
    activePrizeEntries:
      '/api/cxy/manager/v2/regularActivity/activePrizeEntries',
    // 置顶作品列表
    activeTopEntries: '/api/cxy/manager/v2/regularActivity/activeTopEntries',
    // 新增编辑活动分类
    classPut: '/api/cxy/manager/v2/allActivity/classPut',
    // 活动分类列表
    classList: '/api/cxy/manager/v2/allActivity/classList',
    // 活动分类上下架
    classUpStatus: '/api/cxy/manager/v2/allActivity/classUpStatus',
    // 活动分类修改排列顺序
    classUpRank: '/api/cxy/manager/v2/allActivity/classUpRank',
    // 新增编辑活动
    addRegularActivity: '/api/cxy/manager/v2/regularActivity/put',
    // 上下架常规活动
    updateRegularActivity: '/api/cxy/manager/v2/regularActivity/upStatus',
    // 常规活动->全部作品->新增作品
    uploadPrize: '/api/cxy/manager/v2/regularActivity/uploadPrize',
    // 常规活动详情
    regularActivityDetail: '/api/cxy/manager/v2/regularActivity/detail',
    // 作品设置奖项
    setPrize: '/api/cxy/manager/v2/regularActivity/setPrize',
    // 作品置顶
    topUpdate: '/api/cxy/manager/v2/regularActivity/topUpdate',
    // 删除作品
    deleteAcWork: '/api/cxy/manager/v2/regularActivity/deleteAcWork',
    // 上传获奖说明
    uploadPrizeExplain:
      '/api/cxy/manager/v2/regularActivity/uploadPrizeExplain',
    // 修改作品排序
    upAcWorkRank: '/api/cxy/manager/v2/regularActivity/upAcWorkRank',
    upAcWorkPosition: '/api/cxy/manager/v2/regularActivity/upAcWorkPosition',
    // 取消获奖名次
    cancelPrize: '/api/cxy/manager/v2/regularActivity/cancelPrize',
    // 常规活动->模型要求->指定模型，导入模型列表
    addModelIds: '/api/cxy/manager/v2/regularActivity/addModelIds',
    // 优选模型列表
    modelAcSelectedList: '/api/cxy/manager/v2/modelAcSelected/list',
    // 优选模型设置排序
    modelAcSelectedRank: '/api/cxy/manager/v2/modelAcSelected/rank',
    // 添加/移出优选模型
    modelAcSelectedPut: '/api/cxy/manager/v2/modelAcSelected/put',
    // 批量导入优质模型
    modelBatchAdd: '/api/cxy/manager/v2/modelAcSelected/batchAdd'
  },
  // 建模师裂变
  modelerFission: {
    list: '/api/cxy/manager/v2/activityModeler/list',
    add: '/api/cxy/manager/v2/activityModeler/put',
    update: '/api/cxy/manager/v2/activityModeler/operate',
    // 活动统计
    statis: '/api/cxy/manager/v2/activityModeler/statis',
    // 活动邀请者列表
    inviterList: '/api/cxy/manager/v2/activityModeler/inviterList',
    // 被邀请的用户列表
    inviteeList: '/api/cxy/manager/v2/activityModeler/inviteeList'
  },
  activeCommon: {
    add: '/api/cxy/manager/v2/allActivity/add', // 新增
    update: '/api/cxy/manager/v2/allActivity/update', // 编辑
    list: '/api/cxy/manager/v2/allActivity/list', // 列表
    updateHotValue: '/api/cxy/manager/v2/allActivity/updateHotValue', // 修改热度值
    pass: '/api/cxy/manager/v2/allActivity/pass', // 上架
    noPass: '/api/cxy/manager/v2/allActivity/noPass', // 下架
    updateSort: '/api/cxy/manager/v2/allActivity/updateSort', // 修改排序
    updateTop: '/api/cxy/manager/v2/allActivity/updateTop', // 修改置顶
    updateResult: '/api/cxy/manager/v2/allActivity/updateResult' // 关联内容
  },
  couponList: {
    // 模型优惠券创建
    modelCouponCreate: '/api/cxy/manager/v2/coupon/modelCouponCreate',
    // 模型优惠券修改
    modelCouponUpdate: '/api/cxy/manager/v2/coupon/modelCouponUpdate',
    // 模型组优惠券状态修改
    modelGroupUpdateStatus: '/api/cxy/manager/v2/coupon/modelGroupUpdateStatus',
    // 模型组优惠券列表
    modelGroupList: '/api/cxy/manager/v2/coupon/modelGroupList',
    // 模型组优惠券数据统计
    modelGroupStatistic: '/api/cxy/manager/v2/coupon/modelGroupStatistic',
    // 获取官方账号创想币数
    officialIcon: '/api/cxy/manager/v2/coin/official',
    // 优惠券模型组列表
    couponModelList: '/api/cxy/manager/v2/coupon/couponModelList',
    // 优惠券用户列表
    couponUserList: '/api/cxy/manager/v2/coupon/couponUserList',
    // 创想币统计
    statistics: '/api/cxy/manager/v2/coin/statistics',
    // 创想币统计(2014.7.18)
    statisticsDetail: '/api/cxy/manager/v2/coin/statisticsDetail',
    // 官方创想币流水
    officialList: '/api/cxy/manager/v2/coin/officialList',
    // 官方发放创想币
    officialRecharge: '/api/cxy/manager/v2/coin/officialRecharge',
    // 优惠券模型组列表
    chooseCouponModelList: '/api/cxy/manager/v3/model/couponModelGroupList'
  },
  // 创想币模型收益冻结
  coin: {
    // 模型冻结配置列表
    modelFreezeList: '/api/cxy/manager/v2/coin/modelFreezeList',
    // 单个模型冻结/解冻
    modelFreezeSet: '/api/cxy/manager/v2/coin/modelFreezeSet',
    // 批量冻结/解冻模型来源的创想币收益
    modelFreezeBatchSet: '/api/cxy/manager/v2/coin/modelFreezeBatchSet'
  },
  /** 批量数据 */
  bulkData: {
    // 批量数据列表
    bulkList: '/api/cxy/manager/v2/bulk/list',
    // 批量数据删除
    bulkDelete: '/api/cxy/manager/v2/bulk/delete',
    // 批量数据详情列表
    detailList: '/api/cxy/manager/v2/bulk/detailList',
    // 批量数据详情删除
    detailDelete: '/api/cxy/manager/v2/bulk/detailDelete'
  },
  /** 专题管理 */
  topicManage: {
    // topicList: '/api/rest/lottery/tThematic/list',
    topicList: '/api/cxy/manager/v2/thematic/list',
    // topicStatus: '/api/rest/lottery/tThematic/offOrOn',
    topicStatus: '/api/cxy/manager/v2/thematic/offOrOn',
    // topicPut: '/api/rest/lottery/tThematic/saveOrUpdate',
    topicPut: '/api/cxy/manager/v2/thematic/saveOrUpdate',
    batchImportModel: '/api/cxy/manager/v2/thematic/batchImportModel',
    thematicModelList: '/api/cxy/manager/v3/model/thematicModelList',
    // topicDel: '/api/rest/lottery/tThematic/deleteThematic',
    topicDel: '/api/cxy/manager/v2/thematic/delete',
    // listRecommend: '/api/rest/lottery/thematicRecommend/listRecommend',
    listRecommend: '/api/cxy/manager/v2/thematic/recommendList',
    // cancelRecommend: '/api/rest/lottery/thematicRecommend/cancelRecommend',
    cancelRecommend: '/api/cxy/manager/v2/thematic/cancelRecommend',
    // saveRecommend: '/api/rest/lottery/thematicRecommend/saveRecommend',
    saveRecommend: '/api/cxy/manager/v2/thematic/recommend',
    // sortRecommend: '/api/rest/lottery/thematicRecommend/sortRecommend',
    sortRecommend: '/api/cxy/manager/v2/thematic/upRecommendRank',
    // topicDetails: '/api/rest/lottery/tThematic/backgroundDetails', // 专题详情
    topicDetails: '/api/cxy/manager/v2/thematic/detail', // 专题详情
    // addModelToToppic: '/api/rest/lottery/tThematic/addModel', // 添加投稿模型选到专题
    addModelToToppic: '/api/cxy/manager/v2/thematic/addModel', // 添加投稿模型选到专题
    // updateModeler: '/api/rest/lottery/tThematic/updateModeler' // 关联建模师id或者专题专属链接
    updateModeler: '/api/cxy/manager/v2/thematic/updateModeler', // 关联建模师id或者专题专属链接
    pick: '/api/cxy/manager/v2/thematic/pick', // 专题精选
    cancelPick: '/api/cxy/manager/v2/thematic/cancelPick', // 取消精选
    // 新增专题权限用户
    topicAddUser: '/api/cxy/manager/v2/thematic/addAuthUser',
    // 回收专题权限用户（启用）
    // topicRecoverAuthUser: '/api/cxy/manager/v2/thematic/recoverAuthUser',
    topicRecoverAuthUser: '/api/cxy/manager/v2/thematic/updateAuthUser',
    // 专题权限用户列表
    topicUserList: '/api/cxy/manager/v2/thematic/userAuthList',
    // 用户精选专题添加标签
    updateTags: '/api/cxy/manager/v2/thematic/updateTags',
    // 编辑推荐专题
    recommendEdit: '/api/cxy/manager/v2/thematic/recommendEdit'
  },
  // 消息模板
  messages: {
    // 消息分类枚举列表
    typeList: '/api/cxy/manager/v2/msg/msgTypeIdList',
    // 消息模板列表
    tplList: '/api/cxy/manager/v2/msg/list',
    // 消息模板上下架
    updateStatus: '/api/cxy/manager/v2/msg/updateStatus',
    // 消息跳转枚举列表
    jumpTypeIdList: '/api/cxy/manager/v2/msg/jumpTypeIdList',
    // 创建编辑消息模板
    putTpl: '/api/cxy/manager/v2/msg/put',
    // 消息模板更新渠道
    upPlatformType: '/api/cxy/manager/v2/msg/upPlatformType',
    // 消息模板更新离线类型
    upAndroidType: '/api/cxy/manager/v2/msg/upAndroidType',
    // 消息分类列表
    msgClassList: '/api/cxy/manager/v2/msg/msgClassList',
    // 消息分类编辑
    msgClassEdit: '/api/cxy/manager/v2/msg/msgClassEdit',
    // 消息分类更新状态
    updateClassStatus: '/api/cxy/manager/v2/msg/updateClassStatus',
    // 消息分类更新排序
    updateClassRank: '/api/cxy/manager/v2/msg/updateClassRank',
    // 消息类型子类列表
    msgClassChildList: '/api/cxy/manager/v2/msg/msgClassChildList',
    // 消息分类子列新增/编辑
    msgClassChildEdit: '/api/cxy/manager/v2/msg/msgClassChildEdit',
    // 消息分类子列删除
    msgClassChildDel: '/api/cxy/manager/v2/msg/msgClassChildDel',
    // 邮件模板列表
    emailTplList: '/api/cxy/manager/v2/email/emailTmpList',
    // 邮件模板创建
    emailTplCreate: '/api/cxy/manager/v2/email/create',
    // 邮件模板修改
    emailTplUpdate: '/api/cxy/manager/v2/email/update',
    // 邮件发送记录列表
    emailSendRecordList: '/api/cxy/manager/v2/email/sendRecordList',
    // 邮件上下架
    emailUpdateStatus: '/api/cxy/manager/v2/email/updateStatus'
  },
  /** 国赛/千团 */
  gameManage: {
    gameList: '/api/cxy/manager/v2/guosai/list', // 列表
    gameDetail: '/api/cxy/manager/v2/guosai/detail', // 详情
    uploadUser: '/api/cxy/manager/v2/guosai/addUsers', // 导入选手
    userList: '/api/cxy/manager/v2/guosai/listUser' // 选手列表
  },
  /** 金砖 */
  bricsManage: {
    gameList: '/api/cxy/manager/v2/guosai/list', // 列表
    gameDetail: '/api/cxy/manager/v2/guosai/detail', // 详情
    uploadUser: '/api/cxy/manager/v2/guosai/addUsers', // 导入选手
    userList: '/api/cxy/manager/v2/guosai/listUser' // 选手列表
  },
  /** 金砖赛海外 */
  bricsAbroad: {
    // 导入参赛选手
    addUsers: '/api/cxy/manager/v2/jinzhuan/addUsers',
    // 获取参赛选手列表
    listUser: '/api/cxy/manager/v2/jinzhuan/listUser',
    // 专家列表
    listExpert: '/api/cxy/manager/v2/jinzhuan/listExpert',
    // 添加/编辑专家
    putExpert: '/api/cxy/manager/v2/jinzhuan/putExpert',
    // 获取专家信息
    getExpert: '/api/cxy/manager/v2/jinzhuan/getExpert',
    // 参赛作品列表
    listEntry: '/api/cxy/manager/v2/jinzhuan/listEntry',
    // 评分详情
    scoreInfo: '/api/cxy/manager/v2/jinzhuan/scoreInfo',
    // 专家评分
    scoreSet: '/api/cxy/manager/v2/jinzhuan/scoreSet'
  },
  h5Active: {
    list: '/api/rest/lottery/lotteryManger/lotteryList',
    add: '/api/rest/lottery/lotteryManger/saveOrUpdate',
    // 活动列表详情
    detail: '/api/rest/lottery/lotteryManger/getLotteryInfo',
    // 活动虚拟券码导出
    uploadCode: '/api/rest/lottery/lotteryManger/importVirtualCode',
    // 活动数据详情
    activeData: '/api/rest/lottery/lotteryManger/getLotteryDataInfo',
    // 活动数据统计记录列表
    recordList: '/api/rest/lottery/lotteryManger/lotteryDataList',
    // 导出统计数据
    exportRecord: '/api/rest/lottery/lotteryManger/importlotteryData',
    // 中奖记录列表
    winLogList: '/api/rest/lottery/lotteryManger/winLogList',
    // 核销
    writeOff: '/api/rest/lottery/lotteryManger/writeOffOperation',
    // 结束
    end: '/api/rest/lottery/tLottery/manualEnd',
    // 参与指定用户列表
    userList: '/api/rest/lottery/lotteryManger/getLotteryUserList',
    // 设置用户列表
    setUserList: '/api/rest/lottery/lotteryManger/saveLotteryUser',
    // 批量发货
    updateLogistics: '/api/rest/lottery/lotteryManger/updateLogistics',
    // 新建黑白名单
    saveWhiteBlack: '/api/rest/lottery/lotteryManger/saveWhiteBlack',
    // 黑白名单列表
    queryWhiteBlack: '/api/rest/lottery/lotteryManger/queryWhiteBlack',
    // 删除黑白名单
    removeWhiteBlack: '/api/rest/lottery/lotteryManger/removeWhiteBlack'
  },
  /** 助力签到抽奖 */
  boostSignIn: {
    // 活动列表
    list: '/api/rest/lottery/lotteryManger/lotteryList',
    // 新增/编辑活动
    add: '/api/rest/lottery/lotteryManger/saveLottery',
    // 活动详情
    detail: '/api/rest/lottery/lotteryManger/getLotteryInfo',
    // 数据统计
    activeData: '/api/rest/lottery/lotteryManger/getLotteryDataInfo',
    // 数据统计记录列表
    recordList: '/api/rest/lottery/lotteryManger/lotteryDataList',
    // 导出统计数据
    exportRecord: '/api/rest/lottery/lotteryManger/importlotteryData',
    // 中奖记录列表
    winLogList: '/api/rest/lottery/lotteryManger/winLogList',
    // 核销
    writeOff: '/api/rest/lottery/lotteryManger/writeOffOperation',
    // 批量发货
    updateLogistics: '/api/rest/lottery/lotteryManger/updateLogistics',
    // 结束活动
    end: '/api/rest/lottery/tLottery/manualEnd',
    // 复制活动
    copy: '/api/rest/lottery/boostSignIn/copy'
  },
  regimentsManage: {
    regimentsList: '/api/cxy/manager/v2/guosai/list' // 列表
  },
  commentManage: {
    // 评论管理
    // commentList: '/api/cxy/manager/commentList', // 评论管理
    // commentAlter: '/api/cxy/manager/commentAlter', // 评论变更
    // commentPost: '/api/cxy/manager/commentPost' // 发布评论
    commentList: '/api/cxy/manager/v2/comment/commentList', // 评论管理
    commentAlter: '/api/cxy/manager/v2/comment/commentAlter', // 评论变更
    commentPost: '/api/cxy/manager/v2/comment/commentPost', // 发布评论,
    // 机器人获取token
    robotToken: '/api/cxy/account/v2/admin/getRobotToken',
    // 机器人发表评论
    commentPost2: '/api/cxy/comment/postComment',
    // 置顶
    commentTop: '/api/cxy/manager/v2/comment/commentTop',
    // 加精
    commentEssence: '/api/cxy/manager/v2/comment/commentEssence',
    // 置顶列表
    commentTopList: '/api/cxy/manager/v2/comment/commentTopList',
    // 加精列表
    commentEssenceList: '/api/cxy/manager/v2/comment/commentEssenceList',
    // 发放奖励
    rewardDistribution: '/api/cxy/manager/v2/comment/rewardDistribution',
    // 查看评论详情
    commentDetail: '/api/cxy/manager/v2/comment/commentDetail'
  },
  bulletinManage: {
    // 公告管理
    // createBulletin: '/api/cxy/manager/message/noticePut', // 创建公告
    createBulletin: '/api/cxy/manager/v3/msg/noticePut', // 创建公告
    // bulletinDetail: '/api/cxy/manager/message/noticeInfo', // 公告详情
    bulletinDetail: '/api/cxy/manager/v3/msg/noticeInfo', // 公告详情
    // bulletinList: '/api/cxy/manager/message/noticeList', // 公告列表
    bulletinList: '/api/cxy/manager/v3/msg/noticeList', // 公告列表
    // bulletinUpdateStatus: '/api/cxy/manager/message/noticeUpdateStatus' // 公告状态更改
    bulletinUpdateStatus: '/api/cxy/manager/v3/msg/noticeOperate', // 公告状态更改
    // web端消息推送：新增编辑消息
    msgWebPut: '/api/cxy/manager/v2/msgv2/msgWebPut',
    // web端消息推送：消息列表
    msgWebList: '/api/cxy/manager/v2/msgv2/msgWebList',
    // web端消息推送：发布、删除
    msgWebOp: '/api/cxy/manager/v2/msgv2/msgWebOp',
    // web端消息推送：订阅者列表
    msgWebSubers: '/api/cxy/manager/v2/msgv2/msgWebSubers',
    // 公告用户列表
    noticeUserList: '/api/cxy/manager/v3/msg/noticeUserList',
    // 公告推送黑名单列表
    noticeBlacklist: '/api/cxy/manager/v2/msg/listBlacklist',
    // 公告推送黑名单新增
    addBlacklist: '/api/cxy/manager/v2/msg/addBlacklist',
    // 公告推送黑名单移除
    delBlacklist: '/api/cxy/manager/v2/msg/delBlacklist',
    // 公告测试推送（立即推送给指定用户）
    noticePushTest: '/api/cxy/manager/v3/msg/noticePushTest',
    // 公告追加推送用户（突破1万用户限制）
    noticeAppendUsers: '/api/cxy/manager/v3/msg/noticeAppendUsers',
    // 标签人群组列表
    tagGroupList: '/api/rest/lottery/userTags/tagGroupList',
    // 标签群组用户数量查询
    layerUserTagGroupCount: '/api/cxy/manager/v2/user/layerUserTagGroupCount'
  },
  aliyunOss: {
    // 阿里云信息
    circleOssInfo: '/api/cxy/v2/common/getOssInfo', // 获取圈子的oss信息（bucket）
    // getAliyunInfo: '/api/account/getAliyunInfo' // 获取阿里云信息 sessionToken，assessKeyId...
    getAliyunInfo: '/api/cxy/account/v2/getAliyunInfo' // 获取阿里云信息 sessionToken，assessKeyId...
  },
  others: {
    // 其他分类
    // operationRecord: '/api/cxy/manager/operationRecord', // 操作记录(老接口)
    operationRecord: '/api/cxy/manager/v2/common/operateRecord', // 操作记录
    operationRecordJava: '/api/rest/lottery/operation/list', // 操作记录 java
    // 操作记录管理员权限 可以看所有的操作记录  上面operationRecord这个默认只能看自己的。
    opRecordAdmin: 'op_record_admin',
    editPwd: '/api/account/changePassword', // 修改密码
    // searchUser: '/api/manager/accountSearch' // 搜索条件用户
    searchUser: '/api/cxy/account/v2/manager/userSearch' // 搜索条件用户
  },
  searchManage: {
    // 搜索管理
    addHot: '/api/cxy/manager/search/hotWordsPut', // 添加/编辑热词
    delHot: '/api/cxy/manager/search/hotWordsDelete', // 删除热词
    list: '/api/cxy/manager/search/hotWords', // 搜索列表
    // topWord: '/api/cxy/manager/search/topWord', // 搜索词列表
    topWord: '/api/cxy/operational_support/manager/search/topWord',
    syncToHotWords: '/api/cxy/manager/search/syncToHotWords', // 同步热词
    wordStatistic: '/api/cxy/manager/search/wordStatistic', // 搜索词统计数据
    treatmentValue: '/api/cxy/manager/search/treatmentValue', // 干预值更新
    hotWordRank: '/api/cxy/manager/search/hotWordRank', // 搜索热词更新排序
    publish: '/api/cxy/manager/search/hotWordsRelease', // 热词发布
    recode: '/api/cxy/manager/search/hotWordsReleaseList' // 发布记录
  },
  deviceManage: {
    // heziList: '/api/cxy/manager/v2/device/searchDeviceSn', // 盒子列表
    heziList: '/api/rest/print/cluster/deviceMgt/searchDeviceSn', // 盒子列表
    shangyunList: '/api/cxy/manager/v2/device/listSyLicense', // 尚云列表
    addShangyun: '/api/cxy/manager/device/importSyLicense', // 导入尚云
    addHezi: '/api/cxy/manager/v2/device/importDeviceSn', // 导入盒子
    // 设备激活的地区列表
    regionList: '/api/cxy/manager/v2/device/regionList',
    // 后台激活设备 日志上传
    feedbackDeviceLog: '/api/cxy/manager/v2/feedback/uploadLog',
    // OA导入DN记录列表
    oaImportDnList: '/api/cxy/manager/v2/device/oaImportDnList',
    // 设备激活记录
    deviceRegisterRecord: '/api/cxy/manager/v2/device/registerRecord'
  },
  toolManage: {
    materialAdd: '/api/cxy/manager/v2/widget/materialPut', // 素材库新建
    materialList: '/api/cxy/manager/v2/widget/materialList', // 素材库列表
    relatoinContent: '/api/cxy/manager/v2/widget/relationUgc', // 小工具关联内容
    getUgcInfo: '/api/cxy/manager/v2/widget/ugcInfo', // 查询小工具关联内容精简信息
    materialRank: '/api/cxy/manager/v2/widget/materialRank', // 素材库排序
    materialStatus: '/api/cxy/manager/v2/widget/materialOperate', // 素材库状态
    toolList: '/api/cxy/manager/v2/widget/widgetList', // 小工具列表
    toolRecommend: '/api/cxy/manager/v2/widget/widgetRecommend', // 小工具推荐
    toolAdd: '/api/cxy/manager/v2/widget/widgetPut', // 小工具新增
    toolRank: '/api/cxy/manager/v2/widget/widgetRank', // 小工具排序
    toolLike: '/api/cxy/manager/v2/widget/widgetLike', // 小工具点赞
    toolHot: '/api/cxy/manager/v2/widget/widgetHot', //  小工具热度
    toolStatus: '/api/cxy/manager/v2/widget/widgetOperate', // 小工具排序
    // 玩法列表
    playList: '/api/cxy/manager/v2/widget/playClassifyList',
    // 玩法新增
    playAdd: '/api/cxy/manager/v2/widget/playClassifyPut',
    // 玩法排序
    playRank: '/api/cxy/manager/v2/widget/playClassifyRank',
    // 玩法上下架
    palyStatus: '/api/cxy/manager/v2/widget/playClassifyOperate',
    // 玩法关联
    palyContent: '/api/cxy/manager/v2/widget/setPlayId'
  },
  printerManage: {
    // printerPut: '/api/cxy/manager/device/printerPut', // 新增/编辑机型
    // printerList: '/api/cxy/manager/device/printerList', // 打印机列表
    // printerRank: '/api/cxy/manager/device/printerRank', // 打印机排序
    // printerDel: '/api/cxy/manager/device/printerDel', // 打印机删除
    // printerSeriesList: '/api/cxy/manager/device/printerSeriesList', // 打印机系列
    // changeStatus: '/api/cxy/manager/device/printerUpdateStatus' // 打印机更新状态
    printerPut: '/api/cxy/manager/v2/device/printerPut', // 新增/编辑机型
    printerList: '/api/cxy/manager/v2/device/printerList', // 打印机列表
    printerRank: '/api/cxy/manager/v2/device/printerRank', // 打印机排序
    printerDel: '/api/cxy/manager/v2/device/printerDel', // 打印机删除
    printerSeriesList: '/api/cxy/manager/v2/device/printerSeriesList', // 打印机系列
    printerSerisesAdd: '/api/cxy/manager/v2/device/printerSeriesPut', // 打印机系列新增
    printerSerisesSort: '/api/cxy/manager/v2/device/printerSeriesSort', // 打印机系列排序
    printerSerisesStatus:
      '/api/cxy/manager/v2/device/printerSeriesUpdateStatus', // 打印机系列上下架，删除
    changeStatus: '/api/cxy/manager/v2/device/printerUpdateStatus', // 打印机更新状态
    getPrinterParams: '/api/cxy/manager/v2/device/getPrintParams', // 获取打印机参数详情
    setPrinterParams: '/api/cxy/manager/v2/device/bindPrintParams', // 绑定打印机参数
    // 获取切片参数
    // getSliceParams: '/api/cxy/manager/v2/device/gcodeParams',
    getSliceParams: '/api/cxy/manager/v2/device/gcodeParamsList',

    // 编辑切片参数
    editSliceParams: '/api/cxy/manager/v2/device/gcodeParamsUpdate',
    // 打印机关联文档
    relateDoc: '/api/cxy/manager/v2/device/printerDocs',
    // 上传切片参数文件
    createSliceProfile: '/api/cxy/manager/v2/slice-profile/create',
    // 上传切片文件列表
    sliceProfileList: '/api/cxy/manager/v2/slice-profile/list',
    // 获取机型切片文件详情
    getSliceProfileDetail: '/api/cxy/manager/v2/slice-profile/detail',
    // 打印机热门操作
    printerOpHot: '/api/cxy/manager/v2/device/printerOpHot',
    // 内测机型列表
    betaPrinterList: '/api/cxy/manager/v2/device/internalTesting/machineList',
    changeBetaPrinterStatus:
      '/api/cxy/manager/v2/device/internalTesting/machineChangeEnable',
    // 新增内测机型
    addBetaPrinter: '/api/cxy/manager/v2/device/internalTesting/machineAdd',
    // 内测机型添加用户
    addBetaPrinterUser: '/api/cxy/manager/v2/device/internalTesting/userAdd'
  },
  documentManage: {
    // documentList: '/api/cxy/manager/shared_text/sharedTextList', // 文案列表
    documentList: '/api/cxy/manager/v2/share/list', // 文案列表
    // documentAdd: '/api/cxy/manager/shared_text/sharedTextPut', // 新增
    documentAdd: '/api/cxy/manager/v2/share/put', // 新增
    // documentDel: '/api/cxy/manager/shared_text/sharedTextDel' // 删除
    documentDel: '/api/cxy/manager/v2/share/updateStatus' // 删除
  },
  // 高校管理
  universityManage: {
    UniversitieList: '/api/cxy/manager/v2/activity/school/list', // 高校列表
    universityAdd: '/api/cxy/manager/v2/activity/school/put', // 新增高校
    universityDel: '/api/cxy/manager/v2/activity/school/del', // 删除高校
    universityDayStatistics: '/api/cxy/manager/v2/activity/school/recordList', // 弹窗查看高校每日数据统计数据
    universityAllData: '/api/cxy/manager/v2/activity/school/total', // 首页统计所有高校增长数据
    universityActivity: '/api/cxy/manager/v2/activity/school/rank', // 校圈子活跃度排行
    UniversityCreateQcode: '/api/' // 生成二维码
  },
  // 固件管理
  firmwareManage: {
    firmwareList: '/api/cxy/manager/v2/firmware/list', // 固件列表
    firmwareAdd: '/api/cxy/manager/v2/firmware/put', // 新增固件
    firmwareDel: '/api/cxy/manager/v2/firmware/updateStatus', // 下架固件
    getInternalVer: '/api/cxy/manager/v2/firmware/getInternalVer', // 固件内部版本号获取
    upgradeWhitelist: '/api/cxy/manager/v2/firmware/upgradeWhitelist', // 固件升级白名单列表
    upgradeWhiteUpName: '/api/cxy/manager/v2/firmware/upgradeWhiteUpName', // 固件升级白名单修改名字
    upgradeWhiteAdd: '/api/cxy/manager/v2/firmware/upgradeWhitePut', // 固件升级白名单新增
    firmwareDnList: '/api/cxy/manager/v2/firmware/firmwareDnList', // 固件指定dn列表
    firmwareUserList: '/api/cxy/manager/v2/firmware/firmwareUserList', // 固件指定用户列表
    upgradeWhiteUserList: '/api/cxy/manager/v2/firmware/upgradeWhiteUserList' // 白名单详细列表
    // printerSeriesList: '/api/cxy/manager/v2/device/printerSeriesList', // 打印机系列
  },
  // 软件管理
  softwareManage: {
    list: '/api/cxy/manager/v2/firmware/softwareList',
    put: '/api/cxy/manager/v2/firmware/softwarePut'
  },

  // 版本管理
  versionManage: {
    list: '/api/cxy/manager/v2/firmware/verList',
    add: '/api/cxy/manager/v2/firmware/verCreate',
    edit: '/api/cxy/manager/v2/firmware/verUpdate'
  },
  // cfs管理
  cfsListManage: {
    list: '/api/cxy/manager/v2/device/cfs/list',
    add: '/api/cxy/manager/v2/device/cfs/create',
    // delete: '/api/cxy/manager/v2/device/cfs/delete',
    edit: '/api/cxy/manager/v2/device/cfs/edit',
    editStatus: '/api/cxy/manager/v2/device/cfs/editStatus'
  },

  // 文档管理
  softManage: {
    // 列表
    softList: '/api/rest/lottery/documentation/documentationList',
    // 新增
    softAdd: '/api/rest/lottery/documentation/saveOrUpdate',
    // 排序
    softRank: '/api/rest/lottery/documentation/updateSort',
    // 详情
    softDetail: '/api/rest/lottery/documentation/documentationInfo',
    // 删除
    softDelete: '/api/rest/lottery/documentation/deleteDocumentation'
  },

  // 光固化皮肤管理
  resinSkinManage: {
    // 列表
    list: '/api/cxy/manager/v2/skin/list',
    // 新增/编辑
    edit: '/api/cxy/manager/v2/skin/put',
    // 皮肤操作，上下架，排序
    operate: '/api/cxy/manager/v2/skin/operate'
  },

  // 软固插件模块
  plug: {
    // 列表
    plugList: '/api/cxy/manager/v2/firmware/categoryList',
    // 添加
    plugAdd: '/api/cxy/manager/v2/firmware/categoryCreate',
    // 修改
    plugUpdate: '/api/cxy/manager/v2/firmware/categoryUpdate',
    // 状态更新（上下架删除）
    plugUpStatus: '/api/cxy/manager/v2/firmware/categoryUpdateStatus',
    // 更新排序
    plugSort: '/api/cxy/manager/v2/firmware/categoryUpdateSort'
  },
  // OTA升级模块
  otaUpgrade: {
    otaList: '/api/cxy/manager/v2/firmware/otaList', // OTA列表
    otaAdd: '/api/cxy/manager/v2/firmware/otaCreate', // OTA添加
    otaEdit: '/api/cxy/manager/v2/firmware/otaUpdate', // OTA编辑
    otaOperate: '/api/cxy/manager/v2/firmware/otaUpdateStatus', // OTA操作(上下架)
    otaInfo: '/api/cxy/manager/v2/firmware/otaDetail' // ota详情
  },

  qrManage: {
    // qrList: '/api/cxy/manager/product/productList', // 产品管理列表
    // qrList: 'http://api.crealitycloud.com/api/cxy/manager/product/productList',
    // qrList: '/api/rest/lottery/productAssociation/productList', // 产品管理列表
    qrList: '/api/cxy/manager/product/productList',
    productCate: '/api/cxy/manager/v2/common/categoryListAll', // 产品分类列表 /api/cxy/manager/category/productList
    qrPut: '/api/cxy/manager/product/put', // 产品管理新增
    qrDel: '/api/cxy/manager/product/del', // 产品删除
    // 产品关联相关
    qrAddMedia: '/api/rest/lottery/productAssociation/saveOrUpdate',
    // // 切片详情
    // sliceDetail: '/api/cxy/manager/product/gcodeList',
    // // 关联切片
    // qrAddSlice: '/api/cxy/manager/product/linkGcode',
    // // 内容详情
    // contentDetail: '/api/cxy/manager/product/blogList',
    // // 关联内容
    // qrAddContent: '/api/cxy/manager/product/linkBlog'
    // 关联内容详情（模型，切片 帖子）
    qrLinkContentDetail: '/api/cxy/manager/product/linkContentList',
    // 关联内容（模型，切片 帖子）
    qrAddLinkContent: '/api/cxy/manager/product/linkContent',
    // 关联规格参数
    qrAddLinkParam: '/api/cxy/manager/product/linkParam',
    // 查看规格参数
    productParamList: '/api/cxy/manager/product/productParamList',
    qrSort: '/api/cxy/manager/product/rank',
    // 状态
    updateStatus: '/api/cxy/manager/product/updateStatus',
    // 关联教程
    productLinkTutorial: '/api/cxy/manager/v2/product/productLinkTutorial',

    // 购买链接配置模块
    // 列表
    sellLinkList: '/api/cxy/manager/v2/product/sellLinkList',
    // 新增
    sellLinkAdd: '/api/cxy/manager/v2/product/sellLinkAdd',
    // 修改
    sellLinkUpdate: '/api/cxy/manager/v2/product/sellLinkUpdate',
    // 删除
    sellLinkDelete: '/api/cxy/manager/v2/product/sellLinkUpdateStatus',
    // 获取外站登录token
    getJwToken: '/api/cxy/manager/v2/product/getIwtToken',
    // 获取外站list
    getJwList: '/api/cxy/manager/v2/product/productListJwt',
    // 导入外站数据
    importJwList: '/api/cxy/manager/v2/product/importParm',
    // 购买链接权重修改
    sellLinkUpRank: '/api/cxy/manager/v2/product/sellLinkUpRank'
  },
  problemManage: {
    problemList: '/api/cxy/manager/product/FAQList', // 问题列表
    problemCate: '/api/cxy/manager/v2/common/categoryList', // 问题分类列表 /api/cxy/manager/v2/common/categoryList
    problemPut: '/api/cxy/manager/product/putFAQ', // 新增问题
    problemStatus: '/api/cxy/manager/product/updateFAQStatus', // 删除/上下架
    problemRank: '/api/cxy/manager/product/updateFAQRank', // 排序
    problemCopy: '/api/cxy/manager/v2/serviceCenter/faqCopy', // 复制语言
    problemEditUrl: '/api/cxy/manager/product/updateFAQurlAlias', // url别名修改
    problemDetail: '/api/cxy/manager/product/FAQDetail',
    tutorialList: '/api/cxy/manager/v2/tutorial/tutorialList', // 新手教程列表
    tutorialAdd: '/api/cxy/manager/v2/tutorial/tutorialAdd', // 新手教程新增
    tutorialUpdate: '/api/cxy/manager/v2/tutorial/tutorialUpdate', // 新手教程编辑
    tutorialBindPrinters: '/api/cxy/manager/v2/tutorial/tutorialBindPrinters', // 新手教程绑定机型
    tutorialSetUniversal: '/api/cxy/manager/v2/tutorial/tutorialSetUniversal', // 新手教程设置通用教程
    tutorialUpdateStatus: '/api/cxy/manager/v2/tutorial/tutorialUpdateStatus', // 新手教程上下架
    tutorialCopy: '/api/cxy/manager/v2/tutorial/tutorialCopy', // 新手教程复制语言
    tutorialDetail: '/api/cxy/manager/v2/tutorial/tutorialDetail' // 新手教程详情
  },
  // 新手指南
  userGuideManage: {
    list: '/api/cxy/manager/v2/serviceCenter/newbieGuideList',
    add: '/api/cxy/manager/v2/serviceCenter/newbieGuideAdd',
    rank: '/api/cxy/manager/v2/serviceCenter/newbieGuideRank',
    del: '/api/cxy/manager/v2/serviceCenter/newbieGuideDel',
    updateType: '/api/cxy/manager/v2/serviceCenter/newbieGuideUpType', // 新手指南更新前台显示分类
    guideUpStatus: '/api/cxy/manager/v2/serviceCenter/newbieGuideUpStatus' // 新手指南上下架
  },
  appVersionManage: {
    list: '/api/cxy/manager/v2/serviceCenter/versionDescList',
    add: '/api/cxy/manager/v2/serviceCenter/versionDescAdd',
    del: '/api/cxy/manager/v2/serviceCenter/versionDescDel',
    edit: '/api/cxy/manager/v2/serviceCenter/versionDescEdit'
  },
  experienceManage: {
    taskList: '/api/cxy/manager/v2/task/taskList', // 查询经验值任务列表
    createTask: '/api/cxy/manager/v2/task/taskPut', // 创建经验值任务
    taskRank: '/api/cxy/manager/v2/task/taskRank', // 修改任务排序
    taskInfo: '/api/cxy/manager/v2/task/taskInfo', // 查询任务详情
    taskRuleList: '/api/cxy/manager/v2/task/taskRuleList', // 查询任务规则列表
    taskOperate: '/api/cxy/manager/v2/task/taskOperate', // 修改任务状态
    setLimit: '/api/cxy/manager/v2/exp/setLimit', // 经验值上限设置
    recordList: '/api/cxy/manager/v2/exp/recordList', // 经验值明细
    expPointsList: '/api/cxy/manager/v2/exp/expPointsList', // 经验值排行榜
    getLimit: '/api/cxy/manager/v2/exp/getLimit', // 获取经验值上限明细
    detailList: '/api/cxy/manager/v2/exp/expDetail', // 用户明细列表
    levelInfoList: '/api/cxy/manager/v2/exp/levelInfo', // 等级权益列表
    editLevel: '/api/cxy/manager/v2/exp/putBenefit', // 新增编辑等级
    setBeanLimit: '/api/cxy/manager/v2/kwbeans/setLimit', // 设置酷维豆上限
    getBeanLimit: '/api/cxy/manager/v2/kwbeans/getLimit', // 获取酷维豆上限
    rankList: '/api/cxy/manager/v2/kwbeans/rankList', // 酷维豆明细
    kwbeansDetail: '/api/cxy/manager/v2/kwbeans/kwbeansDetail', // 酷维豆获取/消耗明细统计
    pullBlack: '/api/cxy/manager/v2/kwbeans/block', // 拉黑用户
    kwRecordList: '/api/cxy/manager/v2/kwbeans/recordList', // 酷维豆用户明细
    manualGiveList: '/api/cxy/manager/v2/kwbeans/manualGiveList', // 手动发豆列表
    manualGive: '/api/cxy/manager/v2/kwbeans/manualGive', // 手动发豆
    statistics: '/api/cxy/manager/v2/kwbeans/statistics', // 酷维豆统计
    kwbeansRecord: '/api/cxy/manager/v2/kwbeans/kwbeansRecord', // 酷维豆获取/消耗明细流水
    kwbeansRecoveryList: '/api/cxy/manager/v2/kwbeans/recoveryList', // 酷维豆回收列表
    kwbeansRecovery: '/api/cxy/manager/v2/kwbeans/recovery', // 酷维豆回收
    // 任务关联列表
    taskRelationList: '/api/cxy/manager/v2/task/taskRelationList',
    // 获取签到配置列表
    checkinRewardList: '/api/cxy/manager/v2/task/checkinRewardList',
    // 新增签到配置
    addCheckinReward: '/api/cxy/manager/v2/task/addCheckinReward',
    // 更新签到配置
    updateCheckinReward: '/api/cxy/manager/v2/task/updateCheckinReward',
    // 停止签到奖励活动
    stopCheckinReward: '/api/cxy/manager/v2/task/stopCheckinReward'
  },
  // 异步任务管理
  asyncTaskManage: {
    add: '/api/cxy/manager/v2/taskManage/add',
    list: '/api/cxy/manager/v2/taskManage/list',
    pass: '/api/cxy/manager/v2/taskManage/pass',
    fail: '/api/cxy/manager/v2/taskManage/fail',
    subList: '/api/cxy/manager/v2/taskManage/subList',
    retry: '/api/cxy/manager/v2/taskManage/retry'
  },
  // 阶梯任务  这个下面的接口都要换 jyf -------- 调试代码 ----------
  ladderTasksManage: {
    list: '/api/cxy/manager/v2/ladder/list', // 查询阶梯任务列表
    add: '/api/cxy/manager/v2/ladder/create', // 新增阶梯任务
    update: '/api/cxy/manager/v2/ladder/edit', // 更新阶梯任务
    types: '/api/cxy/manager/v2/ladder/types', // 阶梯任务类型列表
    stages: '/api/cxy/manager/v2/ladder/stages', // 阶梯任务期数信息
    rank: '/api/cxy/manager/v2/ladder/rank', // 阶梯任务排序
    status: '/api/cxy/manager/v2/ladder/status', // 阶梯任务上下架
    preheat: '/api/cxy/manager/v2/ladder/preheat' // 阶梯任务预热状态修改
  },
  // 激励计划管理
  boostTaskManage: {
    // 新阶梯任务用户拉黑
    blackUser: '/api/cxy/manager/v2/accrue/black',
    blackList: '/api/cxy/manager/v2/accrue/listBlack'
  },
  beanGoods: {
    createGoods: '/api/rest/lottery/eshop/admin/goods/put', // 创建编辑商品
    // goodsList: '/api/cxy/manager/v2/goods/list', // 商品列表
    goodsList: '/api/rest/lottery/eshop/admin/goods/list', // 商品列表
    delGoods: '/api/cxy/manager/v2/goods/del', // 删除商品
    updateGoods: '/api/cxy/manager/v2/goods/updateStatus', // 更新商品上下架状态
    goodsDetail: '/api/cxy/manager/v2/goods/detail', // 商品详情
    goodsBatchCopy: '/api/cxy/manager/v2/goods/batchCopy', // 复制商品
    detailLogList: '/api/cxy/manager/v2/goods/detailLogList', // 商品操作日志
    couponList: '/api/cxy/manager/v2/goods/couponList', // 券码列表
    couponDetail: '/api/cxy/manager/v2/goods/couponDetail', // 券码详情
    // orderList: '/api/cxy/manager/v2/goods/orders', // 订单列表
    orderList: '/api/rest/lottery/goodsCxy/admin/orders',
    orderEdit: '/api/cxy/manager/v2/goods/orderEdit', // 更新物流信息
    getDayLimit: '/api/cxy/manager/v2/goods/getDayLimit', // 获取商品单日兑换次数
    setDayLimit: '/api/cxy/manager/v2/goods/dayLimit', // 设置商品单日兑换次数
    saveCardSecret: '/api/cxy/manager/v2/goods/orderEditCoupon', // 订单添加/编辑卡密
    orderRightsSend: '/api/cxy/manager/v2/goods/orderRightsSend', // 订单发放虚拟商品（vip/空间）
    goodsClassPut: '/api/cxy/manager/v2/goods/classPut', // 新增商品分类
    goodsClassList: '/api/cxy/manager/v2/goods/classList', // 商品分类列表
    goodsClassUpStatus: '/api/cxy/manager/v2/goods/classUpStatus', // 商品分类状态更新
    goodsReject: '/api/rest/lottery/goodsCxy/admin/orderReject', // 订单驳回
    goodsDtcSite: '/api/cxy/manager/v2/goods/dtcSite', // DTC站点
    goodsBatchStatus: '/api/cxy/manager/v2/goods/batchStatus', // 商品批量更新状态
    batchTag: '/api/cxy/manager/v2/goods/batchTag', // 商品批量打标签
    goodsOrderEccang: '/api/cxy/manager/v2/goods/orderEccang', // 订单通知易仓发货
    goodsRankSet: '/api/cxy/manager/v2/goods/baseEdit', // 商品添加排序
    dtcSiteList: '/api/cxy/manager/v2/goods/dtcSiteList', // DTC站点列表
    dtcSiteEdit: '/api/cxy/manager/v2/goods/dtcSiteEdit', // DTC站点编辑
    dtcSiteRank: '/api/cxy/manager/v2/goods/dtcSiteRank', // DTC站点排序
    dtcSiteStatus: '/api/cxy/manager/v2/goods/dtcSiteStatus', // DTC站点上下架状态改变
    goodsResetStock: '/api/cxy/manager/v2/goods/resetStock', // 商品一键清库存
    queryDtcGoods: '/api/rest/lottery/eshop/dtc/queryGoods', // 查询DTC商品
    goodsShopping: '/api/rest/lottery/goodsCxy/admin/sendOk', // 虚拟DTC发货
    proGoodsCopy: '/api/rest/lottery/eshop/admin/goods/copy' // 仅限国内商品复制
  },
  // 随心修服务
  afterSaleManage: {
    // 商品模块
    addGoods: '/api/rest/cxswcloud/repair/tCommodity/add', // 新增商品
    updateGoods: '/api/rest/cxswcloud/repair/tCommodity/update', // 修改商品
    sortUpdate: '/api/rest/cxswcloud/repair/tCommodity/sortUpdate', // 修改排序
    editShelves: '/api/rest/cxswcloud/repair/tCommodity/editStatus', // 编辑上下架
    exportGoods: '/api/rest/cxswcloud/repair/tCommodity/export', // 商品导出
    goodsInfo: '/api/rest/cxswcloud/repair/tCommodity/selectOnes', // 商品详情
    goodsList: '/api/rest/cxswcloud/repair/tCommodity/BackgroundList', // 商品列表
    hasModels: '/api/rest/cxswcloud/repair/tCommodity/getmodel', // 查询机型是否已经添加过商品

    // 订单模块
    ordersList: '/api/rest/cxswcloud/repair/tRepairOrder/tCommoditylists', // 订单列表
    ordersDetail: '/api/rest/cxswcloud/repair/tRepairOrder/selectOne', // 订单详情

    // 售后模块
    afterSaleList: '/api/rest/cxswcloud/repair/aftersales/BackgroundList', // 售后列表
    afterSaleInfo: '/api/rest/cxswcloud/repair/aftersales/selectone' // 售后详情
  },
  // 志愿者荣誉墙
  specialThanks: {
    // 新增志愿者
    add: '/api/cxy/manager/v2/volunteer/honorAdd',
    // 志愿者列表
    list: '/api/cxy/manager/v2/volunteer/honorList',
    // 删除
    del: '/api/cxy/manager/v2/volunteer/honorDel',
    // 编辑
    edit: '/api/cxy/manager/v2/volunteer/honorEdit',
    // 排序
    rank: '/api/cxy/manager/v2/volunteer/honorRank'
  },
  // 邀请有礼模块
  shareActivity: {
    saveActivity: '/api/cxy/manager/v2/activityInvite/invitePut', // 新增/编辑 活动
    activityList: '/api/cxy/manager/v2/activityInvite/inviteList', // 活动列表
    operate: '/api/cxy/manager/v2/activityInvite/inviteOperate', // 活动上下架
    operateLog: '/api/cxy/manager/v2/common/operateRecord', // 活动操作记录
    statistics: '/api/cxy/manager/v2/activityInvite/inviteUserStatistics', // 活动统计列表
    statisticsNum: '/api/cxy/manager/v2/activityInvite/inviteStatistics', // 统计数
    inviteDetail: '/api/cxy/manager/v2/activityInvite/inviteUserRecord', // 邀请明细
    blacklist: '/api/cxy/manager/v2/activityInvite/inviteBlockList', // 拉黑列表
    operateBlack: '/api/cxy/manager/v2/activityInvite/inviteBlock', // 拉黑与取消拉黑
    detail: '/api/cxy/manager/v2/activityInvite/inviteDetail',
    // 权限用配置
    activityManage: 'shareActivity/activityManage' // 活动管理
  },

  // 系统配置
  systemConfig: {
    list: '/api/cxy/manager/v2/config/list', // 配置列表
    edit: '/api/cxy/manager/v2/config/post', // 配置修改
    changeStatus: '/api/cxy/manager/v2/config/updateStatus', // 配置状态修改
    recommendPAIRouteSet: '/settings/RecommendPAIRouteSet' // 推荐V4分流PAI规则
  },
  // bi报表
  biFormManage: {
    list: '/api/cxy/manager/v2/bi/links'
  },
  // 短链
  shortLink: {
    // 列表
    linkList: '/api/cxy/account/v2/admin/shortlink/list',
    // 新增
    addLink: '/api/cxy/account/v2/admin/shortlink/create',
    // 禁用、启用
    linkStatus: '/api/cxy/account/v2/admin/shortlink/updateStop',
    // 删除
    linkDelete: '/api/cxy/account/v2/admin/shortlink/delete'
  },
  // 外链
  outerLink: {
    // 列表
    linkList: '/api/cxy/manager/v2/outerLink/list',
    // 新增
    addLink: '/api/cxy/manager/v2/outerLink/put',
    // 备注
    linkRemark: '/api/cxy/manager/v2/outerLink/remark',
    // 修改状态
    linkStatus: '/api/cxy/manager/v2/outerLink/status',
    // 绑定短链
    bindShort: '/api/cxy/manager/v2/outerLink/bindShort'
  },
  // 外链渠道
  outerChannelLink: {
    // 列表
    linkList: '/api/cxy/manager/v2/outerChannel/list',
    // 新增
    add: '/api/cxy/manager/v2/outerChannel/put'
  },
  // 风控管理
  riskManage: {
    // 风控配置修改
    updateRiskControl: '/api/cxy/manager/v2/riskControl/update',
    // 新增配置
    createRiskControl: '/api/cxy/manager/v2/riskControl/create',
    // 列表
    listRiskControl: '/api/cxy/manager/v2/riskControl/list',
    // 风控配置状态修改
    updateStatusRisk: '/api/cxy/manager/v2/riskControl/updateStatus',
    // IP风控列表接口
    listIpRiskControl: '/api/cxy/manager/v2/ip/riskControl/list',
    // IP风控状态修改
    updateIpRiskStatus: '/api/cxy/manager/v2/ip/riskControl/updateStatus',
    // 新增IP风控
    createIpRiskControl: '/api/cxy/manager/v2/ip/riskControl/create',
    // IP风控配置修改
    updateIpRiskControl: '/api/cxy/manager/v2/ip/riskControl/update',
    // ip异常下载模型数据
    ipBadModelDownloadList:
      '/api/cxy/manager/v2/ip/riskControl/badModelDownloadList',
    // 用户风险记录列表
    ipBadRecordUserList: '/api/cxy/manager/v2/user/riskRecordList',
    // ip白名单列表
    ipWhitelistList: '/api/cxy/manager/v2/ip/riskControl/whitelist',
    // ip白名单新增
    createIpWhitelist: '/api/cxy/manager/v2/ip/riskControl/whitelistCreate',
    // ip白名单编辑
    updateIpWhitelist: '/api/cxy/manager/v2/ip/riskControl/whitelistUpdate',
    // ip白名单删除
    delIpWhitelist: '/api/cxy/manager/v2/ip/riskControl/whitelistDel',
    // 作弊模型列表
    cheatModelList: '/api/cxy/manager/v2/ip/riskControl/cheatModels',
    //  作弊模型-积分回收
    cheatModelRecover: '/api/cxy/manager/v2/ip/riskControl/recover',
    // 异常用户列表
    accrueBlackList: '/api/rest/lottery/biStatistics/accrueBlackList',
    // 模型异常下载列表
    accrueRecordCleanStatList:
      '/api/rest/lottery/biStatistics/accrueRecordCleanStatList'
  },
  // 推荐公式
  recommendFormula: {
    // 更新模型组推荐配置
    updateRecommendSetting: '/api/cxy/manager/v3/model/updateRecommendSetting',
    // 获取模型组推荐配置
    getRecommendSetting: '/api/cxy/manager/v3/model/getRecommendSetting',
    // 获取模型组推荐配置历史记录
    recommendSettingHistory:
      '/api/cxy/manager/v3/model/recommendSettingHistory',
    // 模型组推荐配置发版
    recommendSettingRelease: '/api/cxy/manager/v3/model/recommendSettingRelease'
  },
  // 金刚区
  navManage: {
    // 列表
    listNavControl: '/api/cxy/manager/v2/common/quickLinkList',
    // 状态更新
    updateNavControl: '/api/cxy/manager/v2/common/upQuickLinkStatus',
    // 排序更新
    rankNavControl: '/api/cxy/manager/v2/common/upQuickLinkRank',
    // 新增编辑
    createNavControl: '/api/cxy/manager/v2/common/quickLinkPut'
  },
  // 模型菜单
  modelMenu: {
    // app新版首页tab编辑
    homeTabEdit: '/api/cxy/manager/v2/common/homeTabEdit',
    // app新版首页tab详情
    homeTabInfo: '/api/cxy/manager/v2/common/homeTabInfo',
    // app首页tab模型数量
    layerModelCount: '/api/cxy/manager/v3/model/layerModelCount',
    // 专题下模型数量
    thematicModelCount: '/api/cxy/manager/v2/thematic/layerModelCount'
  },
  // web首页热门推荐模型
  webHotModel: {
    modelList: '/api/cxy/manager/v2/modelAd/statisc',
    exportAll: '/api/cxy/manager/v2/modelAd/add',
    positionList: '/api/cxy/manager/v2/modelAd/list',
    removeModel: '/api/cxy/manager/v2/modelAd/del',
    setTimeModel: '/api/cxy/manager/v2/modelAd/edit',
    updateSort: '/api/cxy/manager/v2/modelAd/update',
    updateTags: '/api/cxy/manager/v2/modelAd/updateTags'
  },
  // 打印机参数
  printerParamsManage: {
    // 列表
    paramsList: '/api/cxy/manager/v2/device/printParamsList',
    // 新增参数
    addParams: '/api/cxy/manager/v2/device/printParamsAdd',
    // 编辑参数
    editParams: '/api/cxy/manager/v2/device/printParamsEdit',
    // 改变状态
    setStatus: '/api/cxy/manager/v2/device/printParamsSetStatus'
  },
  paramsTemplate: {
    // 列表
    tempList: '/api/cxy/manager/v2/device/printDashboarList',
    // 详情
    tempDetail: '/api/cxy/manager/v2/device/printDashboarItem',
    // 上下架
    tempStatus: '/api/cxy/manager/v2/device/printDashboarSetStatus',
    // 编辑
    tempEdit: '/api/cxy/manager/v2/device/printDashboarEdit',
    // 新增
    tempAdd: '/api/cxy/manager/v2/device/printDashboarAdd',
    // 激光雕刻机列表
    laserPrinterList: '/api/cxy/manager/v2/device/laserCutterList',
    // 雕刻机排序
    laserPrinterRank: '/api/cxy/manager/v2/device/setRank',
    // 激光雕刻机操作（上下架，删除，排序）
    operateLaser: '/api/cxy/manager/v2/device/laserCutterOperate',
    // 新增激光雕刻机
    addLaserPrinter: '/api/cxy/manager/v2/device/laserCutterPut',
    // 激光雕刻材质列表
    laserMaterialList: '/api/cxy/manager/v2/device/laserMaterialList',
    // 新增雕刻材质
    addLaserMaterial: '/api/cxy/manager/v2/device/laserMaterialPut',
    // 雕刻材质排序
    laserMaterialRank: '/api/cxy/manager/v2/device/laserMaterialSetRank',
    // 雕刻材质操作
    operateLaserMaterial: '/api/cxy/manager/v2/device/laserMaterialOperate',
    // 雕刻机关联材质
    laserAddMaterial: '/api/cxy/manager/v2/device/laserCutterMaterial',
    // 激光雕刻机关联的材质删除操作
    laserRelationMaterialOp:
      '/api/cxy/manager/v2/device/laserRelationMaterialOp',
    // 更新参数
    updateParams: '/api/cxy/manager/v2/device/updateAllBindPintParams',
    // 扫描仪列表
    scanPrinterList: '/api/cxy/manager/v2/device/scannerList',
    // 新增编辑扫描仪
    scanPrinterPut: '/api/cxy/manager/v2/device/scannerPut',
    // 扫描仪操作状态更新
    operateScan: '/api/cxy/manager/v2/device/scannerUpdate',
    // 扫描仪删除
    deleteScan: '/api/cxy/manager/v2/device/scannerDel',
    scanPrinterRank: '/api/cxy/manager/v2/device/scannerUpRank',
    // M1生成器列表
    m1GeneratorList: '/api/cxy/manager/v2/device/m1GeneratorList',
    // 新增编辑M1生成器
    m1GeneratorPut: '/api/cxy/manager/v2/device/m1GeneratorPut',
    // M1生成器详情
    m1GeneratorDetail: '/api/cxy/manager/v2/device/m1GeneratorDetail',
    // M1生成器更新状态(上下架)
    m1GeneratorUpdate: '/api/cxy/manager/v2/device/m1GeneratorUpdate',
    // M1生成器删除
    m1GeneratorDel: '/api/cxy/manager/v2/device/m1GeneratorDel',
    // M1生成器排序
    m1GeneratorUpRank: '/api/cxy/manager/v2/device/m1GeneratorUpRank',
    // 打印机型导入其他环境
    pushToRemote: '/api/cxy/manager/v2/device/printer/pushToRemote',
    // 从其他环境导入打印参数
    syncPrintParams: '/api/cxy/manager/v2/device/syncPrintParams',
    // 从其他环境导入打印面板
    syncPrintBoard: '/api/cxy/manager/v2/device/syncPrintBoard'
  },
  // 打印服务、 酷维豆，充值相关
  printService: {
    updateEditorPrice: '/api/rest/lottery/kwBeansPrice/updateOrSavewBeansPrice', // 新增编辑酷维豆
    priceList: '/api/rest/lottery/kwBeansPrice/mangerKwBeansPriceList', // 酷维豆价格列表
    improtChargeSet: '/api/rest/lottery/kwBeansPrice/importKwBeansPrice', // 酷维豆价格导出
    chargeList: '/api/rest/lottery/kwBeansRechargeOrder/rechargeOrderList', // 酷维豆充值记录列表
    reOrder: '/api/rest/lottery/kwBeansRechargeOrder/reOrder', // 充值补单
    chargeListTotal: '/api/rest/lottery/kwBeansRechargeOrder/rechargeOrderData', // 酷维豆充值记录列表
    mangerPrintOrderList:
      '/api/rest/lottery/mangerPrintOrder/mangerPrintOrderList', // 打印订单列表
    mangerPrintOrderListDate:
      '/api/rest/lottery/mangerPrintOrder/mangerPrintOrderListDate', // 打印订单统计
    printOrderDetail: '/api/rest/lottery/mangerPrintOrder/mangerPrintOrderInfo', // 打印订单详情
    trackingInfo: '/api/rest/lottery/printOrder/trackingInfo', // 查询订单物流
    backstageList: '/api/rest/lottery/feedback/backstageList', // 反馈耗材列表
    consumablesList: '/api/rest/lottery/consumables/backstageList', // 耗材库列表
    consumablesApplyList:
      '/api/rest/lottery/tServiceProvider/backgroundDataList', // 服务商申请列表
    consumablesAdd: '/api/rest/lottery/consumables/save', // 新增耗材
    consumablesUpdate: '/api/rest/lottery/consumables/update', // 修改耗材
    serviceDetail: '/api/rest/lottery/tServiceProvider/backstageDetails', // 服务商详情
    serviceExamine: '/api/rest/lottery/tServiceProvider/examine', // 后台服务商驳回/通过
    backstageSaveAdd: '/api/rest/lottery/tServiceProvider/backstageSave', // 服务商资料新增
    consumablesAddService:
      '/api/rest/lottery/tServiceConsumables/backstageSave', // 服务商新增耗材
    consumablesServiceList:
      '/api/rest/lottery/tServiceConsumables/backstageExhibition', // 服务商耗材列表
    manageEditLogistics:
      '/api/rest/lottery/mangerPrintOrder/manageEditLogistics', // 编辑物流
    distributionServiceProvider:
      '/api/rest/lottery/mangerPrintOrder/distributionServiceProvider', // 分配服务商
    // 服务商排序
    provicerSort: '/api/rest/lottery/tServiceProvider/sort',
    // 服务商设置白名单
    provicerSetWhiteList: '/api/rest/lottery/tServiceProvider/setWhiteList',
    // 服务商推荐
    provicerRecommend: '/api/rest/lottery/tServiceProvider/recommend',
    // 服务商上下架
    provicerUpAndDown: '/api/rest/lottery/tServiceProvider/upAndDown',
    // 设置内部服务商
    provicerSetInternalServiceProvider:
      '/api/rest/lottery/tServiceProvider/setInternalServiceProvider',
    // 创想币退款接口
    refund: '/api/rest/lottery/kwBeansRechargeOrder/refund',

    // 首页配置 列表
    configList: '/api/rest/lottery/homepageModel/pageModelList',
    // 首页配置 新增/编辑
    configSave: '/api/rest/lottery/homepageModel/saveOrUpdatePageModel',
    // 评价列表
    evaluateMangerList: '/api/rest/lottery/evaluate/evaluateMangerList',
    // 举报商家列表
    complaintBusinessList: '/api/rest/lottery/complaint/complaintBusinessList',
    // 设置/取消精选
    selectSettings: '/api/rest/lottery/evaluate/selectSettings',
    // 删除评价
    deleteEvaluateManger: '/api/rest/lottery/evaluate/deleteEvaluateManger',
    // 后台投诉商家 处理-不予处理-回复
    complaintBusinessProcess:
      '/api/rest/lottery/complaint/complaintBusinessProcess',
    // 查询服务商未报价统计数据
    getServiceProviderQuotedFeedbackInfo:
      '/api/rest/lottery/photoReal/getServiceProviderQuotedFeedbackInfo',
    // 调研详情
    getQuotedFeedbackInfo: '/api/rest/lottery/photoReal/getQuotedFeedbackInfo',
    // 获取0元下单的订单数
    getToQuotedFreePrintNum:
      '/api/rest/lottery/homepageModel/getToQuotedFreePrintNum',
    // 批量报价
    batchQuotedPrice:
      '/api/rest/lottery/serviceProviderPrintOrder/batchQuotedPrice'
  },
  // 注销管理
  logoutManage: {
    // 权限用配置
    logoutList: '/api/cxy/manager/v2/user/tasklist',
    operate: '/api/cxy/manager/v2/user/del'
  },
  // 切片管理
  sliceManage: {
    list: '/api/cxy/manager/v2/gcode/list',
    add: '/api/cxy/manager/v2/gcode/uploadGcode',
    edit: '/api/cxy/manager/v2/gcode/editGcode',
    detail: '/api/cxy/manager/v2/gcode/getDetail',
    sliceDel: '/api/cxy/manager/v2/gcode/deleteGcode',
    relatedModel: '/api/cxy/manager/v2/gcode/relatedModel',
    // 光固化官方切片管理
    dlpList: '/api/cxy/manager/v2/dlp-slice/officialPrinter/list',
    dlpDelete: '/api/cxy/manager/v2/dlp-slice/officialPrinter/delete',
    dlpAdd: '/api/cxy/manager/v2/dlp-slice/officialPrinter/add'
  },
  // seo
  seoManage: {
    list: '/api/cxy/manager/v2/seo/seoList',
    addAndEditor: '/api/cxy/manager/v2/seo/seoPut',
    seoDelete: '/api/cxy/manager/v2/seo/seoDelete',
    modelClass: '/api/cxy/manager/v2/common/categoryListAll',
    channelClass: '/api/cxy/manager/v2/channel/list'
  },
  memberManage: {
    // 查询会员等级列表
    levelist: '/api/cxy/manager/v2/member/memberSettingsList',
    // 添加会员等级
    leveladd: '/api/cxy/manager/v2/member/memberSettingsCreate',
    // 编辑会员等级
    leveledit: '/api/cxy/manager/v2/member/memberSettingsUpdate',
    // 会员等级关联会员权益
    // levelrelation: '/api/cxy/manager/v2/member/addRelations',
    levelrelation: '/api/cxy/manager/v3/member/addRelations',
    // 会员等级详情
    levelinfo: '/api/cxy/manager/v2/member/memberSettingsDetail',
    // 会员关联商品id
    leveUpdateGoods: '/api/cxy/manager/v2/member/memberSettingsUpdateGoodsId',
    // 云存储空间关联商品id
    cloudUpdateGoods: '/api/cxy/manager/v2/member/spaceSettingsUpdateGoodsId',
    // 会员等级状态
    levelstatus: '/api/cxy/manager/v2/member/memberSettingsUpdateStatus',
    // 会员权益列表
    equityList: '/api/cxy/manager/v2/member/rightsSettingsList',
    // 新增会员权益
    equityAdd: '/api/cxy/manager/v2/member/rightsSettingsCreate',
    // 编辑会员权益
    equityEdit: '/api/cxy/manager/v2/member/rightsSettingsUpdate',
    // 会员权益状态
    equityStatus: '/api/cxy/manager/v2/member/rightsSettingsUpdateStatus',
    // 会员权益详情
    equityInfo: '/api/cxy/manager/v2/member/rightsSettingsDetail',
    // 修改会员权益排序
    equitySort: '/api/cxy/manager/v2/member/rightsSettingsUpdateSort',
    // 会员权益排序
    equityRank: '/api/cxy/manager/v2/member/rightsSettingsUpdateSort',
    // 会员购买记录列表
    orderList: '/api/cxy/manager/v2/member/orderList',
    // 购买记录详情
    orderDetail: '/api/cxy/manager/v2/member/orderDetail',
    // 会员/空间赠送列表
    recordList: '/api/cxy/manager/v2/member/recordList',
    // 会员权益回收
    rightsRetrieve: '/api/cxy/manager/v2/member/rightsRetrieve',
    // 会员权益赠送
    rightsGive: '/api/cxy/manager/v2/member/rightsGive',
    // 购买记录统计
    orderStatistics: '/api/cxy/manager/v2/member/orderStatistics',
    // 会员/云存储空间 收回
    buyRetrieve: '/api/cxy/manager/v2/member/recovery',
    // 新增会员权益分类
    rightsClassPut: '/api/cxy/manager/v2/member/rightsClassPut',
    // 权益分类列表
    rightsClassList: '/api/cxy/manager/v2/member/rightsClassList',
    // 权益分类状态更新
    rightsClassUpdate: '/api/cxy/manager/v2/member/rightsClassUpdate',
    // 同步权益
    syncRightsUpdate: '/api/cxy/manager/v2/member/rightsSync',
    // 试用权益列表
    trialRightsList: '/api/cxy/manager/v2/member/trialRightsList',
    // 试用权益上下架
    upTrialRightsStatus: '/api/cxy/manager/v2/member/upTrialRightsStatus',
    // 试用权益编辑
    upTrialRights: '/api/cxy/manager/v2/member/upTrialRights',
    // 权益推荐
    recommendRights: '/api/cxy/manager/v2/member/rightsSettingsRecommend',
    // 取消权益推荐
    cancleRecommendRights:
      '/api/cxy/manager/v2/member/rightsSettingsUnRecommend',
    // 会员&&空间 订单状态修改为支付成功
    orderReplenishment: '/api/cxy/manager/v2/member/orderStatusUpdate',
    // 权益分类排序修改
    rightsClassUpdateSort: '/api/cxy/manager/v2/member/rightsClassUpdateSort',

    // DTC模块
    // Dtc折扣券码列表
    dtcBundleList: '/api/cxy/manager/v3/dtc/dtcBundleList',
    // Dtc折扣券码查询
    promoCodeList: '/api/cxy/manager/v3/dtc/promoCodeList',
    // Dtc折扣券码编辑
    dtcBundlePut: '/api/cxy/manager/v3/dtc/dtcBundlePut',
    // Dtc折扣券码更新状态
    dtcBundleUp: '/api/cxy/manager/v3/dtc/dtcBundleUp',
    // 券码导入
    promoCodeImport: '/api/cxy/manager/v3/dtc/promoCodeImport',
    // Dtc折扣券码详情
    dtcBundleDetail: '/api/cxy/manager/v3/dtc/dtcBundleDetail',
    // DTC模板列表
    dtcTemplateList: '/api/cxy/manager/v3/dtc/dtcTemplateList'
  },
  // 十佳社团
  topTenClub: {
    // 社团列表
    clubList: '/api/cxy/manager/v2/surprise/ranking',
    // 社团得分设置
    clubScore: '/api/cxy/manager/v2/surprise/setScore',
    // 社团取消资格
    clubRecusal: '/api/cxy/manager/v2/surprise/cancelPut',
    // 发布最佳社团
    pushClub: '/api/cxy/manager/v2/surprise/societyList',
    // pvuv查询
    pvuvInfo: '/api/cxy/manager/v2/surprise/pvuv',
    // 个人列表
    personalList: '/api/cxy/manager/v2/surprise/personalRank',
    // 个人取消资格
    personalRecusal: '/api/cxy/manager/v2/surprise/cancelPut'
  },

  // 礼包管理
  giftBagManage: {
    // 礼包列表
    giftList: '/api/cxy/manager/v2/giftPack/list',
    // 礼包新增
    giftAdd: '/api/cxy/manager/v2/giftPack/add',
    // 礼包编辑
    giftEdit: '/api/cxy/manager/v2/giftPack/update',
    // 礼包结束
    giftOut: '/api/cxy/manager/v2/giftPack/noPass',
    // 礼包添加兑换码
    giftAddCode: '/api/cxy/manager/v2/giftPack/addCodes',
    // 礼包领取数据
    giftReceiveList: '/api/cxy/manager/v2/giftPack/codeList',
    // 礼包领取统计数据
    receiveStaData: '/api/cxy/manager/v2/giftPack/statistics',
    // 礼包详情
    giftDetail: '/api/cxy/manager/v2/giftPack/detail',
    // 礼包回收
    giftRecovery: '/api/cxy/manager/v2/giftPack/recovery',
    // 增加黑名单
    giftAddBlackList: '/api/cxy/manager/v2/giftPack/blacklist/add',
    // 礼包黑名单列表
    giftBlackList: '/api/cxy/manager/v2/giftPack/blacklist/list',
    // 移出礼包黑名单
    giftRemoveBlack: '/api/cxy/manager/v2/giftPack/blacklist/remove'
  },

  // 提现
  withdrawDeposit: {
    // 提现记录列表
    withdrawDepositList: '/api/cxy/manager/v2/withdrawal/list',
    // 提现审核不通过回复
    withdrawDepositReply: '/api/cxy/manager/v2/withdrawal/reply',
    // 认证信息列表
    authenticationInfoList: '/api/cxy/manager/v2/withdrawal/authList',
    // 认证信息审核
    authenticationInfoAudit: '/api/cxy/manager/v2/withdrawal/authAudit',
    // 当月累计提现列表
    accumulativeInfoList: 'accumulativeInfoList',
    // 财务提现记录列表
    withdrawalFinanceList: '/api/cxy/manager/v2/withdrawal/financeList',
    // 财务现金提现记录列表
    cashFinanceList: '/api/cxy/manager/v2/withdrawal/financeListCash',
    // 财务 提现统计
    withdrawalFinanceStatis: '/api/cxy/manager/v2/withdrawal/financeStatis',
    // 下载流水
    listPreWithdrawal: '/api/cxy/manager/v2/coin/listPreWithdrawal',
    // 提现黑名单
    blackListUser: '/api/cxy/manager/v2/coin/listPreWithdrawal',
    // 提现审核-已售模型列表
    wdlModelSoldList: '/api/cxy/manager/v2/coin/wdlModelSoldList',
    // 提现审核-订单明细列表
    wdlModelSoldDetail: '/api/cxy/manager/v2/coin/wdlModelSoldDetail',
    // 提现审核-账号详情
    withdrawalAuditDetail: '/api/cxy/manager/v2/withdrawal/auditDetail',
    // 冻结解冻操作
    frozen: '/api/cxy/manager/v2/withdrawal/frozen',
    // 冻结用户列表
    frozenList: '/api/cxy/manager/v2/withdrawal/frozenList',
    // 现金提现记录
    moneyList: '/api/cxy/manager/v2/withdrawal/listCash',
    // 现金提现统计
    moneyStatistic: '/api/cxy/manager/v2/withdrawal/statisCash',
    // 提现审核（通过/不通过）
    withdrawalAudit: '/api/cxy/manager/v2/withdrawal/audit'
  },
  // 日志管理
  recodeManage: {
    // 设备上报日志记录列表
    logReportList: '/api/cxy/manager/v2/device/user/logReportList',
    // 设备日志文件列表
    logFileList: '/api/cxy/manager/v2/device/user/logFileList',
    // 延时视频管理
    videoList: '/api/cxy/manager/v2/device/user/videoList',
    // 意见反馈列表
    feedbackLog: '/api/cxy/manager/v2/feedback/logList',
    // 日志官方是否已解决
    feedbackIsDeal: '/api/cxy/manager/v2/feedback/isDeal',
    // 转客服工单
    transferWorkOrder: '/api/cxy/manager/v2/feedback/transferWorkOrder',
    // 意见反馈 -》编辑问题类型
    feedbackEditProblem: '/api/cxy/manager/v2/feedback/editProblemType',
    // 日志下载(包含回复)
    feedbackLogDownLoad: '/api/cxy/manager/v2/feedback/download'
  },
  // 邮箱召回
  emailRecall: {
    tmpList: '/api/cxy/manager/v2/user/tmpList',
    tmpCreate: '/api/cxy/manager/v2/user/tmpCreate',
    tmpEdit: '/api/cxy/manager/v2/user/tmpEdit',
    tmpUpdateStatus: '/api/cxy/manager/v2/user/tmpUpdateStatus',
    recallCreate: '/api/cxy/manager/v2/user/recallCreate',
    recallTaskList: '/api/cxy/manager/v2/user/recallTaskList',
    recallUpdateStatus: '/api/cxy/manager/v2/user/recallUpdateStatus',
    recallUserList: '/api/cxy/manager/v2/user/recallUserList',
    recallUserCount: '/api/cxy/manager/v2/user/recallUserCount',
    // 群发邮件任务列表
    bulkEmailList: '/api/cxy/manager/v2/bulkEmail/task/list',
    // 创建邮件群发任务
    createBulkTask: '/api/cxy/manager/v2/bulkEmail/task/create',
    // 更新群发邮件任务状态（可停止/开启
    updateBulkTask: '/api/cxy/manager/v2/bulkEmail/task/status/update',
    // 群发邮件任务详情
    bulkTaskDetails: '/api/cxy/manager/v2/bulkEmail/task/detail',
    // 群发邮件子任务列表
    subTaskList: '/api/cxy/manager/v2/bulkEmail/subTask/list',
    // 邮箱黑名单列表
    unsubscribeList: '/api/cxy/manager/v2/bulkEmail/unsubscribe/list',
    // 邮箱黑名单移除
    unsubscribeRemove: '/api/cxy/manager/v2/bulkEmail/unsubscribe/remove',
    // 标签群组用户数量查询
    layerUserTagGroupCount: '/api/cxy/manager/v2/user/layerUserTagGroupCount'
  },

  // 用户说
  userSaid: {
    list: '/api/cxy/manager/v2/common/userSaysList',
    add: '/api/cxy/manager/v2/common/userSaysAdd',
    edit: '/api/cxy/manager/v2/common/userSaysEdit',
    delete: '/api/cxy/manager/v2/common/userSaysDelete',
    sort: '/api/cxy/manager/v2/common/userUpdateRank'
  },

  // 关于创想云
  aboutCreality: {
    list: '/api/cxy/manager/v2/common/videoList',
    add: '/api/cxy/manager/v2/common/videoAdd',
    edit: '/api/cxy/manager/v2/common/videoEdit',
    delete: '/api/cxy/manager/v2/common/videoDelete',
    sort: '/api/cxy/manager/v2/common/videoUpdateRank'
  },

  // 排行榜
  rankList: {
    modelList: '/api/rest/lottery/ranking/model/list',
    userList: '/api/rest/lottery/ranking/user/list',
    blacklist: '/api/rest/lottery/ranking/blacklist/list',
    // 模型榜发布
    modelRelease: '/api/rest/lottery/ranking/model/release',
    // 用户榜发布
    userRelease: '/api/rest/lottery/ranking/user/release',
    // 排行榜后台发布信息查询
    rankingReleaseList: '/api/rest/lottery/ranking/release/list',
    // 排行榜榜单移除
    rankingStateUpdate: '/api/rest/lottery/ranking/state/update',
    // 排行榜后台黑名单修改
    rankingBlacklistUpdate: '/api/rest/lottery/ranking/blacklist/update',
    // 2023.8.23
    // 排行榜后台榜单周期获取V2
    allPeriod: '/api/rest/lottery/leaderboard/list/allPeriod',
    // 排行榜后台榜单列表V2
    listManage: '/api/rest/lottery/leaderboard/list/rankManage',
    // 排行榜后台用户榜榜单数据V2
    listUser: '/api/rest/lottery/leaderboard/user/list',
    // 排行榜后台模型榜榜单数据V2
    listModel: '/api/rest/lottery/leaderboard/model/list',
    // 排行榜后台榜单规则修改
    updateRule: '/api/rest/lottery/leaderboard/rankRule/updateRule',
    // 排行榜后台黑名单列表V2
    listBlack: '/api/rest/lottery/leaderboard/blacklist/list',
    // 排行榜后台黑名单状态变更
    listBlackUpdate: '/api/rest/lottery/leaderboard/blacklist/update',
    // 排行榜后台榜单规则状态变更V2
    updateStausRule: '/api/rest/lottery/leaderboard/rankRule/updateStatus'
  },
  // 3D照片
  photo3D: {
    // 订单列表
    orderList: '/api/rest/lottery/photo3dOrder/mangerlistPhoto3dOrder',
    // 统计订单数据
    orderTotalNum: '/api/rest/lottery/photo3dOrder/photo3dOrderData',
    // 编辑物流
    editExpress: '/api/rest/lottery/photo3dOrder/editExpress',
    // 查询物流
    trackingInfo: '/api/rest/lottery/photo3dOrder/trackingInfo'
  },
  // 3D照片订单结算
  photo3DSettlement: {
    // 列表
    list: '/api/rest/lottery/photo3dOrder/getCashingList',
    // 汇总
    data: '/api/rest/lottery/photo3dOrder/getCashingListData',
    // 结算
    settle: '/api/rest/lottery/photo3dOrder/settleAccountsOrNot'
  },
  // 建模师入驻 modelerIn
  modelerIn: {
    modelerList: '/api/cxy/manager/v2/modeler/list',
    modelerUpStatus: '/api/cxy/manager/v2/modeler/upStatus',
    modelerUpInfo: '/api/cxy/manager/v2/modeler/upInfo',
    tagList: '/api/cxy/manager/v2/modeler/tagList',
    customTagPut: '/api/cxy/manager/v2/modeler/customTagPut',
    emerging: '/api/cxy/manager/v2/modeler/emerging',
    recommend: '/api/cxy/manager/v2/modeler/recommend',
    upTag: '/api/cxy/manager/v2/modeler/upTag',
    upModelerTag: '/api/cxy/manager/v2/modeler/upModelerTag',
    rewardSettingInfo: '/api/cxy/manager/v2/modeler/rewardSettingInfo',
    editRewardSetting: '/api/cxy/manager/v2/modeler/editRewardSetting',
    modelerVotesList: '/api/cxy/manager/v2/bmy/modelerVotesList',
    voteRecordList: '/api/cxy/manager/v2/bmy/voteRecordList',
    correctVote: '/api/cxy/manager/v2/bmy/correctVote',
    // PK选手分组
    modelerPkList: '/api/cxy/manager/v2/bmy/modelerPkList',
    // 新增PK选手分组
    modelerPkPut: '/api/cxy/manager/v2/bmy/modelerPkPut',
    // PK选手分组排序
    modelerPkUpRank: '/api/cxy/manager/v2/bmy/modelerPkUpRank'
  },
  // 切片参数 -- 耗材管理 API
  sliceConsumable: {
    // 耗材列表
    materialList: '/api/cxy/manager/v2/material/materialList',
    // 耗材新增
    materialCreate: '/api/cxy/manager/v2/material/materialCreate',
    // 耗材编辑
    materialEdit: '/api/cxy/manager/v2/material/materialEdit',
    // 耗材状态更新
    materialUpStatus: '/api/cxy/manager/v2/material/materialUpStatus',
    // 耗材排序
    materialRank: '/api/cxy/manager/v2/material/materialRank',
    // 耗材类型列表
    materialTypeList: '/api/cxy/manager/v2/material/materialTypeList',
    // 耗材类型新增
    materialTypeCreate: '/api/cxy/manager/v2/material/materialTypeCreate',
    // 耗材类型编辑
    materialTypeEdit: '/api/cxy/manager/v2/material/materialTypeEdit',
    // 耗材类型更新状态
    materialTypeUpStatus: '/api/cxy/manager/v2/material/materialTypeUpStatus',
    // 耗材类型更新排序
    materialTypeRank: '/api/cxy/manager/v2/material/materialTypeRank',
    // 耗材品牌列表
    materialBrandList: '/api/cxy/manager/v2/material/materialBrandList',
    // 耗材品牌新增
    materialBrandCreate: '/api/cxy/manager/v2/material/materialBrandCreate',
    // 耗材品牌编辑
    materialBrandEdit: '/api/cxy/manager/v2/material/materialBrandEdit',
    // 耗材品牌更新状态
    materialBrandUpStatus: '/api/cxy/manager/v2/material/materialBrandUpStatus',
    // 耗材品牌更新排序
    materialBrandRank: '/api/cxy/manager/v2/material/materialBrandRank',
    // 切片耗材品牌列表
    brandList: '/api/cxy/manager/v2/slice/material/brandList'
  },
  //  切片参数 --
  sliceParamsManage: {
    sliceAttributes: '/api/cxy/manager/v2/slice-attributes/treeList',
    deleteSliceAttributes: '/api/cxy/manager/v2/slice-attributes/delete',
    editSliceAttributes: '/api/cxy/manager/v2/slice-attributes/edit',
    addSliceAttributes: '/api/cxy/manager/v2/slice-attributes/add',
    detailSliceAttributes: '/api/cxy/manager/v2/slice-attributes/detail',
    listSliceAttributes: '/api/cxy/manager/v2/slice-attributes/list',
    releaseSliceAttributes: '/api/cxy/manager/v2/slice-attributes/release',
    sliceVersionDetail: '/api/cxy/manager/v2/slice-attributes/versionDetail',
    sliceVersionList: '/api/cxy/manager/v2/slice-attributes/versionList',
    sliceVersionExport: '/api/cxy/manager/v2/slice-attributes/versionExport',
    versionCompare: '/api/cxy/manager/v2/slice-attributes/versionCompare',
    syncFromTherEnv: '/api/cxy/manager/v2/slice-attributes/syncFromTherEnv'
  },
  // 切片元数据管理
  sliceBaseManage: {
    // 列表
    list: '/api/cxy/manager/v2/slice/metadata/listver',
    // 复制参数
    copy: '/api/cxy/manager/v2/slice/metadata/copyParam',
    // 新增
    add: '/api/cxy/manager/v2/slice/metadata/submit',
    // 切片元数据管理
    baseDetail: '/api/cxy/manager/v2/slice/metadata/detail',
    // 切片元数据机型继承详情
    inheritDetail: '/api/cxy/manager/v2/slice/metadata/inherit/detail',
    // 同步机型列表
    syncPrinter: '/api/cxy/manager/v2/slice/metadata/inherit/syncPrinter',
    // 机型继承列表
    printerList: '/api/cxy/manager/v2/slice/metadata/inherit/printerList',
    // 更新机器继承参数
    updatePrinterList: '/api/cxy/manager/v2/slice/metadata/inherit/update',
    // 切片参数分类
    keysCategory: '/api/cxy/manager/v2/slice/metadata/keysCategory',
    // 切片元数据状态修改
    updateStatus: '/api/cxy/manager/v2/slice/metadata/updateStatus',
    // ui层级列表
    uiLevelList: '',
    // 切片参数多语言管理
    sliceParamsI18n: '/api/cxy/manager/v2/slice/attributes/list',
    // 多语言编辑
    sliceParamsI18nEdit: '/api/cxy/manager/v2/slice/attributes/edit',
    // 多语言删除
    sliceParamsI18nDelete: '/api/cxy/manager/v2/slice/attributes/delete',
    // 切片元数据设置默认
    setDefaultMetadata: '/api/cxy/manager/v2/slice/metadata/setDefault',
    // 从其他环境导入数据
    async: '/api/cxy/manager/v2/slice/sync/attributes'
  },
  // 耗材管理
  consumableManage: {
    // 耗材列表
    list: '/api/cxy/manager/v2/slice/material/list',
    // 删除耗材
    delete: '/api/cxy/manager/v2/slice/material/delete',
    // 新增耗材
    addConsumable: '/api/cxy/manager/v2/slice/material/create',
    // 编辑耗材
    editConsumable: '/api/cxy/manager/v2/slice/material/edit',
    // 耗材状态修改
    changeConsumableStatus: '/api/cxy/manager/v2/slice/material/editStatus',
    // 耗材品牌
    consumableBrand: '/api/cxy/manager/v2/slice/material/brandList',
    // 耗材类型
    consumableType: '/api/cxy/manager/v2/slice/material/typeList',
    // 机型耗材列表
    materialPrinterList: '/api/cxy/manager/v2/slice/material/printerList',
    // 耗材关联打印机
    materialToPrinter: '/api/cxy/manager/v2/slice/material/relatePrinter',
    // 耗材模板列表
    paramsTempList: '/api/cxy/manager/v2/slice/material/tmplList',
    // 耗材模板更新
    paramsTempAdd: '/api/cxy/manager/v2/slice/material/tmplUpdate',
    // 耗材模板编辑
    paramsTempEdit: '/api/cxy/manager/v2/slice/material/editParams',
    // 机型耗材删除
    printerMaterialDelete: '/api/cxy/manager/v2/slice/material/deletePrinter',
    // 耗材模板删除
    printerMaterialTempDelete: '/api/cxy/manager/v2/slice/material/tmplDelete',
    // 从其他环境导入数据
    asyncMaterial: '/api/cxy/manager/v2/slice/sync/material',
    // 从其他环境导入模板
    asyncMaterialTemp: '/api/cxy/manager/v2/slice/sync/materialTmpl',
    // 打印机关联的耗材
    printerMaterialList:
      '/api/cxy/v2/slice/profile/official/material/printerParameter'
  },
  // 工艺参数管理
  processParamsManage: {
    list: '/api/cxy/manager/v2/slice/process/list',
    // 新增工艺参数
    addParams: '/api/cxy/manager/v2/slice/process/create',
    // 参数模板列表
    paramsTempList: '/api/cxy/manager/v2/slice/process/tmplList',
    // 更新模板
    tempUpdate: '/api/cxy/manager/v2/slice/process/tmplUpdate',
    // 参数更新
    paramsUpdate: '/api/cxy/manager/v2/slice/process/update',
    // 删除
    deleteParams: '/api/cxy/manager/v2/slice/process/delete',
    // 删除模板
    deleteTmplParams: '/api/cxy/manager/v2/slice/process/tmplDelete',
    // 更新默认参数
    updateMeta: '/api/cxy/manager/v2/slice/profile/updateMeta',
    // 从其他环境导入工艺
    asyncProcess: '/api/cxy/manager/v2/slice/sync/process',
    // 从其他环境导入工艺模板
    asyncProcessTemp: '/api/cxy/manager/v2/slice/sync/processTmpl'
  },
  // 机型参数包管理
  printerParamsProfileManage: {
    // 参数包列表
    list: '/api/cxy/manager/v2/slice/profile/list',
    // 新增参数包
    add: '/api/cxy/manager/v2/slice/profile/create',
    // 更新参数包
    update: '/api/cxy/manager/v2/slice/profile/update',
    // 参数包详情
    detail: '/api/cxy/manager/v2/slice/profile/detail',
    // 发布参数(生产压缩包)
    pushParams: '/api/cxy/manager/v2/slice/profile/publish',
    // 更新参数包机型参数
    updatePrinterParam: '/api/cxy/manager/v2/slice/profile/updatePrinterParam',
    // 更新参数包工艺覆盖参数
    updateOverrideParam:
      '/api/cxy/manager/v2/slice/profile/updateOverrideParam',
    // 更新参数包喷嘴参数
    updateExtruderParam:
      '/api/cxy/manager/v2/slice/profile/updateExtruderParam',
    // 更新参数包状态
    updateStatus: '/api/cxy/manager/v2/slice/profile/updateStatus',
    // 更新参数包挤出机覆盖参数
    updateExtruderOverrideParam:
      '/api/cxy/manager/v2/slice/profile/updateExtruderOverrideParam',
    // 参数包版本列表
    verlist: '/api/cxy/manager/v2/slice/profile/verList',
    // 设置默认参数包
    setDefaultVer: '/api/cxy/manager/v2/slice/profile/setDefaultVer',
    // 参数包版本编辑
    editVer: '/api/cxy/manager/v2/slice/profile/editVer',
    // 参数包同步
    asyncProfile: '/api/cxy/manager/v2/slice/sync/profile',
    // 删除参数包
    deleteProfile: '/api/cxy/manager/v2/slice/profile/deleteVer',
    // 参数包上线
    setOnLine: '/api/cxy/manager/v2/slice/profile/setOnLine',
    // 参数包下线
    setOffLine: '/api/cxy/manager/v2/slice/profile/setOffLine'
  },
  // 光固化切片参数相关
  dlpSlice: {
    // 新增层厚
    createLayer: '/api/cxy/manager/v2/dlp-slice/layer/create',
    // 删除层厚
    deleteLayer: '/api/cxy/manager/v2/dlp-slice/layer/delete',
    // 编辑层厚状态
    editStatusLayer: '/api/cxy/manager/v2/dlp-slice/layer/editStatus',
    // 层厚列表
    layerList: '/api/cxy/manager/v2/dlp-slice/layer/list',
    // 耗材列表
    resinList: '/api/cxy/manager/v2/dlp-slice/material/list',
    // 新增耗材
    addResin: '/api/cxy/manager/v2/dlp-slice/material/create',
    // 删除耗材
    deleteResin: '/api/cxy/manager/v2/dlp-slice/material/delete',
    // 耗材机型删除
    deletePrinterResin: '/api/cxy/manager/v2/dlp-slice/material/deletePrinter',
    // 耗材机型详情
    printerMaterialDetail:
      '/api/cxy/manager/v2/dlp-slice/material/printerMaterialDetail',
    // 机型耗材参数编辑
    editPrinterResin: '/api/cxy/manager/v2/dlp-slice/material/editParams',
    // 编辑耗材
    editResin: '/api/cxy/manager/v2/dlp-slice/material/edit',
    // 耗材状态修改
    resinEditStatus: '/api/cxy/manager/v2/dlp-slice/material/editStatus',
    // 机型耗材列表
    printerResinList: '/api/cxy/manager/v2/dlp-slice/material/printerList',
    // 耗材关联机型
    resinRelatePrinter: '/api/cxy/manager/v2/dlp-slice/material/relatePrinter',
    // 耗材品牌列表
    resinBrandList: '/api/cxy/manager/v2/dlp-slice/material/brandList',
    // 获取切片属性树形列表
    dlpSliceAttrTree: '/api/cxy/manager/v2/dlp-slice/attributes/treeList',
    // 编辑切片参数属性
    dlpSliceAttrEdit: '/api/cxy/manager/v2/dlp-slice/attributes/edit',
    // 获取切片属性平铺列表 暂时不用
    // dlpSliceAttrList: '/api/cxy/manager/v2/dlp-slice/attributes/list',
    // 获取切片属性详情
    dlpSliceAttrDetail: '/api/cxy/manager/v2/dlp-slice/attributes/detail',
    // 增加切片参数属性
    dlpSliceAttrAdd: '/api/cxy/manager/v2/dlp-slice/attributes/add',
    // 删除切片参数属性
    dlpSliceAttrDelete: '/api/cxy/manager/v2/dlp-slice/attributes/delete',
    // 机型耗材参数状态编辑
    dlpEditPrinterStatus:
      '/api/cxy/manager/v2/dlp-slice/material/editPrinterStatus',
    // 参数属性同步
    dlpSyncAttributes: '/api/cxy/manager/v2/dlp-slice/sync/attributes',
    // 层厚数据同步
    dlpSyncLayer: '/api/cxy/manager/v2/dlp-slice/sync/layer',
    // 耗材同步
    dlpSyncMaterial: '/api/cxy/manager/v2/dlp-slice/sync/material',
    // 打印机耗材参数同步
    dlpSyncPrinterMaterial: '/api/cxy/manager/v2/dlp-slice/sync/materialPrinter'
  },
  // 三方参数包
  threeParamsProfileManage: {
    list: '/api/cxy/manager/v2/slice/threePorfile/list',
    // 新增三方参数包版本
    addVer: '/api/cxy/manager/v2/slice/threePorfile/addVer',
    // 创建三方参数包
    create: '/api/cxy/manager/v2/slice/threePorfile/create',
    // 删除三方参数包版本
    deleteVer: '/api/cxy/manager/v2/slice/threePorfile/deleteVer',
    // 三方参数包版本编辑
    editVer: '/api/cxy/manager/v2/slice/threePorfile/editVer',
    // 三方参数包版本列表
    listVersion: '/api/cxy/manager/v2/slice/threePorfile/listVersion',
    // 设置默认三方参数包
    setDefaultVer: '/api/cxy/manager/v2/slice/threePorfile/setDefaultVer',
    // 更新三方参数包状态
    updateStatus: '/api/cxy/manager/v2/slice/threePorfile/updateStatus'
  },
  // 邮件订阅
  emialSubscribe: {
    // 列表
    list: '/api/cxy/manager/v2/user/emailSubscribeList',
    // 备注
    remark: '/api/cxy/manager/v2/user/emailSubscribeRemark',
    // 删除
    delete: '/api/cxy/manager/v2/user/emailSubscribeDel'
  },
  // 账单流水
  accountRecord: {
    // 酷维豆列表
    list: '/api/cxy/manager/v2/kwbeans/financeMonthly',
    // 酷维豆统计
    total: '/api/cxy/manager/v2/kwbeans/financeStatis',
    // 创想币列表
    financeList: '/api/cxy/manager/v2/coin/financeList',
    // AI-CubeMe
    cubeMeList: '/api/cxy/manager/v2/powerup/recordList'
  },
  // kol管理
  kolManage: {
    // 列表
    list: '/api/cxy/manager/v2/kol/kolList',
    // 设置收益规则
    setRules: '/api/cxy/manager/v2/kol/kolSetRule',
    // 审核 驳回/通过
    audit: '/api/cxy/manager/v2/kol/kolUpStatus',
    // 更新kol信息
    update: '/api/cxy/manager/v2/kol/kolUpInfo',
    // 结算数据更新
    settleUpdate: '/api/cxy/manager/v2/kol/withdrawUpStatus',
    // 结算列表
    settleList: '/api/cxy/manager/v2/kol/withdrawList',
    // 提现收益统计
    statistics: '/api/cxy/manager/v2/kol/withdrawData',
    // 用户登陆天数详情
    loginDays: '/api/cxy/manager/v2/kol/loginDetail'
  },

  // 勋章管理
  medalManage: {
    // 列表
    list: '/api/cxy/manager/v2/medal/list',
    // 新增
    create: '/api/cxy/manager/v2/medal/create',
    // 编辑
    edit: '/api/cxy/manager/v2/medal/update',
    // 上下架
    operate: '/api/cxy/manager/v2/medal/updateStatus',
    // 删除
    deleteMedal: '/api/cxy/manager/v2/medal/del',
    // 勋章统计列表
    recordList: '/api/cxy/manager/v2/medal/recordList',
    // 发放勋章
    sendMedal: '/api/cxy/manager/v2/medal/send',
    // 回收勋章
    recoveryMedal: '/api/cxy/manager/v2/medal/recovery'
  }
}
export const ACTIVITY_TYPE_ENUM = {
  // 全部
  all: 0,
  // 代理商邀请裂变
  agent: 1,
  // 国赛活动
  games: 2,
  // H5抽奖活动
  lottery: 3,
  // 金砖赛活动
  brics: 4,
  // 高校活动
  colleges: 5,
  // 邀请有礼活动
  invite: 6,
  // 十佳社团活动
  club: 7,
  // 其他
  other: 8,
  // 常规活动
  common: 9
}
export const ACTIVITY_TYPE = [
  {
    label: '代理商邀请裂变',
    value: ACTIVITY_TYPE_ENUM.agent
  },
  {
    label: '国赛活动',
    value: ACTIVITY_TYPE_ENUM.games
  },
  {
    label: 'H5抽奖活动',
    value: ACTIVITY_TYPE_ENUM.lottery
  },
  {
    label: '金砖赛活动',
    value: ACTIVITY_TYPE_ENUM.brics
  },
  {
    label: '高校活动',
    value: ACTIVITY_TYPE_ENUM.colleges
  },
  {
    label: '邀请有礼活动',
    value: ACTIVITY_TYPE_ENUM.invite
  },
  {
    label: '十佳社团活动',
    value: ACTIVITY_TYPE_ENUM.club
  },
  {
    label: '其他',
    value: ACTIVITY_TYPE_ENUM.other
  }
]
export const LABEL_COL = {
  xs: {
    span: 24
  },
  sm: {
    span: 5
  }
}
export const WRAPPER_COL = {
  xs: {
    span: 24
  },
  sm: {
    span: 19
  }
}

// 广告位置枚举
export const BANNER_TYPE = {
  // pc端模型列表
  MODEL_LIST: 1,
  // APP闪屏广告
  APP: 2,
  // paid 模型
  PAID_MODEL: 3,
  // 找模型-推荐
  model_recommend: 4,
  // 趣打印-小课堂
  print_school: 5,
  // 社区头部
  community_banner: 6,
  // 社区右侧
  community_right: 7,
  // 邀请有你
  invite_you: 8,
  // 光固化圈子头部
  lightCircleTop: 9,
  // 光固化圈子右侧
  lightCircleRight: 10,
  // pc端首页banner广告
  homepage_banner: 11,
  // pc端首页 模型集锦聚焦 广告位
  homepage_model_focus: 12,
  // pc端 圈子banner 广告位
  circle_banner: 13,
  // pc端 圈子右侧 广告位
  circle_right: 14,
  // pc端社区推荐
  pc_community_recommend: 15,
  // pc端社区视频
  pc_community_video: 16,
  // pc端社区广场
  pc_community_group: 17,
  // app端社区推荐
  app_community_recommend: 18,
  // app端社区视频
  app_community_video: 19,
  // app端社区广场
  app_community_group: 20,
  // 个人中心
  app_personal_center: 21,
  // 产品大全列表
  productList: 22,
  // 服务中心头部广告图
  service_centre: 23,
  // 打印服务广告
  print_banner: 25,
  // PC小工具主页
  pc_tools: 24,
  // 模型详情页广告
  pc_model_details: 26,
  // web全局顶部广告
  pc_top_ad: 28,
  // 内容/新手指南详情页-右侧区域
  pc_post_detail_right: 29,
  // 标签详情页-右侧区域
  pc_tag_detail_right: 30,
  // 常规活动底部
  pc_active_bottom: 31,
  // web 端建模师合作计划banner
  pc_moderler_plan_ad: 32,
  // APP首页-模型banner
  app_home_model_banner: 33,
  // APP 打印控制台空状态广告
  app_work_banner: 34,
  // web打印控制台空状态广告
  web_work_banner: 35,
  // PC首页播报区域
  pc_home_rolling_news: 36,
  // PC首页产品库
  pc_home_product: 37,
  // PC首页下载中心
  pc_home_download: 38,
  // 新社区首页banner
  pc_2_home_banner: 39,
  // 模型详情页广告（广告添加模块）
  model_detail: 40
}
// 广告位置
export const BANNER_POSITION_LIST = [
  {
    label: '常规活动底部',
    value: BANNER_TYPE.pc_active_bottom,
    size: {
      width: 1200,
      height: 250
    }
  },
  {
    label: '标签详情页-右侧区域',
    value: BANNER_TYPE.pc_tag_detail_right,
    size: {
      width: 380,
      height: 140
    }
  },
  {
    label: '模型详情页文字广告',
    value: BANNER_TYPE.model_detail,
    size: {
      width: 400,
      height: 400
    }
  },
  {
    label: '内容/新手指南详情页-右侧区域',
    value: BANNER_TYPE.pc_post_detail_right,
    size: {
      width: 380,
      height: 140
    }
  },
  {
    label: 'PC 首页banner广告',
    value: BANNER_TYPE.homepage_banner,
    size: {
      width: 1840,
      height: 780
    }
  },
  {
    label: '新社区首页banner',
    value: BANNER_TYPE.pc_2_home_banner,
    size: {
      width: 907,
      height: 454
    }
  },
  {
    label: 'PC 首页播报区域',
    value: BANNER_TYPE.pc_home_rolling_news
  },
  {
    label: 'PC 首页产品库',
    value: BANNER_TYPE.pc_home_product
  },
  {
    label: 'PC 首页下载中心',
    value: BANNER_TYPE.pc_home_download
  },
  {
    label: 'PC 首页模型集锦聚焦',
    value: BANNER_TYPE.homepage_model_focus,
    size: {
      width: 440,
      height: 400
    }
  },
  {
    label: 'PC 模型详情页侧边广告位',
    value: BANNER_TYPE.pc_model_details,
    size: {
      width: 720,
      height: 336
    }
  },
  {
    label: 'PC 模型列表页',
    value: BANNER_TYPE.MODEL_LIST,
    size: {
      width: 2560,
      height: 320
    }
  },
  {
    label: 'App闪屏广告',
    value: BANNER_TYPE.APP,
    size: {
      width: 750,
      height: 1624
    }
  },
  {
    label: 'Pad 模型列表页',
    value: BANNER_TYPE.PAID_MODEL,
    size: {
      width: 980,
      height: 420
    }
  },
  {
    label: '首页-模型推荐列表',
    value: BANNER_TYPE.model_recommend,
    // size: {
    //   width: 360,
    //   height: 482
    // },
    size: {
      width: 343,
      height: 562
    },
    moreSize: [
      {
        width: 540,
        height: 258
      }
    ]
  },
  {
    label: '趣打印-小课堂',
    value: BANNER_TYPE.print_school,
    size: {
      width: 702,
      height: 394
    }
  },
  {
    label: '社区头部广告',
    value: BANNER_TYPE.community_banner,
    size: {
      width: 1920,
      height: 420
    }
  },
  {
    label: '社区右侧广告',
    value: BANNER_TYPE.community_right,
    size: {
      width: 380,
      height: 170
    }
  },
  {
    label: '圈子头部广告',
    value: BANNER_TYPE.circle_banner,
    size: {
      width: 1920,
      height: 420
    }
  },
  {
    label: '圈子右侧广告',
    value: BANNER_TYPE.circle_right,
    size: {
      width: 380,
      height: 170
    }
  },
  {
    label: 'APP弹窗广告',
    value: BANNER_TYPE.invite_you,
    size: {
      width: 885,
      height: 1185
    }
  },
  {
    label: '光固化圈子头部',
    value: BANNER_TYPE.lightCircleTop,
    size: {
      width: 1920,
      height: 420
    }
  },
  {
    label: '光固化圈子右侧',
    value: BANNER_TYPE.lightCircleRight,
    size: {
      width: 380,
      height: 170
    }
  },
  {
    label: 'PC 端社区推荐',
    value: BANNER_TYPE.pc_community_recommend,
    size: {
      width: 702,
      height: 395
    }
  },
  {
    label: 'PC 端社区视频',
    value: BANNER_TYPE.pc_community_video,
    size: {
      width: 702,
      height: 395
    }
  },
  {
    label: 'PC 端社区广场',
    value: BANNER_TYPE.pc_community_group,
    size: {
      width: 702,
      height: 395
    }
  },
  {
    label: 'APP端社区推荐',
    value: BANNER_TYPE.app_community_recommend,
    size: {
      width: 351,
      height: 197
    }
  },
  {
    label: 'APP端社区视频',
    value: BANNER_TYPE.app_community_video,
    size: {
      width: 351,
      height: 197
    }
  },
  {
    label: 'APP端社区广场',
    value: BANNER_TYPE.app_community_group,
    size: {
      width: 351,
      height: 197
    }
  },
  {
    label: 'APP个人中心Banner',
    value: BANNER_TYPE.app_personal_center,
    size: {
      width: 702,
      height: 156
    }
    // moreSize: [
    //   {
    //     width: 360,
    //     height: 172
    //   }
    // ]
  },
  {
    label: '产品中心-banner',
    value: BANNER_TYPE.productList,
    size: {
      width: 2560,
      height: 420
    }
  },
  {
    label: '服务中心头部-banner',
    value: BANNER_TYPE.service_centre,
    size: {
      width: 2560,
      height: 420
    }
  },
  {
    label: '打印服务首页',
    value: BANNER_TYPE.print_banner,
    size: {
      width: 750,
      height: 476
    }
    // moreSize: [
    //   {
    //     width: 360,
    //     height: 172
    //   }
    // ]
  },
  // {
  //   label: '小工具主页-banner',
  //   value: BANNER_TYPE.pc_tools,
  //   size: {
  //     width: 2560,
  //     height: 420
  //   }
  // },
  {
    label: 'PC 顶部广告',
    value: BANNER_TYPE.pc_top_ad,
    size: {
      width: 5120,
      height: 116
    }
  },
  {
    label: 'PC 端建模师合作计划-banner',
    value: BANNER_TYPE.pc_moderler_plan_ad,
    size: {
      width: 1200,
      height: 130
    }
  },
  {
    label: 'APP首页模型banner',
    value: BANNER_TYPE.app_home_model_banner,
    size: {
      width: 702,
      height: 200
    }
  },
  {
    label: 'APP打印控制台空状态广告',
    value: BANNER_TYPE.app_work_banner,
    size: {
      width: 702,
      height: 200
    }
  },
  {
    label: 'Web打印控制台空状态广告',
    value: BANNER_TYPE.web_work_banner,
    size: {
      width: 1240,
      height: 352
    }
  }
]
// 广告状态
export const BANNER_STATUS = {
  // 0全部，1待开始，2进行中，3已结束，4已下架，5已删除
  ALL: 0,
  WAIT: 1,
  GOING: 2,
  END: 3,
  OFF: 4,
  DELETE: 5
}

// 广告营销标签枚举
export const MARKETING_TAG_LIST = [
  { label: '无标签', value: 0 },
  { label: 'New', value: 1 },
  { label: 'Hot', value: 2 },
  { label: 'Sale', value: 3 }
]

// 广告链接类型枚举  这个字段要根据移动端 jump code文档来配置不要轻易加 单方面修改要及时沟通
export const BANNER_URL_TYPE = {
  PAGE_LOGIN: 1, // 登录
  PAGE_IZONE: 2, // 他人主页
  PAGE_H5: 3, // h5
  PAGE_SEARCH: 4, // 搜索
  PAGE_NEW_POST: 5, // 创建帖子
  PAGE_CIRCLE_SEARCH: 10, // 圈子内搜索帖子
  PAGE_CIRCLE_HOME: 11, // 玩社区-圈子
  PAGE_CIRCLE_POST: 12, // 帖子详情
  PAGE_CIRCLE_GROUP: 13, // 圈子详情
  PAGE_MODEL: 14, // 模型详情
  PAGE_SLICE: 15, // 切片详情
  PAGE_HOME_FOLLOW: 16, // 首页关注列表
  PAGE_HOME_REC: 17, // 首页推荐列表
  PAGE_HOME_MODEL: 18, // 找模型-首页
  PAGE_WEBSITE_IN: 19, // web 站内url
  PAGE_WEBSITE_OUT: 20, // web站外 url
  PAGE_CIRCLE_FIND: 21, // 发现圈子
  PAGE_MODEL_LIKE: 22, // 猜你喜欢列表
  PAGE_MODEL_OFFICIAL: 23, // 官方模型列表
  PAGE_MODEL_HOT: 24, // 热门列表
  PAGE_MODEL_TODAY: 25, // 今日推荐
  PAGE_MODEL_EDIT_USER: 27, // 编辑用户资料
  PAGE_MODEL_SIGN_IN: 28, // 用户签到页面
  PAGE_CREATE_MODEL: 29, // 创建模型组
  PAGE_CREATE_PIC: 30, //  创建3d照片
  PAGE_CREATE_CIRCLE: 31, // 创建圈子页面
  PAGE_CIRCLE_Gcode: 32, // 上传Gcode文件页面
  PAGE_MY_PRINTER: 33, // 我的打印详情
  PAGE_MESSAGE_LIST: 34, // 系统消息列表
  PAGE_COMMENT_LIST: 35, // 消息-评论列表
  PAGE_FANS_LIST: 36, // 消息-粉丝列表
  PAGE_GROUP_LIST: 37, // 圈子成员列表
  PAGE_PRINT_ONW: 38, // 一键打印活动
  PAGE_DEVICE_LIST: 39, // 添加设备
  PAGE_WELFARE_MALL: 40, // 福利商城
  PAGE_BALL: 41, // 星球灯
  PAGE_TOOL: 42, // 创意建模
  PAGE_CHANNEL_SCHOOL: 43, // 频道-小课堂
  PAGE_CHANNEL_PLAY: 44, // 频道-玩社区
  PAGE_CONTENT_DOCUMENT: 45, // 内容-发文章
  PATE_PRINT: 46, // 趣打印
  PAGE_CENTER_MODEL: 47, // 我的-模型
  PAGE_MY_GCODE: 48, // 我的切片列表
  PAGE_MY_CONTENT: 49, // 我的内容列表
  PAGE_MY_PRINT_LIST: 50, // 我的打印列表
  PAGE_PRINT_SERVE_INFO: 55, // 打印服务 服务商资料
  PAGE_PRINT_SPECIAL: 64, // 打印服务专区
  PAGE_PRINT_BEAN: 51, // 酷维豆明细
  PAGE_MY_CIRCLE: 54, // 我的圈子
  PAGE_TOOL_LASER: 63, // 激光雕刻
  PAGE_TOOL_ELAPSE: 66, // 流逝影像
  PAGE_IMPORT_MODEL: 67, // 导入模型库
  PAGE_SPECIAL_DETAIL: 68, // 专题详情
  PAGE_MODEL_ALL: 69, // 首页-模型合集
  PAGE_HOME_LIGHT: 70, // 首页-标签模型列表
  PAGE_HOME_ACTIVE: 71, // 首页-精选活动
  PAGE_HOME_MORE: 72, // 首页-更多
  PAGE_CONNECT: 73, // 联系客服
  // 挪车牌
  PAGE_LICENSE_PLATE: 76,
  // 笔筒
  PAGE_PEN_CONTAINER: 77,
  // 会员中心主页
  PAGE_USER_MEMBER: 79,
  // 云存储空间购买页面
  PAGE_PURCHASE_SPACE: 81,
  // 活动
  PAGE_ACTIVITY: 85,
  // 流逝影像列表页
  PAGE_ELAPSE_LIST: 87,
  // 拍照建模
  PAGE_PHOTO_MODEL: 89,
  // 拍照建模列表
  PAGE_PHOTO_MODEL_LIST: 90,
  // 合辑列表
  PAGE_COLLECTION_LIST: 91,
  // 合辑详情
  PAGE_COLLECTION_DETAIL: 92,
  // 推荐用户列表
  PAGE_RECOMMEND_USER: 93,
  // 我的作品
  PAGE_MY_CREATE: 94,
  // 用户排行榜
  PAGE_USER_RANK: 102,
  // 模型排行榜
  PAGE_MODEL_RANK: 103,
  // VIP生日礼包
  BIRTHDAY_GIFT: 104,
  // 绑定邮箱
  BIND_EMAIL: 105,
  // 意见反馈
  FEEDBACK: 100,
  // 应用市场
  APP_STORE: 110,
  // 创想云微信公众号
  WECHAT_CRALITY: 111,
  // 关注创想云抖音号
  WECHAT_TIKTOK: 112,
  // 3d百科文章
  PAGE_BLOG: 113,
  // 订阅Youtube频道
  SUBSCRIBE_YOUTUBE: 114,
  // 订阅TikTok账号
  SUBSCRIBE_TIKTOK: 115,
  // 加入Reddit社群
  SUBSCRIBE_REDDIT: 116,
  // 活动赛事列表页面
  // ACTIVITY_LIST: 117,
  // 成为优质建模师
  DESIGNER_BECOME: 118,
  // 盒子打坏检测详情
  BREAKDOWN_DETECTION: 119,
  // 会员专区模型列表
  VIP_MODEL_LIST: 120,
  // 促销模型列表
  PROMOTION_MODEL_LIST: 121,
  // 模型促销管理
  PROMO_MODEL_MANAGE: 124,
  // 优惠券使用跳转(模型列表)    旧的不要用
  // USE_COUPON_MODEL_LIST_OLD: 127,
  // 购物车  /cart
  SHOP_CART: 128,
  // 优惠券中心跳转   web端没找到页面
  COUPON_PAGE: 129,
  // 权益中心详情  /personal-center/member-center
  USER_COUPON: 130,
  // 导入模型库(活动)  还不知道干啥的
  IMPORT_MODEL_ACTIVITY: 131,
  // 帮助中心详情
  HELP_CENTER: 132,
  // 帮助中心列表
  HELP_LIST: 133,
  // 反馈与帮助
  FEEDBACK_HELP: 134,
  // 优惠券使用跳转(模型列表)
  // USE_COUPON_MODEL_LIST_NEW: 135,
  // 激励广告
  REWARDED_ADV: 136,
  // 打印配置文件列表
  MY_PRINT_CONFIG_LIST: 138,
  // 优惠券类型模型（首页的优惠券列表）
  COUPONS_TYPE_MODEL: 139,
  // 多色模型（首页的多色列表）
  MULTICOLOR_MODEL_LIST: 140,
  // 独家模型
  EXCLUSIVE_MODEL_LIST: 141,
  // 折扣模型
  DISCOUNT_MODEL_LIST: 142,
  // 打印配置模型
  PRINT_SETTINGS_MODEL: 143,
  // 助力券去选模型
  REWARD_VOUCHER: 144,
  // 个人中心助力劵 tab
  BOOST_TICKET: 146,
  // 新社区-App全部模型（仅新版App端使用）
  NEW_APP_ALL_MODEL: 300,
  // 使用makeNow
  USE_MAKENOW: 313,
  // 社区列表独立页面
  COMMUNITY_PAGE: 156,
  // 新手打印教程
  NEW_HAND_PRINT_TUTORIAL: 314
}

// 这个字段要根据移动端 jump code文档来配置不要轻易加 单方面修改要及时沟通
// argument 下的配置不要占用name字段，name字段用于后端处理APP显示的逻辑用了
export const BANNER_URL_LIST = [
  {
    label: '登录页',
    value: BANNER_URL_TYPE.PAGE_LOGIN,
    argument: []
  },
  {
    label: '他人主页',
    value: BANNER_URL_TYPE.PAGE_IZONE,
    argument: [
      {
        label: 'userId',
        value: '',
        descript: '用户id',
        message: '用户id不能为空！',
        type: 'input',
        required: true
      },
      {
        label: 'tab',
        value: 'model',
        descript: '页面tab',
        message: '请选择跳转页面tab',
        type: 'select',
        required: false,
        list: [
          {
            value: 'model',
            label: '模型'
          },
          {
            value: 'post',
            label: '帖子'
          },
          {
            value: 'group',
            label: '圈子'
          }
        ]
      }
    ]
  },
  {
    label: 'web站外链接',
    value: BANNER_URL_TYPE.PAGE_WEBSITE_OUT
  },
  {
    label: 'H5',
    value: BANNER_URL_TYPE.PAGE_H5,
    argument: [
      {
        label: 'url',
        value: '',
        descript: 'url链接',
        type: 'input',
        message: '跳转链接不能为空！',
        required: true
      },
      {
        label: 'newUrl',
        value: '',
        descript: '新平台链接',
        placeholder:
          '同时选择新平台和旧平台显示，新平台和旧平台跳转链接又不一样时填写',
        type: 'input',
        required: false
      },
      {
        label: 'title',
        value: '',
        descript: '标题',
        type: 'input',
        required: false
      }
    ]
  },
  {
    label: '搜索页',
    value: BANNER_URL_TYPE.PAGE_SEARCH,
    argument: [
      {
        label: 'tab',
        value: 'all',
        descript: '页面tab',
        message: '请选择跳转页面tab',
        type: 'select',
        required: false,
        list: [
          {
            value: 'all',
            label: '综合'
          },
          {
            value: 'model',
            label: '模型'
          },
          {
            value: 'post',
            label: '帖子'
          },
          {
            value: 'group',
            label: '圈子'
          },
          {
            value: 'user',
            label: '用户'
          }
        ]
      },
      {
        label: 'keyword',
        value: '',
        descript: '关键字',
        message: '',
        type: 'input',
        required: false
      },
      {
        label: 'targetId',
        value: '',
        descript: '关键字绑定的页面ID',
        message: '',
        type: 'input',
        required: false
      }
    ]
  },
  {
    label: '发布帖子页',
    value: BANNER_URL_TYPE.PAGE_NEW_POST,
    argument: [
      {
        label: 'source',
        value: 1,
        descript: '来源',
        message: '请选择帖子来源',
        type: 'select',
        required: false,
        list: [
          {
            value: 1,
            label: '社区频道'
          },
          {
            value: 2,
            label: '社区圈子'
          },
          {
            value: 3,
            label: '小工具'
          },
          {
            value: 4,
            label: '板块'
          },
          {
            value: 5,
            label: '圈子主页'
          },
          {
            value: 9,
            label: '发布实拍'
          }
        ]
      },
      {
        label: 'id',
        value: '',
        descript: '内容id',
        message: '',
        type: 'input',
        required: false
      },
      {
        label: 'activityId',
        value: '',
        descript: '活动id',
        message: '',
        type: 'input',
        required: false
      },
      {
        label: 'modelId',
        value: '',
        descript: '关联模型id',
        message: '',
        type: 'input',
        required: false
      }
    ]
  },
  // 完全用不上 先注释了
  // {
  //   label: '圈内搜索',
  //   value: BANNER_URL_TYPE.PAGE_CIRCLE_SEARCH,
  //   argument: [
  //     {
  //       label: 'id',
  //       value: '',
  //       descript: '圈子ID',
  //       message: '请输入对应圈子ID',
  //       type: 'input',
  //       required: true
  //     }
  //   ]
  // },
  {
    label: '玩社区-圈子',
    value: BANNER_URL_TYPE.PAGE_CIRCLE_HOME,
    argument: []
  },
  {
    label: '内容详情',
    value: BANNER_URL_TYPE.PAGE_CIRCLE_POST,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '内容ID',
        message: '请输入对应内容ID',
        type: 'input',
        required: true
      },
      {
        label: 'isDelete',
        value: 0,
        descript: '是否删除',
        message: '',
        type: 'select',
        required: false,
        list: [
          {
            value: 1,
            label: '是'
          },
          {
            value: 0,
            label: '否'
          }
        ]
      }
    ]
  },
  {
    label: '圈子详情',
    value: BANNER_URL_TYPE.PAGE_CIRCLE_GROUP,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '圈子ID',
        message: '请输入对应圈子ID',
        type: 'input',
        required: true
      }
    ]
  },
  {
    label: '模型详情',
    value: BANNER_URL_TYPE.PAGE_MODEL,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '模型ID',
        message: '请输入对应模型组ID',
        type: 'input',
        required: true
      },
      {
        label: 'isDelete',
        value: 0,
        descript: '是否删除',
        message: '',
        type: 'select',
        required: false,
        list: [
          {
            value: 1,
            label: '是'
          },
          {
            value: 0,
            label: '否'
          }
        ]
      },
      {
        label: 'isShared',
        value: 0,
        descript: '是否公开',
        message: '',
        type: 'select',
        required: false,
        list: [
          {
            value: 1,
            label: '是'
          },
          {
            value: 0,
            label: '否'
          }
        ]
      }
    ]
  },
  {
    label: '切片详情',
    value: BANNER_URL_TYPE.PAGE_SLICE,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '切片ID',
        message: '请输入对应切片ID',
        type: 'input',
        required: true
      }
    ]
  },
  // {
  //   label: '首页-关注列表',
  //   value: BANNER_URL_TYPE.PAGE_HOME_FOLLOW,
  //   argument: []
  // },
  // {
  //   label: '首页-推荐列表',
  //   value: BANNER_URL_TYPE.PAGE_HOME_REC,
  //   argument: []
  // },
  {
    label: '模型-推荐页',
    value: BANNER_URL_TYPE.PAGE_HOME_MODEL,
    argument: []
  },
  {
    label: '会员专区模型列表',
    value: BANNER_URL_TYPE.VIP_MODEL_LIST,
    argument: []
  },
  {
    label: '促销模型列表',
    value: BANNER_URL_TYPE.PROMOTION_MODEL_LIST,
    argument: []
  },
  {
    label: '发现圈子',
    value: BANNER_URL_TYPE.PAGE_CIRCLE_FIND,
    argument: []
  },
  {
    label: '编辑用户资料',
    value: BANNER_URL_TYPE.PAGE_MODEL_EDIT_USER,
    argument: []
  },
  {
    label: '创建模型组页面',
    value: BANNER_URL_TYPE.PAGE_CREATE_MODEL,
    argument: []
  },
  {
    label: '创建3D照片页面',
    value: BANNER_URL_TYPE.PAGE_CREATE_PIC,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '小工具ID',
        message: '请输入对应小工具ID',
        type: 'input',
        required: true
      }
    ]
  },
  {
    label: '激光雕刻',
    value: BANNER_URL_TYPE.PAGE_TOOL_LASER,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '小工具ID',
        message: '请输入对应服务器小工具ID',
        type: 'input',
        required: true
      }
    ]
  },
  {
    label: '流逝影像详情页',
    value: BANNER_URL_TYPE.PAGE_TOOL_ELAPSE,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '流逝影像ID',
        message: '请输入流逝影像ID',
        type: 'input',
        required: true
      }
    ]
  },
  {
    label: '流逝影像列表页',
    value: BANNER_URL_TYPE.PAGE_ELAPSE_LIST
  },
  {
    label: '创建圈子页面',
    value: BANNER_URL_TYPE.PAGE_CREATE_CIRCLE,
    argument: []
  },
  {
    label: '上传Gcode文件',
    value: BANNER_URL_TYPE.PAGE_CIRCLE_Gcode,
    argument: []
  },
  {
    label: '系统消息列表',
    value: BANNER_URL_TYPE.PAGE_MESSAGE_LIST,
    argument: []
  },
  {
    label: '消息-评论列表',
    value: BANNER_URL_TYPE.PAGE_COMMENT_LIST,
    argument: []
  },
  {
    label: '消息-粉丝列表',
    value: BANNER_URL_TYPE.PAGE_FANS_LIST,
    argument: []
  },
  {
    label: '绑定邮箱',
    value: BANNER_URL_TYPE.BIND_EMAIL,
    argument: []
  },
  {
    label: '圈子成员列表',
    value: BANNER_URL_TYPE.PAGE_GROUP_LIST,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '圈子ID',
        message: '请输入对应圈子ID',
        type: 'input',
        required: true
      }
    ]
  },
  // 没这个活动了
  // {
  //   label: '一键打印活动',
  //   value: BANNER_URL_TYPE.PAGE_PRINT_ONW,
  //   argument: [
  //     {
  //       label: 'deviceName',
  //       value: '',
  //       descript: '设备ID',
  //       message: '请输入对应设备ID',
  //       type: 'input',
  //       required: true
  //     },
  //     {
  //       label: 'gcodeId',
  //       value: '',
  //       descript: '切片ID',
  //       message: '请输入对应切片ID',
  //       type: 'input',
  //       required: true
  //     },
  //     {
  //       label: 'time',
  //       value: '15',
  //       descript: '有效时间',
  //       message: '请输入有效时间',
  //       type: 'input',
  //       required: false
  //     }
  //   ]
  // },
  {
    label: '设备列表页',
    value: BANNER_URL_TYPE.PAGE_DEVICE_LIST,
    argument: []
  },
  {
    label: '福利商城页面',
    value: BANNER_URL_TYPE.PAGE_WELFARE_MALL,
    argument: [
      {
        label: 'tab',
        value: '',
        descript: '商城tab',
        message: '请选择跳转页面tab',
        type: 'select',
        required: false,
        list: [
          {
            value: '1',
            label: '任务Tab'
          },
          {
            value: '2',
            label: '商城Tab'
          }
        ]
      }
    ]
  },
  {
    label: '星球灯',
    value: BANNER_URL_TYPE.PAGE_BALL,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '小工具ID',
        message: '请输入对应服务器小工具ID',
        type: 'input',
        required: true
      }
    ]
  },
  {
    // label: '找模型-小工具',
    label: '首页-创意工具',
    value: BANNER_URL_TYPE.PAGE_TOOL,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '小工具ID',
        message: '请输入对应服务器小工具ID',
        type: 'input',
        required: false
      }
    ]
  },
  {
    label: '玩社区-广场列表',
    value: BANNER_URL_TYPE.PAGE_CHANNEL_PLAY,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '频道ID',
        message: '请输入对应服务器社区的频道ID',
        type: 'input',
        required: false
      }
    ]
  },
  {
    label: '写文章',
    value: BANNER_URL_TYPE.PAGE_CONTENT_DOCUMENT,
    argument: [
      {
        label: 'source',
        value: 1,
        descript: '来源',
        message: '请选择帖子来源',
        type: 'select',
        required: false,
        list: [
          {
            value: 1,
            label: '社区频道'
          },
          {
            value: 2,
            label: '社区圈子'
          },
          {
            value: 3,
            label: '小工具'
          },
          {
            value: 4,
            label: '打印交流(板块)'
          },
          {
            value: 5,
            label: '圈子主页'
          }
        ]
      },
      {
        label: 'id',
        value: '',
        descript: '内容id',
        message: '',
        type: 'input',
        required: false
      },
      {
        label: 'activityId',
        value: '',
        descript: '活动id',
        message: '',
        type: 'input',
        required: false
      }
    ]
  },
  {
    label: '酷维豆明细',
    value: BANNER_URL_TYPE.PAGE_PRINT_BEAN,
    argument: [
      {
        label: 'billType',
        value: 0,
        descript: '明细类型',
        message: '请选择酷维豆明细类型',
        type: 'select',
        required: false,
        list: [
          {
            value: 0,
            label: '全部'
          },
          {
            value: 1,
            label: '任务'
          },
          {
            value: 2,
            label: '兑换商品'
          },
          {
            value: 3,
            label: '活动抽奖'
          },
          {
            value: 4,
            label: '模型付费下载'
          },
          // {
          //   value: 5,
          //   label: '打印服务'
          // },
          {
            value: 6,
            label: '充值'
          },
          {
            value: 7,
            label: '平台发放'
          }
        ]
      },
      {
        label: 'contentType',
        value: 0,
        descript: '账单类型',
        message: '请选择账单类型',
        type: 'select',
        required: false,
        list: [
          {
            value: 0,
            label: '酷维豆账单'
          },
          {
            value: 1,
            label: '创想币账单'
          }
        ]
      }
    ]
  },
  {
    label: '我的圈子',
    value: BANNER_URL_TYPE.PAGE_MY_CIRCLE,
    argument: []
  },
  {
    label: '挪车牌',
    value: BANNER_URL_TYPE.PAGE_LICENSE_PLATE,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '小工具ID',
        message: '请输入对应小工具ID',
        type: 'input',
        required: true
      }
    ]
  },
  {
    label: '笔筒',
    value: BANNER_URL_TYPE.PAGE_PEN_CONTAINER,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '小工具ID',
        message: '请输入对应小工具ID',
        type: 'input',
        required: true
      }
    ]
  },
  {
    label: '我的模型',
    value: BANNER_URL_TYPE.PAGE_CENTER_MODEL,
    argument: [
      {
        label: 'id',
        value: 1,
        descript: '模型列表类型',
        message: '请选择模型列表类型',
        type: 'select',
        required: false,
        list: [
          {
            value: 1,
            label: '我上传的'
          },
          {
            value: 2,
            label: '我收藏的'
          },
          {
            value: 3,
            label: '我下载的'
          },
          {
            value: 4,
            label: '我购买的'
          }
        ]
      }
    ]
  },
  {
    label: '我的切片',
    value: BANNER_URL_TYPE.PAGE_MY_GCODE,
    argument: [
      {
        label: 'id',
        value: 1,
        descript: '切片列表类型',
        message: '请选择切片列表类型',
        type: 'select',
        required: false,
        list: [
          {
            value: 1,
            label: '云切片'
          },
          {
            value: 2,
            label: '我的上传'
          }
        ]
      }
    ]
  },
  {
    label: '我的内容列表',
    value: BANNER_URL_TYPE.PAGE_MY_CONTENT,
    argument: [
      {
        label: 'id',
        value: 1,
        descript: '内容列表类型',
        message: '请选择内容列表类型',
        type: 'select',
        required: false,
        list: [
          {
            value: 1,
            label: '我发布的'
          },
          {
            value: 2,
            label: '我收藏的'
          }
        ]
      }
    ]
  },
  {
    label: '打印历史(我的)',
    value: BANNER_URL_TYPE.PAGE_MY_PRINT_LIST,
    argument: []
  },
  {
    label: '导入模型库',
    value: BANNER_URL_TYPE.PAGE_IMPORT_MODEL,
    argument: [
      {
        label: 'activeId',
        value: '',
        descript: '专题ID',
        message: '请输入对应专题ID',
        type: 'input',
        required: true
      }
    ]
  },
  {
    label: '专题详情',
    value: BANNER_URL_TYPE.PAGE_SPECIAL_DETAIL,
    argument: [
      {
        label: 'id',
        value: '',
        descript: '专题url别名',
        message: '请输入对应专题url别名',
        type: 'input',
        required: true
      }
    ]
  },
  // 和模型库一样 注释了 免得混淆
  // {
  //   label: '首页-模型合集',
  //   value: BANNER_URL_TYPE.PAGE_MODEL_ALL,
  //   argument: []
  // },
  {
    label: '模型标签列表',
    value: BANNER_URL_TYPE.PAGE_HOME_LIGHT,
    argument: [
      {
        label: 'tags',
        value: '',
        descript: '模型标签',
        message: '请输入模型标签，多个标签用英文逗号分割',
        type: 'input',
        required: true
      }
    ]
  },
  {
    label: '首页-精选活动',
    value: BANNER_URL_TYPE.PAGE_HOME_ACTIVE,
    argument: []
  },
  // 没啥用
  // {
  //   label: '首页-更多',
  //   value: BANNER_URL_TYPE.PAGE_HOME_MORE,
  //   argument: []
  // },
  // 打印服务出的 没场景用了
  // {
  //   label: '联系客服',
  //   value: BANNER_URL_TYPE.PAGE_CONNECT,
  //   argument: []
  // },
  {
    label: '云存储空间购买页面',
    value: BANNER_URL_TYPE.PAGE_PURCHASE_SPACE,
    argument: []
  },
  {
    label: '会员中心页面',
    value: BANNER_URL_TYPE.PAGE_USER_MEMBER,
    argument: [
      {
        label: 'level',
        value: '2',
        descript: '会员等级页',
        message: '请选择会员等级页',
        type: 'input',
        required: true
      }
    ]
  },
  {
    label: '合辑列表',
    value: BANNER_URL_TYPE.PAGE_COLLECTION_LIST,
    argument: [
      {
        label: 'userId',
        value: '',
        descript: '用户id',
        message: '请输入用户id',
        type: 'input',
        required: false
      }
    ]
  },
  {
    label: '合辑详情',
    value: BANNER_URL_TYPE.PAGE_COLLECTION_DETAIL,
    argument: [
      {
        label: 'compilationId',
        value: '',
        descript: '合辑id',
        message: '请输入合辑id',
        type: 'input',
        required: true
      }
    ]
  },
  {
    label: '推荐用户列表',
    value: BANNER_URL_TYPE.PAGE_RECOMMEND_USER,
    argument: []
  },
  {
    label: '我的作品',
    value: BANNER_URL_TYPE.PAGE_MY_CREATE,
    argument: [
      {
        label: 'tabId',
        value: '',
        descript: '对应服务器小工具ID,',
        message: '对应服务器小工具ID,',
        type: 'input',
        required: false
      }
    ]
  },
  {
    label: '用户排行榜',
    value: BANNER_URL_TYPE.PAGE_USER_RANK,
    argument: []
  },
  {
    label: '模型排行榜',
    value: BANNER_URL_TYPE.PAGE_MODEL_RANK,
    argument: []
  },
  {
    label: '生日礼包',
    value: BANNER_URL_TYPE.BIRTHDAY_GIFT,
    argument: []
  },
  {
    label: '创想云微信公众号',
    value: BANNER_URL_TYPE.WECHAT_CRALITY,
    argument: []
  },
  {
    label: 'Youtube站外链接',
    value: BANNER_URL_TYPE.SUBSCRIBE_YOUTUBE,
    argument: [
      {
        label: 'url',
        value: '',
        descript: 'Youtube链接',
        type: 'input',
        message: '跳转链接不能为空！',
        required: true
      }
    ]
  },
  {
    label: 'TikTok站外链接',
    value: BANNER_URL_TYPE.SUBSCRIBE_TIKTOK,
    argument: [
      {
        label: 'url',
        value: '',
        descript: 'TikTok链接',
        type: 'input',
        message: '跳转链接不能为空！',
        required: true
      }
    ]
  },
  {
    label: 'Reddit站外链接',
    value: BANNER_URL_TYPE.SUBSCRIBE_REDDIT,
    argument: [
      {
        label: 'url',
        value: '',
        descript: 'Reddit链接',
        type: 'input',
        message: '跳转链接不能为空！',
        required: true
      }
    ]
  },
  {
    label: '创想云抖音号站外链接',
    value: BANNER_URL_TYPE.WECHAT_TIKTOK,
    argument: [
      {
        label: 'url',
        value: '',
        descript: '抖音号站外链接',
        type: 'input',
        message: '跳转链接不能为空！',
        required: true
      }
    ]
  },
  {
    label: '成为优质建模师',
    value: BANNER_URL_TYPE.DESIGNER_BECOME,
    argument: [
      {
        label: 'url',
        value: '',
        descript: 'APP跳转链接',
        type: 'input',
        message: '跳转链接不能为空！',
        required: true
      }
    ]
  },
  {
    label: '3d百科文章详情',
    value: BANNER_URL_TYPE.PAGE_BLOG,
    argument: []
  },
  {
    label: '应用商店',
    value: BANNER_URL_TYPE.APP_STORE,
    argument: []
  },
  // {
  //   label: '活动赛事页面(PC)',
  //   value: BANNER_URL_TYPE.ACTIVITY_LIST,
  //   argument: [
  //     {
  //       label: 'url',
  //       value: '',
  //       descript: 'APP跳转链接',
  //       type: 'input',
  //       message: '跳转链接不能为空！',
  //       required: true
  //     },
  //     {
  //       label: 'title',
  //       value: '',
  //       descript: '标题',
  //       type: 'input',
  //       required: false
  //     }
  //   ]
  // },
  {
    label: '意见反馈',
    value: BANNER_URL_TYPE.FEEDBACK,
    argument: [
      {
        label: 'pageType',
        value: '1',
        descript: '页面类型,',
        message: '页面类型,',
        type: 'select',
        required: false,
        list: [
          {
            value: '1',
            label: 'App反馈'
          }
        ]
      },
      {
        label: 'objType',
        value: '12',
        descript: '来源id,',
        message: '来源id,',
        type: 'select',
        required: false,
        list: [
          {
            value: '12',
            label: '任务跳转-反馈'
          }
        ]
      }
    ]
  },
  {
    label: '模型促销管理(设置促销)',
    value: BANNER_URL_TYPE.PROMO_MODEL_MANAGE,
    argument: []
  },
  {
    label: '购物车',
    value: BANNER_URL_TYPE.SHOP_CART,
    argument: []
  },
  {
    label: '权益中心详情',
    value: BANNER_URL_TYPE.USER_COUPON,
    argument: []
  },
  {
    label: '帮助中心详情',
    value: BANNER_URL_TYPE.HELP_CENTER,
    argument: []
  },
  {
    label: '帮助中心列表',
    value: BANNER_URL_TYPE.HELP_LIST,
    argument: []
  },
  {
    label: '领券中心',
    value: BANNER_URL_TYPE.COUPON_PAGE,
    argument: []
  },
  {
    label: '反馈与帮助',
    value: BANNER_URL_TYPE.FEEDBACK_HELP,
    argument: []
  },
  // {
  //   label: '优惠券使用跳转(模型列表)',
  //   value: BANNER_URL_TYPE.USE_COUPON_MODEL_LIST_NEW,
  //   argument: []
  // },
  {
    label: '激励广告',
    value: BANNER_URL_TYPE.REWARDED_ADV,
    argument: []
  },
  {
    label: '打印配置文件列表',
    value: BANNER_URL_TYPE.MY_PRINT_CONFIG_LIST,
    argument: []
  },
  {
    label: '优惠券类型模型（首页的优惠券列表）',
    value: BANNER_URL_TYPE.COUPONS_TYPE_MODEL,
    argument: []
  },
  {
    label: '多色模型（首页的多色列表）',
    value: BANNER_URL_TYPE.MULTICOLOR_MODEL_LIST,
    argument: []
  },
  {
    label: '独家模型',
    value: BANNER_URL_TYPE.EXCLUSIVE_MODEL_LIST,
    argument: []
  },
  {
    label: '折扣模型',
    value: BANNER_URL_TYPE.DISCOUNT_MODEL_LIST,
    argument: []
  },
  {
    label: '打印配置模型',
    value: BANNER_URL_TYPE.PRINT_SETTINGS_MODEL,
    argument: []
  },
  {
    label: '助力券去选模型',
    value: BANNER_URL_TYPE.REWARD_VOUCHER,
    argument: []
  },
  // {
  //   label: '指定模型浏览',
  //   value: BANNER_URL_TYPE.PAGE_MODEL,
  //   argument: []
  // }
  {
    label: '助力劵列表',
    value: BANNER_URL_TYPE.BOOST_TICKET,
    argument: [
      {
        label: 'tab',
        value: '',
        descript: 'tab页',
        type: 'select',
        required: false,
        list: [
          {
            value: 1,
            label: '未使用'
          },
          {
            value: 2,
            label: '已使用'
          },
          {
            value: 3,
            label: '已过期'
          }
        ]
      }
    ]
  },
  {
    label: '新社区-App全部模型（仅新版App端使用）',
    value: BANNER_URL_TYPE.NEW_APP_ALL_MODEL,
    argument: []
  },
  {
    label: '使用makeNow',
    value: BANNER_URL_TYPE.USE_MAKENOW,
    argument: []
  },
  {
    label: '社区列表',
    value: BANNER_URL_TYPE.COMMUNITY_PAGE,
    argument: []
  }
]
// 举报类型
export const REPORT_CATE_ZH = [
  {
    categoryId: 1,
    categoryName: '恶意攻击谩骂'
  },
  {
    categoryId: 2,
    categoryName: '违法信息'
  },
  {
    categoryId: 3,
    categoryName: '淫秽色情'
  },
  {
    categoryId: 4,
    categoryName: '营销广告'
  },
  {
    categoryId: 5,
    categoryName: '其他'
  }
]

export const COMMENT_TYPE_NAME = {
  // 评论type枚举
  all: 0, // 全部
  model: 1, // 模型评论
  model2: 2, // 模型回复评论
  content: 3, // 帖子评论
  content2: 4, // 帖子回复评论
  // 资讯
  BLOG: 5,
  // 资讯回复
  BLOG_REPLY: 6
}
export const COMMENT_SORCE = {
  // 评论评分枚举
  all: 0, // 全部
  yes: 1, // 已评分
  no: 2 // 未评分
}

/** *随心修模块枚举***/

// 商品状态
export const GOODS_STATUS = [
  {
    key: '上架',
    value: 0
  },
  {
    key: '下架',
    value: 1
  }
]

// 支付方式
export const PAY_TYPE = [
  {
    key: '全部',
    value: ''
  },
  {
    key: '微信支付',
    value: 4
  },
  {
    key: '支付宝支付',
    value: 1
  },
  {
    key: 'Ios内购',
    value: 2
  },
  {
    key: 'paypal',
    value: 3
  },
  {
    key: '经销商邀请裂变',
    value: 5
  }
]

// 订单状态
export const ORDER_STATUS = [
  {
    key: '全部',
    value: ''
  },
  {
    key: '等待支付',
    value: 1
  },
  {
    key: '已支付',
    value: 2
  },
  {
    key: '已关闭',
    value: 3
  },
  {
    key: '已退款',
    value: 4
  }
]

// 端口枚举
export const STATUS_PORT = {
  android: 1,
  iOS: 2,
  wap: 3
}
// 订单来源枚举
export const PRINT_ORDER_STATUS = {
  android: 2,
  iOS: 1,
  wap: 3
}
// 服务商审核状态
export const APPLY_SERVICE_ACTION = {
  PASS: 1,
  NOTPASS: 2
}
// 服务商状态
export const APPLY_SERVICE_STATUS = {
  // 待审核
  WAIT: 1,
  // 已通过
  PASS: 2,
  // 未通过
  NOTPASS: 3,
  // 已完成（已上架）
  SUCCESS: 4,
  // 下架
  DOWN: 5
}
// 打印服务精度
export const ACCURACY_STATUS = {
  STANDARD: 1,
  HEIGHT: 2,
  INDUSTRYT: 3
}
export const ACCURACY_STATUS_ARR = [
  {
    key: '高精度',
    value: 1
  },
  {
    key: '正常',
    value: 2
  },
  {
    key: '快速',
    value: 3
  }
]
// 打印服耗材颜色价格状态
export const COLOR_PRICE_STATUS = {
  UP: 1,
  DOWN: 2
}
// 耗材分类
export const CLASSLITY_LIST = [
  {
    value: 1,
    label: 'PLA'
  },
  {
    value: 2,
    label: 'ABS'
  },
  {
    value: 3,
    label: '树脂'
  },
  {
    value: 4,
    label: '尼龙'
  },
  {
    value: 5,
    label: '金属'
  },
  {
    value: 6,
    label: '橡胶'
  },
  {
    value: 7,
    label: '蜡'
  },
  {
    value: 8,
    label: 'TPU'
  },
  {
    value: 9,
    label: 'PETG'
  },
  {
    value: 10,
    label: '其他'
  }
]
// seo页面枚举
export const SEO_PAGE = [
  {
    value: 1,
    label: '首页'
  },
  {
    value: 2,
    label: '个人中心'
  },
  {
    value: 3,
    label: '圈子'
  },
  // {
  //   value: 4,
  //   label: '模型',
  //   hideSelect: true,
  //   children: [
  //     {
  //       value: 4,
  //       label: '推荐'
  //     },
  //     {
  //       value: 5,
  //       label: '光固化'
  //     }
  //   ]
  // },
  {
    value: 6,
    label: '特色专题',
    url: '/model-collections'
  },
  // {
  //   value: 7,
  //   label: '社区频道-推荐',
  //   hideSelect: true,
  //   children: [
  //     {
  //       value: 7,
  //       label: '推荐'
  //     }
  //   ]
  // },
  {
    value: 8,
    label: '活动赛事',
    url: '/activity-list'
  },
  {
    value: 9,
    label: 'download页面',
    url: '/download'
  },
  {
    value: 10,
    label: '发现圈子',
    url: '/discover-group'
  },
  {
    value: 11,
    label: '领取礼包',
    url: '/gift-package'
  },
  {
    value: 12,
    label: '新手指南',
    url: '/guide'
  },
  {
    value: 13,
    label: '帮助中心',
    url: '/help-center'
  },
  {
    value: 14,
    label: '产品中心'
  },
  {
    value: 15,
    label: '服务中心'
  },
  {
    value: 16,
    label: '下载中心'
  },
  {
    value: 17,
    label: '个人中心-建模师创作者合作计划',
    url: '/user/designer/plan'
  },
  {
    value: 18,
    label: '打印服务',
    url: '/printing-service'
  },
  {
    value: 19,
    label: '3D百科全部分类'
  },
  {
    value: 20,
    label: '3D照片创建',
    url: '/3d-photo'
  },
  {
    value: 21,
    label: '3D照片预览',
    url: '/3d-photo/view-photo'
  },
  {
    value: 22,
    label: '3D照片创建成功',
    url: '/3d-photo/created-success?id=0&categoryId=0'
  },
  {
    value: 23,
    label: '创意工具',
    url: '/makers-tools'
  },
  {
    value: 24,
    label: '提现账户管理',
    url: '/account-manage'
  },
  {
    value: 25,
    label: '社区-推荐',
    url: '/channel-category/foryou'
  },
  {
    value: 26,
    label: '社区-视频',
    url: '/channel-category/video'
  },
  {
    value: 27,
    label: '社区-广场',
    url: '/channel-category/community'
  },
  {
    value: 28,
    label: '社区-圈子',
    url: '/channel-category/group'
  },
  {
    value: 29,
    label: '写文章',
    url: '/create-content'
  },
  {
    value: 30,
    label: '写文章预览',
    url: '/prev-content/preview-content?type=detail'
  },
  {
    value: 31,
    label: '发帖',
    url: '/create-post'
  },
  {
    value: 32,
    label: '发帖预览',
    url: ''
  },
  {
    value: 33,
    label: '创建圈子',
    url: '/create-group'
  },
  {
    value: 34,
    label: '创建模型组',
    url: '/create-model'
  },
  {
    value: 35,
    label: '编辑个人信息',
    url: ''
  },
  {
    value: 36,
    label: '福利商城',
    url: '/gift-shop?type=task'
  },
  {
    value: 37,
    label: '新手指南搜索页面',
    url: '/guide/search?keyword=2'
  },
  {
    value: 38,
    label: '帮助中心搜索用户',
    url: '/help-center/search?keyword=2'
  },
  {
    value: 39,
    label: '不支持浏览器引导',
    url: '/ie-page'
  },
  {
    value: 40,
    label: '模型互导',
    url: '/import-creality'
  },
  {
    value: 41,
    label: 'T站导入',
    url: '/import-thingiverse'
  },
  {
    value: 42,
    label: '排行榜',
    url: '/leaderboard'
  },
  {
    value: 43,
    label: '我的活动',
    url: '/my-activity'
  },
  {
    value: 44,
    label: '我的账单-创想币',
    url: '/my-bill/credits'
  },
  {
    value: 45,
    label: '我的账单-酷维豆',
    url: '/my-bill/cuvacoin'
  },
  {
    value: 46,
    label: '我的意见反馈',
    url: '/my-feedback'
  },
  {
    value: 47,
    label: '意见反馈详情',
    url: '/my-feedback/details?id=638d8d89584e8a1e6a56cb90'
  },
  {
    value: 48,
    label: '我的订单',
    url: '/my-order'
  },
  {
    value: 49,
    label: '我的打印',
    url: '/my-print'
  },
  {
    value: 50,
    label: '我的打印-创建任务',
    url: '/my-print/create-task'
  },
  {
    value: 51,
    label: '订单详情',
    url: '/order-detail/6322dfa8e3824a3c673f28d4'
  },
  {
    value: 52,
    label: '支付',
    url: '/payment/110122120517044415240270'
  },
  {
    value: 53,
    label: '帮助中心(针对购买会员)',
    url: '/personal-center/help-center'
  },
  {
    value: 54,
    label: '会员中心(购买会员)',
    url: '/personal-center/member-center'
  },
  {
    value: 55,
    label: '购买空间',
    url: '/personal-center/payment'
  },
  {
    value: 56,
    label: '打印界面',
    url: ''
  },
  {
    value: 57,
    label: '固件升级',
    url: '/print-manage/firmware-upgrade'
  },
  {
    value: 58,
    label: '打印报告',
    url: '/print-report'
  },
  {
    value: 59,
    label: '打印服务-商家报价',
    url: '/printing-service/comparisons'
  },
  {
    value: 60,
    label: '打印服务-创建订单',
    url: '/printing-service/create-order'
  },
  {
    value: 61,
    label: '打印服务-订单评价详情',
    url: ''
  },
  {
    value: 62,
    label: '打印服务-订单评价成功',
    url: '/printing-service/evaluate-success'
  },
  {
    value: 63,
    label: '打印服务-服务商主页',
    url: '/printing-service/merchant-home/1695033658'
  },
  {
    value: 64,
    label: '打印服务-服务商列表',
    url: '/printing-service/merchant-list'
  },
  {
    value: 65,
    label: '打印服务-商家报价方案',
    url: ''
  },
  {
    value: 66,
    label: '打印服务-商家报价方案详情',
    url: ''
  },
  {
    value: 67,
    label: '打印服务-订单详情',
    url: ''
  },
  {
    value: 68,
    label: '打印服务-订单评价',
    url: '/printing-service/order-evaluate'
  },
  {
    value: 69,
    label: '打印服务-订单提交成功',
    url: '/printing-service/order-success'
  },
  {
    value: 70,
    label: '打印服务-订单支付成功',
    url: '/printing-service/pay-success?orderId=1212121'
  },
  {
    value: 71,
    label: '打印服务-已选择的模型',
    url: '/printing-service/select-model'
  },
  {
    value: 72,
    label: '打印服务-填写服务商认证资料',
    url: '/printing-service/select-model'
  },
  {
    value: 73,
    label: '产品中心-机型对比',
    url:
      '/product/compare?id1=61766d90855e10608bc18635&id2=61528a66b6566902c447a36f'
  },
  {
    value: 74,
    label: '搜索',
    url: '/search-content?q=121'
  },
  {
    value: 75,
    label: '切片',
    url:
      '/slice-settings/6237e8e32e6a626b04992d47?categoryId=204&modelStatus=singel&modelGroupId=6237e8e32e6a626b04992d45'
  },
  {
    value: 76,
    label: '下载中心-搜索',
    url: '/software-firmware/search?name=12'
  },
  {
    value: 77,
    label: '模型导入状态(T站导入创想云)',
    url: '/thingiverse'
  },
  {
    value: 78,
    label: 'T站导入历史记录',
    url: '/thingiverse-history'
  },
  {
    value: 79,
    label: 'T站模型列表',
    url: '/thingiverse-list'
  },
  {
    value: 80,
    label: '用户充值(购买创想币)',
    url: '/top-up'
  },
  {
    value: 81,
    label: '上传切片',
    url: '/upload-gcode'
  },
  {
    value: 82,
    label: '个人中心-建模师申请入口',
    url: '/user/designer/apply'
  },
  {
    value: 83,
    label: '会员权益详情',
    url: '/user/equity'
  },
  {
    value: 84,
    label: '账号设置',
    url: '/user-data/6489569226'
  },
  {
    value: 85,
    label: '提现',
    url: '/withdrawal'
  },
  {
    value: 86,
    label: '提现进度',
    url: '/withdrawal-progress'
  },
  {
    value: 87,
    label: '提现记录',
    url: '/withdrawal-record'
  },
  {
    value: 88,
    label: '提交提现',
    url: '/withdrawal-submit'
  },
  {
    value: 89,
    label: '关于我们',
    url: '/policy?type=about'
  },
  {
    value: 90,
    label: '用户协议',
    url: '/policy?type=protocol'
  },
  {
    value: 91,
    label: '隐私政策',
    url: '/policy?type=policy'
  },
  {
    value: 92,
    label: '版权声明',
    url: '/policy?type=copyright'
  },
  {
    value: 93,
    label: '下载中心-软件',
    url: '/software-firmware/software'
  },
  {
    value: 94,
    label: '下载中心-开源插件',
    url: '/software-firmware/plugins'
  },
  {
    value: 95,
    label: '下载中心-固件',
    url: '/software-firmware/firmware'
  },
  {
    value: 96,
    label: '下载中心-创想云终端固件',
    url: '/software-firmware/box'
  },
  {
    value: 97,
    label: '下载中心-其他',
    url: '/software-firmware/other'
  },
  {
    value: 98,
    label: '建模师专区',
    url: '/designer-space'
  },
  {
    value: 100,
    label: '编辑模型'
  }
]
// 快递公司
export const EXPRESS_LIST = [
  {
    name: '韵达快递',
    id: 1
  },
  {
    name: '圆通速递',
    id: 2
  },
  {
    name: '中通快递',
    id: 3
  },
  {
    name: '邮政快递包裹',
    id: 4
  },
  {
    name: '百世快递',
    id: 5
  },
  {
    name: '申通快递',
    id: 6
  },
  {
    name: '顺丰速运',
    id: 7
  },
  {
    name: '京东物流',
    id: 8
  },
  {
    name: 'EMS',
    id: 9
  },
  {
    name: '邮政标准快递',
    id: 10
  },
  {
    name: '优速快递',
    id: 11
  },
  {
    name: '德邦快递',
    id: 12
  },
  {
    name: '龙邦速递',
    id: 13
  },
  {
    name: '天天快递',
    id: 14
  },
  {
    name: '联邦快递',
    id: 15
  },
  {
    name: '苏宁物流',
    id: 16
  },
  {
    name: '极兔速递',
    id: 17
  },
  {
    name: '丹鸟',
    id: 18
  },
  {
    name: '极速达物流',
    id: 19
  },
  {
    name: '丰网速运',
    id: 20
  },
  {
    name: '宅急送',
    id: 21
  }
]
// 订单取消原因（用户）
export const cancel_reason_user = [
  {
    id: 1,
    name: '价格太高'
  },
  {
    id: 2,
    name: '想更换服务商'
  },
  {
    id: 3,
    name: '不想打印模型了'
  },
  {
    id: 4,
    name: '服务商长时间未确认订单'
  },
  {
    id: 5,
    name: '与其他平台或线下店比价'
  },
  {
    id: 6,
    name: '服务商让我取消订单'
  },
  {
    id: 7,
    name: '服务商让我到其他平台下单'
  },
  {
    id: 8,
    name: '打印模型/规格选择错误'
  },
  {
    id: 9,
    name: '地址/手机号填写错误'
  },
  {
    id: 10,
    name: '服务商服务态度差'
  },
  {
    id: 11,
    name: '功能尝鲜'
  },
  {
    id: 1001,
    name: '其他'
  }
]
// 订单取消身份
export const cancel_reason_role = {
  // 用户
  user: 1,
  // 服务商
  service: 2
}

// 订单取消原因（服务商）
export const cancel_reason_service = [
  {
    id: 1,
    name: '耗材不足，无法完成打印'
  },
  {
    id: 2,
    name: '模型有问题'
  },
  {
    id: 3,
    name: '无法满足打印需求'
  },
  {
    id: 4,
    name: '打印设备故障'
  },
  {
    id: 5,
    name: '暂无空闲打印设备'
  },
  {
    id: 1001,
    name: '其他'
  },
  {
    id: 2100555,
    name: '买家因超过24小时未支付订单，订单已自动取消'
  },
  {
    id: 2100556,
    name: ' 服务商因超过48小时未确认订单，订单已自动取消'
  }
]

// 会员等级枚举
export const member_level_list = [
  {
    id: 1,
    name: '1级(普通会员)'
  },
  {
    id: 2,
    name: '2级'
  },
  {
    id: 3,
    name: '3级'
  },
  {
    id: 4,
    name: '4级'
  },
  {
    id: 5,
    name: '5级'
  }
]

// 操作记录对应模板
export const RECORD_ID = [
  {
    id: 1,
    name: '账号'
  },
  {
    id: 2,
    name: '圈子'
  },
  {
    id: 3,
    name: '内容管理'
  },
  {
    id: 4,
    name: '模型管理'
  },
  {
    id: 5,
    name: '公告'
  },
  {
    id: 6,
    name: '活动'
  },
  {
    id: 7,
    name: '内容置顶'
  },
  {
    id: 8,
    name: '账号删除'
  },
  {
    id: 9,
    name: '标签'
  },
  {
    id: 10,
    name: '用户会员'
  },
  {
    id: 11,
    name: '评论管理'
  },
  {
    id: 12,
    name: '打印机管理'
  },
  {
    id: 13,
    name: '软固件管理'
  }
]

// 外链状态
export const OUTER_STATUS = {
  // 用户
  PASS: 2,
  // 服务商
  NO_PASS: 3
}
